// leaflet 
import "leaflet/dist/leaflet.css";
import L, { map } from "leaflet";
import * as turf from '@turf/turf';
import * as THREE from "three";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { v4 as uuid } from "uuid"
import "leaflet-side-by-side";
import {
  getArea,
  getDistance,
  get3dPolygonArea,
  getDistanceIn3d,
  addEditControl,
  layerAddedEvent,
  layerRemovedEvent,
  editEnableEvent,
  editDisableEvent,
  drawMeasurements,
  hideMeasurements,
  drawingEndEvent,
  existingMeasurementUpdatedEvent,
  toggleMeasurementLabels,
  removeExistingMeasurementTooltips,
  addMeasurementTooltips,
  toggleMeasurementTooltips
} from "../../ReusableComponents/map/leafletMeasure.js"
//leaflet
import Help from "../../sidebaricon/Help.png";
import React, { Component, useEffect } from "react";
import { addProjectDetails } from "../../redux";
import { addPlan } from "../../redux";
import { BreadCrumbs } from "../../ReusableComponents/BreadCrumbs"
import * as API from "../../api.js";
import planActive from "../../assets/sideBarIcons/Plan.png"
import orthoInactive from "../../assets/sideBarIcons/OrthoInative.png"
import fail from '../../assets/error.png';
import ReactTooltip from 'react-tooltip'
import mapDetailsInactive from "../../assets/toolbarIcons/mapDetailsInactive.png"
import mapDetailsActive from "../../assets/toolbarIcons/mapDetails.png"
import imagesInactive from "../../assets/sideBarIcons/ImagesInactive.png"
import { SelectComponent } from '../../ReusableComponents/SelectComponent'
import AeroMeghLogo from "../../aeromeghLog.png";
import DeleteIcon from '../../assets/toolbarIcons/Delete.png';
import Menu from "../../icons/MenuDark.png"
import saveIcon from '../../assets/toolbarIcons/save.png';
import dateFormat from 'dateformat'
import Loader from '../../icons/loader.svg';
import { Modal } from "react-bootstrap";
import circleLeft from '../../icons/prev.png';
import circleRight from '../../icons/next.png';
import Prev from '../../icons/back1.png';
import Next from '../../icons/next1.png';
import projectInactive from '../../assets/sideBarIcons/ProjectInactive.png';
import service from "../../sidebaricon/Services.png";
import dashboardIcon from '../../assets/sideBarIcons/dashboard.png';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connect } from "react-redux";
import { Link, StaticRouter, Redirect } from "react-router-dom";
import waiting from '../../res/waiting.png';
import Geocode from "react-geocode";
import Popup from "reactjs-popup";
import closeButton from '../../close-button.png';
import { Popup as CustomPopup } from "../../ReusableComponents/reusableFunctions";
//toolbar icons 
import compareInactiveIcon from '../../assets/toolbarIcons/compareInactive.png'
import inspectIcon from '../../assets/toolbarIcons/inspect.png'
import inspectInactiveIcon from '../../assets/toolbarIcons/inspectInactive.png'
import RGBIcon from '../../assets/toolbarIcons/RGB.png'
import RGBInactiveIcon from '../../assets/toolbarIcons/RGBInactive.png'
import NDVIIcon from '../../assets/toolbarIcons/NDVI.png'
import NDVIInactiveIcon from '../../assets/toolbarIcons/NDVIInactive.png'
import CopyIcon from '../../icons/copy.png'
import reportIcon from '../../assets/toolbarIcons/report.png'
import shapeFileIcon from '../../assets/toolbarIcons/ShapeFileIcon.png'
import dxfFileIcon from '../../assets/toolbarIcons/CADFileIcon.png'
import kmlFileIcon from '../../assets/toolbarIcons/KMLFileIcon.png';
import reportActiveIcon from '../../assets/toolbarIcons/reportActive.png'
import ThreeDIcon from '../../assets/toolbarIcons/ThreeD.png'
import ThreeDInactiveIcon from '../../assets/toolbarIcons/ThreeDInactive.png'
import DEMIconInactive from '../../assets/toolbarIcons/DEMInactive.png'
import DEMInactive from '../../assets/toolbarIcons/DSMInactive.png'
import DTMIconInactive from '../../assets/toolbarIcons/DTMInactive.png'
import DEMIcon from '../../assets/toolbarIcons/DEM.png'

// import Delete from "../../delete.svg"
import Map from "./subComponents/Map";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Histogram from "./subComponents/Histogram.jsx";
import { Select, FormControl, withStyles, InputBase, MenuItem } from '@material-ui/core';
import { ActivityPopup } from '../../ReusableComponents/ActivityPopup.js';
import trackingIcon from '../../assets/tracking_black.png'
import Tiff from 'tiff.js'
import closeBtn from '../../assets/toolbarIcons/closeButton.png'
import MarkerIcon from '../../assets/marker.png'
import selectedMarker from '../../assets/selectedMarker.png'
import validator from 'validator'
import lineActive from '../../assets/toolbarIcons/lineActive.png'
import lineInactive from '../../assets/toolbarIcons/lineInactive.png'
import showLayers from '../../assets/toolbarIcons/layersActive.png'
import hideLayers from '../../assets/toolbarIcons/layersInactive.png'
import polygonActive from '../../assets/toolbarIcons/polygonActive.png'
import polygonInactive from '../../assets/toolbarIcons/polygonInactive.png'
import markerActive from '../../assets/toolbarIcons/markerActive.png'
import markerInactive from '../../assets/toolbarIcons/marker.png'
import pointerActive from '../../assets/toolbarIcons/pointerActive.png'
import pointerInactive from '../../assets/toolbarIcons/pointerInactive.png'
import roadMapView from '../../assets/Images/roadMapViewzz.png'
import sateliteView from '../../assets/Images/sateliteView.png'
import tickIcon from '../../icons/tick.png'
import { AnimatedModal } from '../../ReusableComponents/AnimatedModal'
import { SketchPicker } from 'react-color';
import threeDIcon from '../../assets/sideBarIcons/3DIcon.png'
import measurementReportIcon from '../../assets/sideBarIcons/measurementReport.png'
import shareInviteMailIcon from '../../assets/shareInviteMailIcon.png'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { checkURLExist, addUserAnalytic, updateOutTime, importShapeFile, getRandomHexColour, triggerBlobDownload, getSingleGeoJSON, getUniqueCollectionName, extractMessageAfterMention } from "../../ReusableComponents/reusableFunctions";
import YieldAnalysis from "./subComponents/YieldAnalysis";
import LineStatistics from "./subComponents/LineStatistics";
import ElevationProfile from "./subComponents/ElevationProfile";
import PlantHealthIndexLayer from "./subComponents/PlantHealthIndexLayer";
import PotreeViewer from "./Threed/PotreeViewer";
import ButtonWithIcon from "../../ReusableComponents/ButtonWithIcon";
import { ActiveRole, DRONENAKSHA_FEATURES, GCS_FEATURES, getActiveTeamActiveMembers, getFeaturesPermissions } from "../../Teams";
import DownloadAssetCard from "../../ReusableComponents/DownloadAssetCard";
import compareInactiveIcon2 from "../../assets/toolbarIcons/compareInactive.png";
import { MentionsInput, Mention } from 'react-mentions';
import AppConstants, { ASSETS, BLOB_URL, EXTENDBOUNDS, MAP_URLS, SOCKET_IO_MESSAGES, tilesServer } from "../../AppConstants";
import SaveShapeFile from "../../ReusableComponents/SaveShapeFile";
import 'leaflet.markercluster';
import LocationSelector from "../../ReusableComponents/LocationSelector";
import FloorSelector from "./FloorSelector";
import FloorComponent from "./FloorComponent";
import FloorImagesViewer from "./FloorImagesViewer";
import FloorAdder from "./FloorAdder";
import Layers from "./Layers";
import { Maximize } from "../../helperComponents/Helpers";
import Tip from "../../ReusableComponents/Tip";
import AddIcon from '../../icons/addBlue.png';
import BoxAnnotationIconInactive from "../../assets/Icons/boxToolInactive.png"
import BoxAnnotationIconActive from "../../assets/Icons/boxToolActive.png"
import FloorsActive from "../../assets/Icons/FloorsActive1.png"
import FloorsInactive from "../../assets/Icons/FloorsInactive1.png"
import PointInfoIcon from '../../assets/Icons/point_info.png'
import VolumeBoxIcon from '../../assets/Icons/VolumeBoxIcon.png'
import VolumeBoxIconActive from '../../assets/Icons/VolumeBoxIconActive.png'
import PointInfoIconActive from '../../assets/Icons/point_infoActive.png'
import menuIcon from "../../assets/Icons/menu.png";
import elevation from '../../assets/Icons/elevation.png'
import redFlag from "../../assets/Icons/redFlag.png";
import transClose from "../assets/icons/Close.svg"
import { EVENTS, ThreeJsDrawing } from "./FloorImagesViewer/threeJsDrawing";
import { setThreeJsData } from "./FloorImagesViewer/mouseEvents.js";
import DrawingToolbar from "./DrawingToolbar.js";
import EntitySelector from "../../ReusableComponents/EntitySelector.js";
import { exportPolygonTiff } from "../../ReusableComponents/map/gisFunctions.js";
import { connectToSocketIOGroup } from "../SocketIo/index.js";
import Tippy from "@tippyjs/react";
import TopBar from "../../TopBar.js";


const BOX = "Box"
const POLYGON = "Polygon"
const MULITPOLYGON = "MultiPolygon"
const POLYLINE = "Polyline"
const MARKER = "Marker"
const POINT = "Point"
const LINESTRING = "LineString"
const MULTILINESTRING = "MultiLineString"
const GEOMETRYCOLLECTION = "GeometryCollection"
var utmObj = require('utm-latlng');
var utm = new utmObj();

const ZOOM_EXTRA_LEVELS = 6
const potreeViwerSERVER = `${process.env.REACT_APP_CLIENT_PROTOCOL}://${process.env.REACT_APP_CLIENT_HOST}/3dviewer/index.html`

Geocode.setApiKey("AIzaSyBuxfUtRZSEUT2QrbZA8zUsG58lZUYYmwI");

// set response language. Defaults to english.
Geocode.setLanguage("en");
const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: "12px",
    width: '85px',
    color: "#3c3c3c",
    height: "15px",
    padding: '5px 26px 5px 10px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

const MenuProps = {
  PaperProps: {
    style: {
      top: 265,
      bottom: 100,
    },
  },
};

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    <img src={menuIcon} alt="I am alt" />
  </a>
));


let imageMapType;
let imageMapType1;
const NotSelected = "Not Selected"
const PlantHealthAnalysis = "Plant Health"
const OrthomosaicAnalysis = "Image Analysis"
const activeSidebarMeasurement = "Measurements"
const elevationAnalysis = "Elevation Analysis"
const activeSidebarDownloadAssets = "Download Assets"
const activeSidebarMapDetails = "Map Details"
const activeSidebarLayers = "Layers"
let colorsMap = [
  [165, 0, 38, 255],
  [166, 1, 38, 255],
  [168, 3, 38, 255],
  [170, 5, 38, 255],
  [172, 7, 38, 255],
  [174, 9, 38, 255],
  [176, 11, 38, 255],
  [178, 13, 38, 255],
  [180, 15, 38, 255],
  [182, 16, 38, 255],
  [184, 18, 38, 255],
  [186, 20, 38, 255],
  [188, 22, 38, 255],
  [190, 24, 38, 255],
  [192, 26, 38, 255],
  [194, 28, 38, 255],
  [196, 30, 38, 255],
  [198, 32, 38, 255],
  [200, 33, 38, 255],
  [202, 35, 38, 255],
  [204, 37, 38, 255],
  [206, 39, 38, 255],
  [208, 41, 38, 255],
  [210, 43, 38, 255],
  [212, 45, 38, 255],
  [214, 47, 38, 255],
  [215, 49, 39, 255],
  [216, 51, 40, 255],
  [217, 53, 41, 255],
  [218, 56, 42, 255],
  [220, 58, 43, 255],
  [221, 61, 45, 255],
  [222, 63, 46, 255],
  [223, 65, 47, 255],
  [224, 68, 48, 255],
  [225, 70, 49, 255],
  [226, 73, 50, 255],
  [228, 75, 51, 255],
  [229, 77, 52, 255],
  [230, 80, 53, 255],
  [231, 82, 54, 255],
  [232, 85, 56, 255],
  [233, 87, 57, 255],
  [234, 89, 58, 255],
  [236, 92, 59, 255],
  [237, 94, 60, 255],
  [238, 97, 61, 255],
  [239, 99, 62, 255],
  [240, 101, 63, 255],
  [241, 104, 64, 255],
  [242, 106, 65, 255],
  [244, 109, 67, 255],
  [244, 111, 68, 255],
  [244, 114, 69, 255],
  [245, 116, 70, 255],
  [245, 119, 71, 255],
  [245, 121, 72, 255],
  [246, 124, 74, 255],
  [246, 126, 75, 255],
  [246, 129, 76, 255],
  [247, 131, 77, 255],
  [247, 134, 78, 255],
  [247, 137, 79, 255],
  [248, 139, 81, 255],
  [248, 142, 82, 255],
  [248, 144, 83, 255],
  [249, 147, 84, 255],
  [249, 149, 85, 255],
  [250, 152, 86, 255],
  [250, 154, 88, 255],
  [250, 157, 89, 255],
  [251, 159, 90, 255],
  [251, 162, 91, 255],
  [251, 165, 92, 255],
  [252, 167, 94, 255],
  [252, 170, 95, 255],
  [252, 172, 96, 255],
  [253, 174, 97, 255],
  [253, 176, 99, 255],
  [253, 178, 101, 255],
  [253, 180, 102, 255],
  [253, 182, 104, 255],
  [253, 184, 106, 255],
  [253, 186, 107, 255],
  [253, 188, 109, 255],
  [253, 190, 110, 255],
  [253, 192, 112, 255],
  [253, 194, 114, 255],
  [253, 196, 115, 255],
  [253, 198, 117, 255],
  [253, 200, 119, 255],
  [253, 202, 120, 255],
  [253, 204, 122, 255],
  [253, 206, 124, 255],
  [253, 208, 125, 255],
  [253, 210, 127, 255],
  [253, 212, 129, 255],
  [253, 214, 130, 255],
  [253, 216, 132, 255],
  [253, 218, 134, 255],
  [253, 220, 135, 255],
  [253, 222, 137, 255],
  [254, 224, 139, 255],
  [254, 225, 141, 255],
  [254, 226, 143, 255],
  [254, 227, 145, 255],
  [254, 228, 147, 255],
  [254, 230, 149, 255],
  [254, 231, 151, 255],
  [254, 232, 153, 255],
  [254, 233, 155, 255],
  [254, 234, 157, 255],
  [254, 236, 159, 255],
  [254, 237, 161, 255],
  [254, 238, 163, 255],
  [254, 239, 165, 255],
  [254, 241, 167, 255],
  [254, 242, 169, 255],
  [254, 243, 171, 255],
  [254, 244, 173, 255],
  [254, 245, 175, 255],
  [254, 247, 177, 255],
  [254, 248, 179, 255],
  [254, 249, 181, 255],
  [254, 250, 183, 255],
  [254, 251, 185, 255],
  [254, 253, 187, 255],
  [254, 254, 189, 255],
  [254, 254, 189, 255],
  [252, 254, 187, 255],
  [251, 253, 185, 255],
  [249, 252, 183, 255],
  [248, 252, 181, 255],
  [246, 251, 179, 255],
  [245, 250, 177, 255],
  [243, 250, 175, 255],
  [242, 249, 173, 255],
  [240, 249, 171, 255],
  [239, 248, 169, 255],
  [237, 247, 167, 255],
  [236, 247, 165, 255],
  [234, 246, 163, 255],
  [233, 245, 161, 255],
  [231, 245, 159, 255],
  [230, 244, 157, 255],
  [228, 244, 155, 255],
  [227, 243, 153, 255],
  [225, 242, 151, 255],
  [224, 242, 149, 255],
  [222, 241, 147, 255],
  [221, 240, 145, 255],
  [219, 240, 143, 255],
  [218, 239, 141, 255],
  [217, 239, 139, 255],
  [215, 238, 137, 255],
  [213, 237, 136, 255],
  [211, 236, 135, 255],
  [209, 235, 133, 255],
  [207, 234, 132, 255],
  [205, 233, 131, 255],
  [203, 232, 129, 255],
  [201, 232, 128, 255],
  [199, 231, 127, 255],
  [197, 230, 126, 255],
  [195, 229, 124, 255],
  [193, 228, 123, 255],
  [191, 227, 122, 255],
  [189, 226, 120, 255],
  [187, 226, 119, 255],
  [185, 225, 118, 255],
  [183, 224, 117, 255],
  [181, 223, 115, 255],
  [179, 222, 114, 255],
  [177, 221, 113, 255],
  [175, 220, 111, 255],
  [173, 220, 110, 255],
  [171, 219, 109, 255],
  [169, 218, 107, 255],
  [167, 217, 106, 255],
  [164, 216, 105, 255],
  [162, 215, 105, 255],
  [159, 214, 105, 255],
  [157, 213, 105, 255],
  [154, 212, 104, 255],
  [152, 210, 104, 255],
  [149, 209, 104, 255],
  [147, 208, 103, 255],
  [144, 207, 103, 255],
  [142, 206, 103, 255],
  [139, 205, 103, 255],
  [137, 204, 102, 255],
  [134, 203, 102, 255],
  [132, 202, 102, 255],
  [129, 201, 102, 255],
  [127, 199, 101, 255],
  [124, 198, 101, 255],
  [122, 197, 101, 255],
  [119, 196, 100, 255],
  [117, 195, 100, 255],
  [114, 194, 100, 255],
  [112, 193, 100, 255],
  [109, 192, 99, 255],
  [107, 191, 99, 255],
  [104, 190, 99, 255],
  [102, 189, 99, 255],
  [99, 187, 98, 255],
  [96, 186, 97, 255],
  [93, 184, 96, 255],
  [90, 183, 96, 255],
  [87, 181, 95, 255],
  [84, 180, 94, 255],
  [81, 178, 93, 255],
  [78, 177, 93, 255],
  [75, 175, 92, 255],
  [72, 174, 91, 255],
  [69, 173, 90, 255],
  [66, 171, 90, 255],
  [63, 170, 89, 255],
  [60, 168, 88, 255],
  [57, 167, 87, 255],
  [54, 165, 87, 255],
  [51, 164, 86, 255],
  [48, 162, 85, 255],
  [45, 161, 84, 255],
  [42, 159, 84, 255],
  [39, 158, 83, 255],
  [36, 157, 82, 255],
  [33, 155, 81, 255],
  [30, 154, 81, 255],
  [27, 152, 80, 255],
  [25, 151, 79, 255],
  [24, 149, 78, 255],
  [23, 147, 77, 255],
  [22, 145, 76, 255],
  [21, 143, 75, 255],
  [20, 141, 74, 255],
  [19, 139, 73, 255],
  [18, 137, 72, 255],
  [17, 136, 71, 255],
  [16, 134, 70, 255],
  [15, 132, 69, 255],
  [14, 130, 68, 255],
  [13, 128, 67, 255],
  [12, 126, 66, 255],
  [11, 124, 65, 255],
  [10, 122, 64, 255],
  [9, 120, 63, 255],
  [8, 119, 62, 255],
  [7, 117, 61, 255],
  [6, 115, 60, 255],
  [5, 113, 59, 255],
  [4, 111, 58, 255],
  [3, 109, 57, 255],
  [2, 107, 56, 255],
  [1, 105, 55, 255],
  [0, 104, 55, 255]
]

let poly;
let poly1;
let poly2;
let rectangle;
let gmarkers = [];
let gmarkers1 = [];
let gmarkers2 = [];
let marker = [];
let marker1 = [];
let marker2 = [];
const gcpLayer = L.layerGroup()

let scene, camera, controls, sphere, polygons = [], drawingTool;

class RMAssignDrone extends Component {
  constructor(props) {
    super(props);
    this.potree = React.createRef();
    this.inputRef = React.createRef();
    this.fileInputRef = React.createRef();
    this.fileEventRef = React.createRef();
    this.annotationTool = React.createRef();
    this.containerRef = React.createRef();
    this.suggestionsPortalRef = React.createRef();
    this.state = {
      panning: true,
      minimizedFloorPlanningViewer: true,
      allMeasurementsShow: true,
      globalMeasurementsShow: true,
      mapMeasurementsShow: true,
      showSideBarLayers: false,
      isMeasurementCompared: [],
      isElevationData: false,
      isRegionInOrtho: false,
      isAllowToDownload: true,
      isOwner: true,
      // measurements
      drawPolygon: false,
      drawPolyline: false,
      drawMarker: false,
      showPointer: true,
      measurements: [],
      drawnMeasurements: [],
      showMeasurements: true,
      //measurements end
      progress: 0,
      showCheckboxes: false,
      selectedImageCount: 0,
      Idx: 0,
      orthoID: 0,
      outId: "",
      userperpage: 100000,
      currentpage: 1,
      userdisplay: [],
      showAddImagePopup: false,
      loader: true,
      services: [],
      counts: 0,
      projects: [],
      collection_name: '',
      createCollectionMsg: '',
      tasks: [],
      images: [],
      activeSidepanel: this.props.location?.state?.activeSidepanel || OrthomosaicAnalysis,
      reports: [],
      downloadNDVIPopup: false,
      selecttedImages: [],
      showBackIcon: true,
      cancel: false,
      viewStatus: false,
      onlineDrones: 0,
      currentPage: 1,
      maxItemsPerPage: 5,
      selectedDroneId: 0,
      drones: [],
      onlineDrones: [],
      mission: [],
      geofence: [],
      displayPauseResume: false,
      loading: true,
      displayLatLong: false,
      fence: false,
      user: {},
      orthoImageSet: '',
      videoJsOptions: null,
      locations: "nashik",
      streamKeys: this.props.streamKeys,
      topics: this.props.topics,
      center: undefined,
      zoom: 19,
      circleStrokeColor: "orange",
      sendingError: false,
      sendingErrorMessage: "",
      circleFillColor: "orange",
      altitude: "",
      speed: "",
      showingInfoWindow: false,
      type: "",

      selectedLayer1: undefined,
      selectedLayer2: undefined,

      OrthoURL: undefined,
      DSMURL: undefined,
      DTMURL: undefined,

      defaultOrtho: true,
      imageAnalysisLoader: false,
      band1: "1",
      band2: "2",
      band3: "3",
      selectedBand1: [{ value: '1', label: 'RED' }],
      selectedBand2: [{ value: '2', label: 'GREEN' }],
      selectedBand3: [{ value: '3', label: 'BLUE' }],
      selectBandsList: [{ value: '1', label: 'red' }, { value: '2', label: 'green' }, { value: '3', label: 'blue' }, { value: '4', label: '4' }],

      bandsList: [
        [
          "1",
          "red"
        ],
        [
          "2",
          "green"
        ],
        [
          "3",
          "blue"
        ],
        [
          "4",
          ""
        ]
      ],

      processTileType: undefined,
      activeProcessTileType: ["RGB"],
      selectedFilter: undefined,
      selectedAlgorithm: [],
      selectAlgorithms: [],
      selectFilters: [{ value: "RGB" }],
      processTileIndex: "VARI",
      DEMType: 'DSM',
      processTileMin: -0.283,
      algoMin: -1.0,
      algoMax: 1.0,
      processTileMax: 0.181,
      orthomosaicImages: [],
      processTileIndexNum: undefined,
      imageSets: '',
      flightType: "",
      toggle: false,
      toggle1: false,
      toggle2: false,
      showOrthoPopup: false,
      label: 1,
      label1: 1,
      lattitude: "",
      longitude: "",
      avatarURL: "",
      background: "white",
      displayWaypoint: false,
      displaySurvey: false,
      displaySpraying: false,
      sending: false,
      sidebarMode: this.props.location.state
        ? this.props.location.state.sidebarMode
        : "shrunk",
      redirect: false,
      orthoImageData: undefined,
      orthoImageData1: undefined,
      compare: false,
      ThreeDShow: false,
      planShow: false,
      RGBShow: false,
      NDVIShow: false,
      DEMShow: false,
      DTMShow: false,
      DEMShowPopup: false,
      ThreeDShowPopup: false,
      pointCloudShow: false,
      bothShowPT: false,
      inspectShow: false,
      GCPShow: true,
      GCP: false,
      DrawPlan: false,
      planEmpty: false,
      histogramUnavailable: false,
      statistics: {
        1: {
          histogram: [
            new Array(256).fill(0),
            [-1, -0.9921568627450981, -0.9843137254901961, -0.9764705882352941, -0.9686274509803922, -0.9607843137254902, -0.9529411764705882, -0.9450980392156862, -0.9372549019607843, -0.9294117647058824, -0.9215686274509804, -0.9137254901960784, -0.9058823529411765, -0.8980392156862745, -0.8901960784313725, -0.8823529411764706, -0.8745098039215686, -0.8666666666666667, -0.8588235294117648, -0.8509803921568627, -0.8431372549019608, -0.8352941176470589, -0.8274509803921568, -0.8196078431372549, -0.8117647058823529, -0.803921568627451, -0.7960784313725491, -0.788235294117647, -0.7803921568627451, -0.7725490196078432, -0.7647058823529411, -0.7568627450980392, -0.7490196078431373, -0.7411764705882353, -0.7333333333333334, -0.7254901960784313, -0.7176470588235294, -0.7098039215686275, -0.7019607843137254, -0.6941176470588235, -0.6862745098039216, -0.6784313725490196, -0.6705882352941177, -0.6627450980392157, -0.6549019607843137, -0.6470588235294118, -0.6392156862745098, -0.6313725490196078, -0.6235294117647059, -0.615686274509804, -0.607843137254902, -0.6, -0.592156862745098, -0.5843137254901961, -0.5764705882352941, -0.5686274509803921, -0.5607843137254902, -0.5529411764705883, -0.5450980392156863, -0.5372549019607843, -0.5294117647058824, -0.5215686274509804, -0.5137254901960784, -0.5058823529411764, -0.4980392156862745, -0.4901960784313726, -0.48235294117647065, -0.4745098039215686, -0.4666666666666667, -0.45882352941176474, -0.4509803921568627, -0.44313725490196076, -0.43529411764705883, -0.4274509803921569, -0.41960784313725497, -0.4117647058823529, -0.403921568627451, -0.39607843137254906, -0.388235294117647, -0.3803921568627451, -0.37254901960784315, -0.3647058823529412, -0.3568627450980393, -0.34901960784313724, -0.3411764705882353, -0.33333333333333337, -0.3254901960784313, -0.3176470588235294, -0.30980392156862746, -0.3019607843137255, -0.2941176470588236, -0.28627450980392155, -0.2784313725490196, -0.2705882352941177, -0.26274509803921564, -0.2549019607843137, -0.24705882352941178, -0.23921568627450984, -0.2313725490196079, -0.22352941176470587, -0.21568627450980393, -0.207843137254902, -0.19999999999999996, -0.19215686274509802, -0.1843137254901961, -0.17647058823529416, -0.16862745098039222, -0.16078431372549018, -0.15294117647058825, -0.14509803921568631, -0.13725490196078427, -0.12941176470588234, -0.1215686274509804, -0.11372549019607847, -0.10588235294117654, -0.0980392156862745, -0.09019607843137256, -0.08235294117647063, -0.07450980392156858, -0.06666666666666665, -0.05882352941176472, -0.050980392156862786, -0.04313725490196085, -0.03529411764705881, -0.027450980392156876, -0.019607843137254943, -0.0117647058823529, -0.0039215686274509665, 0.0039215686274509665, 0.0117647058823529, 0.019607843137254832, 0.027450980392156765, 0.0352941176470587, 0.04313725490196085, 0.050980392156862786, 0.05882352941176472, 0.06666666666666665, 0.07450980392156858, 0.08235294117647052, 0.09019607843137245, 0.0980392156862746, 0.10588235294117654, 0.11372549019607847, 0.1215686274509804, 0.12941176470588234, 0.13725490196078427, 0.1450980392156862, 0.15294117647058814, 0.16078431372549007, 0.16862745098039222, 0.17647058823529416, 0.1843137254901961, 0.19215686274509802, 0.19999999999999996, 0.2078431372549019, 0.21568627450980382, 0.22352941176470598, 0.2313725490196079, 0.23921568627450984, 0.24705882352941178, 0.2549019607843137, 0.26274509803921564, 0.2705882352941176, 0.2784313725490195, 0.28627450980392144, 0.2941176470588236, 0.3019607843137255, 0.30980392156862746, 0.3176470588235294, 0.3254901960784313, 0.33333333333333326, 0.3411764705882352, 0.34901960784313735, 0.3568627450980393, 0.3647058823529412, 0.37254901960784315, 0.3803921568627451, 0.388235294117647, 0.39607843137254894, 0.4039215686274509, 0.4117647058823528, 0.41960784313725497, 0.4274509803921569, 0.43529411764705883, 0.44313725490196076, 0.4509803921568627, 0.45882352941176463, 0.46666666666666656, 0.4745098039215687, 0.48235294117647065, 0.4901960784313726, 0.4980392156862745, 0.5058823529411764, 0.5137254901960784, 0.5215686274509803, 0.5294117647058822, 0.5372549019607842, 0.5450980392156863, 0.5529411764705883, 0.5607843137254902, 0.5686274509803921, 0.5764705882352941, 0.584313725490196, 0.5921568627450979, 0.6000000000000001, 0.607843137254902, 0.615686274509804, 0.6235294117647059, 0.6313725490196078, 0.6392156862745098, 0.6470588235294117, 0.6549019607843136, 0.6627450980392156, 0.6705882352941177, 0.6784313725490196, 0.6862745098039216, 0.6941176470588235, 0.7019607843137254, 0.7098039215686274, 0.7176470588235293, 0.7254901960784315, 0.7333333333333334, 0.7411764705882353, 0.7490196078431373, 0.7568627450980392, 0.7647058823529411, 0.7725490196078431, 0.780392156862745, 0.7882352941176469, 0.7960784313725491, 0.803921568627451, 0.8117647058823529, 0.8196078431372549, 0.8274509803921568, 0.8352941176470587, 0.8431372549019607, 0.8509803921568628, 0.8588235294117648, 0.8666666666666667, 0.8745098039215686, 0.8823529411764706, 0.8901960784313725, 0.8980392156862744, 0.9058823529411764, 0.9137254901960783, 0.9215686274509804, 0.9294117647058824, 0.9372549019607843, 0.9450980392156862, 0.9529411764705882, 0.9607843137254901, 0.968627450980392, 0.9764705882352942, 0.9843137254901961, 0.9921568627450981, 1]
          ],
          max: 1,
          min: -1,
          percentile: [-0.2714285714285714, 0.2],
          std: 0.1042979526354489,
          valid_percent: 78.33045085877862
        }
      },
      collection_id: '',
      scale: 0,
      imageLoad: false,
      collections: [],
      plan: {},
      project: {},
      itemName: "",
      showProcessPopup: false,
      processPopupIcon: "",
      processAction: "",
      processMessage: "",
      thumbURLs: [],
      imageURLs: [],
      tiffSrc: "",
      reportLoader: false,
      imageTilesLoaded: false,
      report_type: "",
      openToolBar: false,
      sidebarPanel: false,
      saveName: false,
      saveDes: false,
      activeBaseLayer: 'satelite',
      displayColorPicker: false,
      background: 'red',
      saveNameState: false,
      saveDesState: false,
      textboxValid: true,
      errorMsg: "",
      inviteMail: [],
      emailValue: '',
      shareInviteModal: false,
      validationDisplay: "none",
      validationMessage: "",
      accessType: false,
      errorEmails: [],
      existEmails: [],
      successEmails: [],
      alreadysharedwith: [],
      deleteShareEmail: '',
      deleteshareSId: '',
      accessRemoved: [],
      shareDetailedData: false,
      GCPPoints: [],
      displayAreaUnit: '',
      displayLengthUnit: '',
      displayLatLongUnit: 'degree',
      latlongData: {},
      toolTipShow: true,
      calculationMethod: "fit_plane",
      DSMAvailable: false,
      DTMAvailable: false,
      OrthomosaicAvailable: false,
      ThreeDAvailable: false,
      indThreeDAvailable: false,
      indPointCloudAvailable: false,
      showOnclickPointDetails: false,
      onclickMarker: null,
      copyText: '',
      showElevationProfile: false,
      elevationProfileLoader: false,
      elevationData: null,
      selectedUnit: { label: 'Metric (m, sq.m, cu.m)', value: 'm' },
      unitSystems: [{ label: 'Metric (m, sq.m, cu.m)', value: 'm' }, { label: 'Imperial (ft, sq.ft, cu.yd)', value: 'ft' }],
      showRangeData: false,
      rangeMin: -1,
      rangeMax: 1,
      DSMAvailable1: false,
      DTMAvailable1: false,
      OrthomosaicAvailable1: false,
      ThreeDAvailable1: false,
      indThreeDAvailable1: false,
      indPointCloudAvailable1: false,
      showCompareReportCard: false,
      teamMembers: [],
      mentionValue: '',
      mentionMessage: '',
      mentionedUser: '',
      clickedPolyFromShape: false,
      selectedShapeCountour: null,
      shapeFileLayers: [],
      kmlFileLayes: [],
      hideButtontext: true,
      showImportFilePopUp: false,
      importedShapeCount: 0,
      totalShapeCount: 0,
      innerRegionPolyCount: 0,
      innerPoly: [],
      shapeFilePopup: false,
      saveShapeFilePopup: false,
      shapeFileItem: undefined,
      shapeFileIcon: undefined,
      shapeFileMsg: null,
      urlExits: false,
      compare3DMode: false,
      shpFileEvent: undefined,
      uploadFileEvent: undefined,
      selectedFilesExt: undefined,
      assetsLayers: [],
      importLoading: false,
      loadingComponent: false,
      AllMeasurementMenu: false,
      LocalMeasurementMenu: false,
      GlobalMeasurementMenu: false,
      measurementMenu: false,
      disableLayers: false,
      floors: [],
      activeSideBarFloor: "",
      DisableAddGlobalMeasurement: false,
      selectedLayerGeoJson: undefined,
      selectedLabel: undefined,
      addProperty: false,
      propertyKey: null,
      propertyValue: null,
      propertyKeysArr: [],
      propertyObj: {},
      showTip: true,
      keyWarning: false,
      valueWarning: false,
      activityPopupObj: undefined,
      showDeletePopup: undefined,
      finalOtherProperties: {},
      callMarkIssue: undefined,
      selectedFloor: undefined,
      selectedTab: undefined,

      previousRGBShow: false,
      previousNDVIShow: false,
      previousDEMShow: false,
      previousDTMShow: false,
      previousThreeDShow: false,
      previousPointCloudShow: false,
      previousBothShowPT: false,
    };
    // this.updateRMAssignDroneState = this.updateRMAssignDroneState.bind(this);
  }
  // ----------------Check if annotation out of bounds or not

  isAnyMapAvailable = () => {
    return (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) ||
      (this.state.DTMAvailable != NotSelected && this.state.DTMAvailable) ||
      (this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable)
  }

  //----------------Threed related functions here-------------------//

  // this will be called when measurement clicked from threed viewer
  measurementClickedOnThreed = (id) => {
    this.managePopup()
    this.measurementClicked(id, true)
  }

  getTiffAvailable = () => {
    return (this.state.DSMAvailable && this.state.DSMAvailable != NotSelected ||
      this.state.DTMAvailable && this.state.DTMAvailable != NotSelected ||
      this.state.OrthomosaicAvailable && this.state.OrthomosaicAvailable != NotSelected)
  }
  //this function is passed to potree viewer which is trigger when new meauserement is drawn on 3d.
  //this will be save the measurement into the database and draw new measurement on 2d map.
  drawIn2dAndSave = (measurement) => {
    return new Promise((resolve, reject) => {
      this.saveMeasurement(measurement).then(savedMeasurement => {

        if (this.getTiffAvailable()) {
          drawMeasurements(this.state.selectedUnit.value, this.state.toolTipShow, this.state.map, [savedMeasurement], this.measurementClicked, this.markerDragEnd, this.state.drawnMeasurements.length, this.state.permissions).then((data) => {
            this.setDrawnMeasurements([data.drawnMeasurements[0]])
          })
        }
        resolve(savedMeasurement)
      })
    })
  }

  updateMeasurementFrom3d = (measurement) => {
    measurement = {
      ...this.state.measurements.find(measurementS => measurementS.id === measurement.id),
      coordinates: measurement.coordinates,
      is3d: true,
      stats: null,
      measurements: undefined,
      cut_volume: null,
      fill_volume: null,
      volume: null,
      calc_method: null
    }
    this.updateMeasurement(measurement)
  }

  //---------------Threed related functions END-------------------//
  getElevationProfileData = () => {
    // get elevation profile from tile server
    return new Promise((resolve, reject) => {
      this.setState({ elevationProfileLoader: true, graphData: null })
      if (this.state.orthoImageData) {
        let data = {
          taskId: this.state.orthoImageData.task_id,
          blobContainer: this.state.permissions.container,
          sas: this.state.permissions.st,
          latLngs: this.state.selectedMeasurement.coordinates
        }
        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getElevationProfileData(data).then((result) => {
          this.setState({ isElevationData: result.elevationProfile.filter(elv => elv.elevation >= 0 && elv.elevation != "NA").length > 0 })
          let graphData = this.getElevationData(result.elevationProfile)
          this.setState({
            elevationData: result.elevationProfile,
            graphData,
            elevationProfileLoader: false
          })
          resolve(0)
        })
        else {
          this.setState({ elevationData: null, graphData: null, elevationProfileLoader: false })
        }
      }
    })
  }

  closeElevationGraph = () => {
    this.setState({ showElevationProfile: false, graphData: null })
  }

  getElevationData = (elevationData) => {

    var labels = []
    let len = this.state.selectedMeasurement?.measurements?.[0] ? (this.state.selectedMeasurement.measurements[0]["2D Length"]).split(" ") : 0
    let addDistance = Number(len[0]) / elevationData.length
    let distance = 0.0
    let data = elevationData.map((d, i) => {
      labels.push(distance)
      let x = this.state.selectedUnit.value == 'm' ? Number(distance.toFixed(2)) : (Number(distance) * 3.281).toFixed(2)
      let y = this.state.selectedUnit.value == 'm' ? Number(d.elevation.toFixed(4)) : (Number(d.elevation) * 3.281).toFixed(4)
      let obj = { x, y }
      distance = distance + addDistance
      return obj
    })
    const data1 = (canvas) => {

      return {
        labels: labels,
        datasets: [
          {
            label: "test",
            data: data,
            fill: true,
            backgroundColor: (context) => {
              if (!context.chart.chartArea) return;
              const chart = context.chart;
              const { ctx, data, chartArea: { top, bottom }, } = chart;
              const gradient = ctx.createLinearGradient(0, 0, top, bottom);
              gradient.addColorStop(0, '#b0ceff');
              gradient.addColorStop(0.5, '#c7ddfc');
              gradient.addColorStop(1, '#edf3fc');
              return gradient
            },
            borderColor: "#2989cf",
            borderWidth: 1,
            showLine: true,
          },
        ],
      }
    }
    return data1()

  }

  exportTiff = () => {
    this.setState({
      showProcessPopup: true,
      processPopupIcon: "WAIT",
      processMessage: `please wait while we are generating clipped orthomosaic...`
    })
    exportPolygonTiff(this.state.permissions.container, this.state.orthoImageData?.task_id, this.state.permissions.st, this.state.selectedMeasurement.coordinates)
      .then(() => {
        this.setState({
          showProcessPopup: false,
          processPopupIcon: "",
          processMessage: ``
        })
      })
      .catch(e => {
        this.setState((state) => ({
          ...state,
          itemName: "",
          processPopupIcon: "ERROR",
          processMessage: `Something went wrong while generating clipped orthomosaic.`,
          showProcessPopup: true,
          deleteShareEmail: '',
          deleteshareSId: '',
          accessRemoved: [],
        }))
      })
  }

  getVolume = () => {
    this.setState({ loadingVolume: true })
    const { selectedMeasurement, user, orthoImageData, calculationMethod, measurements } = this.state

    const polygon = selectedMeasurement.coordinates.map(coord => [coord.lng, coord.lat])
    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getVolume(calculationMethod, this.state.permissions.container, this.state.permissions.st, this.state.orthoImageData.task_id, polygon)
      .then((volume) => {
        this.setState({
          loadingVolume: false,
          selectedMeasurement: {
            ...selectedMeasurement,
            volume: volume.volume ? Number(volume.volume).toFixed(2) : null,
            cut_volume: volume.cutVolume ? volume.cutVolume : null,
            fill_volume: volume.fillVolume ? volume.fillVolume : null,
            calc_method: volume.fillVolume ? calculationMethod : null
          }
        }, () => {
          if (this.potree.current) this.potree.current.updateVolume(selectedMeasurement.id, volume.volume || null);
          if (volume.volume) {
            const updatedIndex = measurements.findIndex(
              (measurement) => measurement.id === selectedMeasurement.id
            )
            measurements[updatedIndex] = {
              ...this.state.selectedMeasurement
            }
            if (this.state.drawnMeasurements[updatedIndex]) this.updateTooltip(this.state.drawnMeasurements[updatedIndex], this.state.selectedMeasurement)
            if (this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) API.updateMeasurement(this.state.selectedMeasurement);
          }
        })
      }
      )
      .catch((volume) => {
        this.setState({
          loadingVolume: false,
          selectedMeasurement: {
            ...selectedMeasurement,
            volume: volume.volume ? volume.volume : null,
            cut_volume: volume.cutVolume ? volume.cutVolume : null,
            fill_volume: volume.fillVolume ? volume.fillVolume : null,
            calc_method: null
          }
        })
      })
    else {
      this.setState({
        loadingVolume: false,
        selectedMeasurement: {
          ...selectedMeasurement,
        }
      })
    }
  }

  // task zip file API
  getZipFIle = (highRes) => {
    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) API.getZipFIle(this.state.orthoImageData.task_id, this.state.orthoImageData.task_name, highRes)
  }

  initTeamsLiveChangesSetup = async () => {
    try {
      await connectToSocketIOGroup(this.state.orthoImageData?.task_id || this.props.location.state.plan?.id, (measurement, type) => {
        if (type === SOCKET_IO_MESSAGES.DRONENAKSHA.MEASUREMENT_UPDATED) this.updateMeasurement(measurement, true)
        if (type === SOCKET_IO_MESSAGES.DRONENAKSHA.MEASUREMENT_ADDED) drawMeasurements(this.state.selectedUnit.value, this.state.toolTipShow, this.state.map, [measurement], this.measurementClicked, this.markerDragEnd, this.state.drawnMeasurements.length, this.state.permissions)
          .then(async (data) => {
            if (!(this.state.allMeasurementsShow || (measurement.plan_id && this.state.globalMeasurementsShow) || (!measurement.plan_id && this.state.mapMeasurementsShow))) {
              await toggleMeasurementLabels(false, data.drawnMeasurements[0], this.state.map, this.state.selectedUnit.value, measurement)
              data.drawnMeasurements[0].remove()
              measurement.show = false
            }
            this.saveMeasurement(measurement, true)
            this.setDrawnMeasurements(data.drawnMeasurements)
          })
        if (type === SOCKET_IO_MESSAGES.DRONENAKSHA.MEASUREMENT_DELETED) {
          this.deleteMeasurement(measurement.id)
        }
      })
    } catch (e) {
      console.error(e)

    }
  }

  //leaflet 
  mapInitialized = () => {
    const { map } = this.state

    document.addEventListener('contextmenu', (e) => {
      e.preventDefault()
      map.dragging.disable()
    });

    document.addEventListener('mouseup', (e) => {
      map.dragging.enable()
    });

    addEditControl(map);
    layerAddedEvent(map)
    layerRemovedEvent(map)
    editEnableEvent(map, this.setActiveEditLayer);
    editDisableEvent(map, this.saveLayer, this.removeActiveEditLayer)
    drawingEndEvent(map, this.drawingEndEvent)
    existingMeasurementUpdatedEvent(map, this.updateLayer)
    gcpLayer.addTo(map)
    this.getMeasurements().then((data) => {
      this.showMeasurements("mapInitialized")
      this.showGCP()

      if (this.state.showFloors) {
        this.setState({
          sidebarPanel: true,
          DEMShow: false,
          DTMShow: false,
          NDVIShow: false,
          RGBShow: false,
          ThreeDShow: false,
          pointCloudShow: false,
          bothShowPT: false,
        })
      }
    })

  }

  changeMeasurementColor = (color) => {
    let { measurements, drawnMeasurements, selectedMeasurement } = this.state
    if (this.potree.current) this.potree.current.setMeasurementColor(selectedMeasurement.id, color)
    const index = measurements.findIndex(
      (measurement) => measurement.id === selectedMeasurement.id
    )
    if (drawnMeasurements[index]) {
      let colorUpdatedMeasurement = drawnMeasurements[index].setStyle({
        color: color.hex
      })
      drawnMeasurements[index] = colorUpdatedMeasurement
    }
    let measurement = {
      ...measurements[index],
      color: color.hex
    }
    measurements[index] = measurement
    this.setState({
      measurements, drawnMeasurements,
      selectedMeasurement: {
        ...selectedMeasurement,
        color: color.hex
      }
    })
    if (this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) {
      if (measurement.task_id) API.updateMeasurement(measurement);
      else API.updateGlobalMeasurement(measurement)
    }
  }

  getMeasurements = () => {
    // get measurements from the database
    return new Promise(async (resolve, reject) => {

      const setMeasurementsState = (states) => {
        const keysToRemove = ['compared', 'coordinates', 'date_created', 'plan_id', 'show'];

        if (states?.measurements.length > 0) {
          const filteredObject = Object.fromEntries(
            Object.entries(states?.measurements[0]).filter(([key]) => !keysToRemove.includes(key))
          );

          this.setState({
            ...states, selectedMeasurement: undefined,
            propertyKeysArr: filteredObject ? Object.keys(filteredObject) : [],
          }, () => {
            resolve()
          })
        } else {
          resolve()
        }
      }

      // if (this.state.orthoImageData) {
      let taskId = this.state.orthoImageData?.task_id
      if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) {
        const localMeasurements = taskId ? await API.getMeasurements(taskId) : { measurements: [] }
        const globalMeasurements = await API.getGlobalMeasurements(this.props.location.state.plan.id)
        const measurements = [...localMeasurements.measurements, ...globalMeasurements.measurements]
        this.setState({ showCompareReportCard: globalMeasurements.length > 0, contour: localMeasurements.contour });
        if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) {
          const elevationNotAvailableMeasurements = measurements.filter(m => (m.type === "Marker" && !m.coordinates.elevation) || (m.type !== "Marker" && !m.coordinates[0].elevation))
          if (elevationNotAvailableMeasurements.length > 0) {
            if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getMeasurementsInThreed(taskId, this.state.permissions, elevationNotAvailableMeasurements).then((data3d) => {

              setMeasurementsState({
                areaCode: data3d.areaCode,
                areaNumber: data3d.areaNumber,
                measurements: [...data3d.measurements, ...measurements.filter(m => (m.type === "Marker" && m.coordinates.elevation) || (m.type !== "Marker" && m.coordinates[0].elevation))]
              })
            }).catch((e) => {
              setMeasurementsState({
                measurements: measurements,
              })
            })

          } else {
            setMeasurementsState({
              measurements: measurements,
            })
          }
        }
        else {
          setMeasurementsState({
            measurements: measurements,
          })
        }
      }


      // }
    })

  }

  updateTooltip = async (layer, measurement) => {
    await toggleMeasurementLabels(this.state.toolTipShow && measurement.show, layer, this.state.map, this.state.selectedUnit.value, measurement)
    await addMeasurementTooltips(layer, this.state.selectedUnit.value)
    await toggleMeasurementTooltips(measurement.showLabels, layer, this.state.map, this.state.selectedUnit.value)
  }

  toggleAllMeasurements = () => {
    const measurements = this.state.measurements.map((m, key) => {
      toggleMeasurementLabels(this.state.toolTipShow && this.state.allMeasurementsShow, this.state.drawnMeasurements[key], this.state.map, this.state.selectedUnit.value, m)
      if (!this.state.allMeasurementsShow) {
        this.state.drawnMeasurements[key].remove()
      }
      else {
        this.state.drawnMeasurements[key].addTo(this.state.map)
      }
      return {
        ...m,
        show: this.state.allMeasurementsShow
      }
    })
    this.setState({
      measurements,
      mapMeasurementsShow: this.state.allMeasurementsShow,
      globalMeasurementsShow: this.state.allMeasurementsShow,
    })
  }

  toggleGlobalMeasurement = () => {
    const measurements = this.state.measurements.map((m, key) => {
      if (m.plan_id) {
        toggleMeasurementLabels(this.state.toolTipShow && this.state.globalMeasurementsShow, this.state.drawnMeasurements[key], this.state.map, this.state.selectedUnit.value, m)
        if (!(this.state.globalMeasurementsShow)) this.state.drawnMeasurements[key].remove()
        else {
          this.state.drawnMeasurements[key].addTo(this.state.map)
        }
        return {
          ...m,
          show: this.state.globalMeasurementsShow
        }
      } else return m
    })
    this.setState({
      measurements,
      allMeasurementsShow: this.state.mapMeasurementsShow && this.state.globalMeasurementsShow,
    })
  }

  toggleMapMeasurement = () => {
    const measurements = this.state.measurements.map((m, key) => {
      if (!(m.plan_id)) {
        toggleMeasurementLabels(this.state.toolTipShow && this.state.mapMeasurementsShow, this.state.drawnMeasurements[key], this.state.map, this.state.selectedUnit.value, m)
        if (!(this.state.mapMeasurementsShow)) this.state.drawnMeasurements[key].remove()
        else {
          this.state.drawnMeasurements[key].addTo(this.state.map)
        }
        return {
          ...m,
          show: this.state.mapMeasurementsShow
        }
      } else return m
    })
    this.setState({
      measurements,
      allMeasurementsShow: this.state.mapMeasurementsShow && this.state.globalMeasurementsShow,
    })
  }

  showMeasurements = async (from) => {
    if (this.state.showMeasurements) {
      let { drawnMeasurements, measurements, map } = this.state
      let measurements1 = measurements.map((measurement) => {
        measurement.show = true
        return (measurement)
      })
      this.setState({ measurements: measurements1 })
      if (drawnMeasurements.length > 0) {
        this.setState({ drawnMeasurements: [] })
        await hideMeasurements(drawnMeasurements)
        drawMeasurements(this.state.selectedUnit.value, this.state.toolTipShow, map, measurements, this.measurementClicked, this.markerDragEnd, undefined, this.state.permissions).then((data) => {
          this.setDrawnMeasurements(data.drawnMeasurements)
        })
      } else {
        drawMeasurements(this.state.selectedUnit.value, this.state.toolTipShow, map, measurements, this.measurementClicked, this.markerDragEnd, undefined, this.state.permissions).then((data) => {
          this.setDrawnMeasurements(data.drawnMeasurements)
        })
      }
    }
  }

  // toggleShowMeasurement = () => {
  //   this.managePopup()
  //   this.toggleMeasurement("showPointer")
  //   this.setState({
  //     showMeasurements: !(this.state.showMeasurements),
  //     inspectShow: false,
  //     toolTipShow: (this.state.showMeasurements)
  //   }, () => {
  //     this.inspectImages()
  //     // this.toggleToolTips(this.state.showMeasurements)
  //     if (this.state.showMeasurements) {
  //       if (this.potree.current) this.potree.current.toggleMeasurementsVisibility(true)
  //       this.showMeasurements("toggleShowMeasurement")
  //       this.setState({
  //         measurements: this.state.measurements.map(measure => { return { ...measure, show: true } }),
  //       })
  //     } else {
  //       if (this.potree.current) this.potree.current.toggleMeasurementsVisibility(false)
  //       hideMeasurements(this.state.drawnMeasurements)
  //       this.setState({
  //         measurements: this.state.measurements.map(measure => { return { ...measure, show: false } }),
  //       }
  //       )
  //     }

  //   })
  // }

  disbaleCrosshair = () => {
    let elements = document.getElementsByClassName("leaflet-interactive")
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.cursor = "pointer"
    }
  }

  disableEdit = async () => {
    this.disbaleCrosshair()
    if (this.potree.current) {
      await this.potree.current.clearPartiallyVolume()
      if (!(this.potree.current.isVolumeBoxDrawn())) {
        this.setState({
          drawVolumeBox: false
        })
      }
      await this.potree.current.stopDrawing();
      this.potree.current.indicateMarkerInScene(null);
    }

    if (this.state.onclickMarker) {
      L.DomUtil.removeClass(this.state.map._container, 'crosshair-cursor-enabled');
      this.state.onclickMarker.remove()
    }
    //this is used to disable active Edit layer when polygon or polyline button active
    if (this.state.activeEditLayer && !(this.state.drawMarker)) {
      this.state.activeEditLayer.disableEdit()
      // this.state.map.editTools.stopDrawing()
    }
    if (this.state.activeDrawnMeasurement) {
      this.state.activeDrawnMeasurement.disableEdit()
      this.setState({
        selectedMeasurement: undefined,
        activeDrawnMeasurement: undefined
      })
    }
    return

  }

  getInviteUsersList = () => {
    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].SHARE) API.getInviteUsersList(this.state.orthoImageData.collection_id).then((res) => {
      this.setState((state) => ({
        ...state,
        alreadysharedwith: res.data,
      }))
    }, (e) => {
      console.log('Something went wrong while fetching invited users list.');
    })
  }

  deleteSharedData = () => {
    this.setState((state) => ({
      ...state,
      shareDetailedData: false,
      itemName: "",
      processPopupIcon: "WAIT",
      processAction: "DELETE",
      processMessage: "Removing access please wait",
      showProcessPopup: true,
      shareInviteModal: false,
      inviteModal: false,
      inviteMail: [],
      successEmails: [],
      existEmails: [],
      errorEmails: [],
      emailValue: '',
      validationDisplay: "none",
      validationColor: "red",
      validationMessage: ""
    }))
    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].SHARE) API.deleteSharedData(this.state.deleteshareSId).then((res) => {
      if (res.status == 200) {
        res.json().then((data) => {
          this.setState((state) => ({
            ...state,
            itemName: "",
            processPopupIcon: "COMPLETE",
            processAction: "DELETE",
            processMessage: data.message,
            showProcessPopup: true,
            deleteShareEmail: '',
            deleteshareSId: '',
            accessRemoved: [],
          }))
        })
      } else {
        res.json().then((data) => {
          this.setState((state) => ({
            ...state,
            itemName: "",
            processPopupIcon: "ERROR",
            processAction: "DELETE",
            processMessage: data.message,
            showProcessPopup: true,
            deleteShareEmail: '',
            deleteshareSId: '',
            accessRemoved: [],
          }))
        })

      }
    }, (e) => {
      this.setState((state) => ({
        ...state,
        itemName: "",
        processPopupIcon: "ERROR",
        processAction: "DELETE",
        processMessage: e,
        showProcessPopup: true,
        deleteShareEmail: '',
        deleteshareSId: '',
        accessRemoved: [],
      }))
    })
  }

  toggleToolTips = (show) => {
    if (this.state.drawnMeasurements.length > 0 && (this.state.showMeasurements || this.state.globalMeasurementsShow)) {
      this.setState({
        toolTipShow: show || !this.state.toolTipShow
      }, async () => {
        let { drawnMeasurements, measurements } = this.state
        for (let i = 0; i < drawnMeasurements.length; i++) {
          if (drawnMeasurements[i]) await toggleMeasurementLabels(this.state.toolTipShow, drawnMeasurements[i], this.state.map, this.state.selectedUnit.value, measurements[i])
        }
      })
    }

  }

  getSharedData = () => {
    this.setState((state) => ({
      ...state,
      shareInviteModal: false,
      shareDetailedData: true,
    }))
    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].SHARE) API.getSharedData(this.state.project.id, this.state.deleteShareEmail, this.state.deleteshareSId).then((res) => {

      this.setState((state) => ({
        ...state,
        accessRemoved: res.data
      }))
    }, (e) => {
      console.log('Something went wrong while fetching shared project data.');
      // this.setState((state) => ({
      //   ...state,
      //   loading: false
      // }))
    })
  }

  sendInvite = () => {
    let access_level = this.state.accessType == true ? 'READ' : 'DOWNLOAD'
    this.state.inviteMail.forEach((email, key) => {
      if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].SHARE) API.inviteUserToShareAssets(email, this.state.orthoImageData.collection_id, access_level, this.state.project.id, this.state.plan.id, this.state.orthoImageData.task_name).then((response) => {
        if (response.status === 201) {
          response.json().then((data) => {
            this.setState((prevState) => ({
              ...prevState,
              validationDisplay: "block",
              validationMessage: data.message,
              validationColor: "green",
            }), () => {
              this.getInviteUsersList()
            })
          })
          this.state.successEmails.push(email)
        } else if (response.status === 202) {
          response.json().then((data) => {
            this.setState((prevState) => ({
              ...prevState,
              validationDisplay: "block",
              validationMessage: data.message,
              validationColor: "red"
            }))
          })
          this.state.existEmails.push(email)
        }
      })
        .catch((error) => {
          this.state.errorEmails.push(email)
          this.setState((prevState) => ({
            ...prevState,
            inviteErrorMsg: error.Error,
            validationDisplay: "block",
            validationMessage: error.Error,
            validationColor: "red"
          }))
        })
    })


  };

  onChangeAccess = (e, key, sid) => {
    let access = e.target.value
    this.state.alreadysharedwith[key].access_level.title = access
  }

  handleInputChange = (event) => {
    let emailValue = event.target.value
    if (emailValue === this.state.user.username) {
      this.setState((prevState) => ({
        ...prevState,
        validationDisplay: "block",
        validationColor: "red",
        validationMessage: "You can not send invitation to yourself."
      }))
    } else {
      if (emailValue.includes(' ')) {
        this.setState((prevState) => ({
          ...prevState,
          validationDisplay: "block",
          validationColor: "red",
          validationMessage: "space not allowed"
        }))
      } else {
        this.setState((state) => ({
          ...state,
          emailValue: emailValue,
        }), () => {
          if (this.state.emailValue.includes(',')) {
            this.setState((prevState) => ({
              ...prevState,
              inviteMail: [],
            }), () => {
              let emails = this.state.emailValue.split(',')
              emails.map((email, key) => {
                if (validator.isEmail(email)) {
                  this.state.inviteMail.push(email)
                  this.setState((prevState) => ({
                    ...prevState,
                    validationDisplay: "block",
                    validationColor: "red",
                    validationMessage: ""
                  }))
                } else {
                  this.setState((prevState) => ({
                    ...prevState,
                    validationDisplay: "block",
                    validationColor: "red",
                    validationMessage: "please enter valid Email address"
                  }))
                }
              })
            })

          } else {
            if (validator.isEmail(this.state.emailValue)) {
              this.state.inviteMail[0] = this.state.emailValue
              this.setState((prevState) => ({
                ...prevState,
                validationDisplay: "block",
                validationColor: "red",
                validationMessage: ""
              }))
            } else {
              this.setState((prevState) => ({
                ...prevState,
                validationDisplay: "block",
                validationColor: "red",
                validationMessage: "please enter valid Email address"
              }))
            }
          }
        })
      }
    }
  }

  enableCrosshair = () => {
    let elements = document.getElementsByClassName("leaflet-interactive")
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.cursor = "crosshair"
    }
  }

  toggleMeasurement = (type) => {
    //this is used to toggle measurement 
    if (this.state.inspectShow) {
      this.setState({
        inspectShow: false
      }, this.inspectImages)
    }
    this.toggleMeasurementButtons(type).then(() => {
      switch (type) {
        case "drawPolygon":
          if (this.state.drawPolygon) {
            this.disableEdit().then(() => {
              if (this.potree.current) {
                this.potree.current.startDrawing("Polygon");
              }
              this.enableCrosshair()
              // after disablingEdit Automatically new measurement will be start by drawingEndEvent function so we have to start drawing only first time when there is no any activedrawinglayer
              if (!(this.state.activeEditLayer)) {
                this.state.map.editTools.startPolygon()
              }
            })
          }
          else this.disableEdit() //when active toggle button press again it will disable editing mode
          break;
        case "drawPolyline":
          if (this.state.drawPolyline) {
            this.disableEdit().then(() => {
              if (this.potree.current) {
                this.potree.current.startDrawing("Polyline");
              }
              this.enableCrosshair()
              // after disablingEdit Automatically new measurement will be start by drawingEndEvent function so we have to start drawing only first time when there is no any activedrawinglayer
              if (!(this.state.activeEditLayer)) {
                this.state.map.editTools.startPolyline()
              }
            })
          }
          else this.disableEdit() //when active toggle button press again it will disable editing mode
          break;
        case "drawMarker":
          if (this.state.drawMarker) {
            this.disableEdit().then(() => {
              if (this.potree.current) {
                this.potree.current.startDrawing("Marker");
              }
              L.DomUtil.addClass(this.state.map._container, 'crosshair-cursor-enabled');
              if (this.state.activeEditLayer) {
                this.state.activeEditLayer.disableEdit()
              }
              this.enableCrosshair()

            })
          } else {
            this.disableEdit()
            this.disbaleCrosshair()
            L.DomUtil.removeClass(this.state.map._container, 'crosshair-cursor-enabled');
          }
          break;
        case "showPointer":
          this.selectMarkerOnMap(null)
          this.disableEdit()
          L.DomUtil.removeClass(this.state.map._container, 'crosshair-cursor-enabled');
          const { DEMShow, DTMShow, NDVIShow, RGBShow, ThreeDShow, pointCloudShow, bothShowPT, showFloors } = this.state;
          if (!DEMShow && !DTMShow && !NDVIShow && !RGBShow && !ThreeDShow && !pointCloudShow && !bothShowPT && !showFloors) {
            this.setState({ showFloors: true })
          }
          break;
        case "showOnclickPointDetails":
          this.selectMarkerOnMap(null)
          this.disableEdit().then(() => {
            L.DomUtil.addClass(this.state.map._container, 'pointer-cursor-enabled');
          })
          break;
        case "drawVolumeBox":
          this.disableEdit().then(() => {
            this.setState({
              drawVolumeBox: !this.state.drawVolumeBox
            }, () => {
              if (this.state.drawVolumeBox) {
                this.potree.current.startDrawing("VolumeBox");
              }
              else {
                this.disableEdit().then(() => {
                  this.potree.current.exitPointCloudSlicing();
                })
              }
            })
          })
          break;
        default: console.log("toggle type not valid");
      }
    })
  }

  toggleMeasurementButtons = async (keepActive,) => {
    // this will toggle active button 
    this.setState({
      selectedMeasurement: undefined,
      showSideBarLayers: keepActive === "showSideBarLayers" || false,
      drawPolygon: keepActive === "drawPolygon" ? !(this.state.drawPolygon) : false,
      drawPolyline: keepActive === "drawPolyline" ? !(this.state.drawPolyline) : false,
      drawMarker: keepActive === "drawMarker" ? !(this.state.drawMarker) : false,
      showPointer: keepActive === "showPointer" || false,
      showOnclickPointDetails: keepActive === "showOnclickPointDetails" ? !(this.state.showOnclickPointDetails) : false,
      // showMeasurements: (this.state.showMeasurements == false && (keepActive === "drawPolygon" || keepActive === "drawPolyline" || keepActive === "drawMarker")) ? true : this.state.showMeasurements,
    }, () => {
      // if ( this.state.showMeasurements) { this.showMeasurements("toggleMeasurementButtons") }
      const { drawPolygon, drawPolyline, drawMarker, showOnclickPointDetails } = this.state
      if (!(drawPolygon || drawPolyline || drawMarker || showOnclickPointDetails)) {
        this.setState({ showPointer: true }) //when all drawing mode is off then pointer is active
      }
    })
  }

  drawingEndEvent = () => {
    // after single measurement draw end this will start new draw shape
    if (this.state.drawPolygon) this.state.map.editTools.startPolygon();
    if (this.state.drawPolyline) this.state.map.editTools.startPolyline();
  }

  removeActiveEditLayer = () => {
    // this is used to remove activeEditLayer object from states
    this.setState({ activeEditLayer: undefined })
  }

  saveToGlobal = async (measurement) => {
    const updateLocalMeasurement = (data) => {
      const index = this.state.measurements.findIndex(m => m.id === measurement.id)
      this.state.measurements[index] = {
        ...measurement,
        ...data.measurement,
        task_id: data.measurement.task_id,
        plan_id: data.measurement.plan_id
      }

      const selectedMeasurement = {
        ...this.state.selectedMeasurement,
        ...data.measurement,
        show: data.measurement.plan_id ? this.state.globalMeasurementsShow : this.state.mapMeasurementsShow,
        task_id: data.measurement.task_id,
        plan_id: data.measurement.plan_id
      }
      this.setState({
        selectedMeasurement
      }, () => {
        if (this.state.drawnMeasurements?.[index]) {
          if (this.state.selectedMeasurement.show) this.state.drawnMeasurements[index].addTo(this.state.map)
          else this.state.drawnMeasurements[index].remove()
        }


        this.setState({ DisableAddGlobalMeasurement: false })
      })
    }
    if (measurement.task_id) {
      API.saveGlobalMeasurements({ ...measurement, planId: this.props.location.state.plan.id }).then((data) => {
        API.deleteMeasurement(measurement).then((dltres) => {
          updateLocalMeasurement(data)
        })
      })
    }
    else {
      API.deleteGlobalMeasurement(measurement.id).then((deleted) => {
        API.saveMeasurement({ ...measurement, taskId: this.state.orthoImageData.task_id }).then(data => {
          updateLocalMeasurement(data)
        })
      })
    }
  }

  saveMeasurement = (measurement, addedFromAnotherMachine = false) => {
    return new Promise(async (resolve, reject) => {
      if (this.state.isOwner && !addedFromAnotherMachine) {
        // this is used to save single measurement into the database if user is owner of map
        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) {

          const data = measurement.taskId ? await API.saveMeasurement(measurement) : await API.saveGlobalMeasurements({ ...measurement, planId: this.props.location.state.plan.id })

          let newMeasurement = {
            ...data.measurement,
            show: true,
          }

          resolve(newMeasurement)
          this.setState({
            measurements: [...this.state.measurements, { ...newMeasurement, compared: false }],
            globalMeasurementsShow: newMeasurement?.plan_id ? true : this.state.globalMeasurementsShow,
            mapMeasurementsShow: !(newMeasurement?.plan_id) ? true : this.state.mapMeasurementsShow,
          }, () => {
            this.validateLayersToggle()
          })
        } else resolve()
      } else {
        // this is used to save single measurement into the states only if user is not owner of map and its added by another user no need to save
        let newMeasurement = {
          ...measurement,
          show: measurement.show === false ? false : true,
          id: measurement.id || uuid()
        }
        resolve(newMeasurement)
        this.setState({
          measurements: [...this.state.measurements, { ...newMeasurement, compared: false }],
          globalMeasurementsShow: newMeasurement?.plan_id && newMeasurement.show !== false ? true : this.state.globalMeasurementsShow,
          mapMeasurementsShow: !(newMeasurement?.plan_id) && newMeasurement.show !== false ? true : this.state.mapMeasurementsShow
        }, () => {
          this.setState({
            allMeasurementsShow: this.state.globalMeasurementsShow && this.state.mapMeasurementsShow
          })
        })
      }
    })
  }

  saveLayer = async (coords, type, layer, countour, addedFromAnotherMachine) => {
    // this function is called by leaflet when drawing end
    const { map, selectedMeasurement, activeEditLayer, drawnMeasurements } = this.state
    let taskId = this.state.orthoImageData?.task_id
    // drawing end is called also when there we updating exist measurement thats why we check is there any selected measurement which is updating if yes then we dont save 
    //also we check this function is called only when draw new measurement is active

    const keysToRemove = ['2D Area', '2D Perimet', '3D Area', '3D Perimet', 'DNtype', '2D Length', '3D Length', 'desc', 'name'];
    const filteredObject = layer?.properties ? Object.fromEntries(
      Object.entries(layer.properties).filter(([key]) => !keysToRemove.includes(key))
    ) : {};

    if (!(selectedMeasurement) && activeEditLayer) {
      const measurement = {
        id: uuid(),
        name: layer.properties?.name || type,
        type: type,
        coordinates: coords,
        description: layer.properties?.descriptio || layer.properties?.desc,
        taskId: taskId,
        color: "red",
        countour: countour,
        properties: Object.keys(filteredObject).length > 0 ? filteredObject : undefined
      }
      if (!this.state.clickedPolyFromShape) layer.remove() //this will remove drawing layer , after saving it will be rendered again
      this.changedPrvShpClr()
      //removed measurement by layer.remove() is drawing again with database id 
      drawMeasurements(this.state.selectedUnit.value, this.state.toolTipShow, map, [measurement], this.measurementClicked, this.markerDragEnd, drawnMeasurements.length, this.state.permissions).then((data) => {
        //for updating local measurement array
        this.setDrawnMeasurements(data.drawnMeasurements)
      })
      this.removeActiveEditLayer()
      if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) {
        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getMeasurementsInThreed(taskId, this.state.permissions, [measurement]).then(async data => {
          this.saveMeasurement(data.measurements[0], addedFromAnotherMachine)
        }).catch(async e => {
          this.saveMeasurement(measurement, addedFromAnotherMachine)
        })


      } else {
        this.saveMeasurement(measurement, addedFromAnotherMachine)
      }
    }

  }

  update3dParameters = (selectedMeasurement, updateFromAnotherMachine) => {
    if (selectedMeasurement && selectedMeasurement.measurements) {
      const updateMeasurement = async (measurementIn3d) => {
        const updatedMeasurementStats = selectedMeasurement.type === "Polyline" ?
          [
            {
              "2D Length": getDistance(selectedMeasurement.coordinates, "m", true, !(this.getTiffAvailable()))
            },
            {
              "Elevation": this.state.selectedMeasurement?.countour ? this.state.selectedMeasurement.countour : '-'
            },
            {
              "3D Length": measurementIn3d ? await getDistanceIn3d(measurementIn3d.coordinates, "m", false) : '-'
            }
          ] : selectedMeasurement.type === "Polygon" ? [
            {
              "2D Area": getArea(selectedMeasurement.coordinates, "m", true, !(this.getTiffAvailable()))
            },
            {
              "3D Area": measurementIn3d ? await get3dPolygonArea(measurementIn3d.coordinates, 'm', false) : '-'
            },
            {
              "2D Perimeter": getDistance([...selectedMeasurement.coordinates, selectedMeasurement.coordinates[0]], "m", true, !(this.getTiffAvailable()))
            },
            {
              "3D Perimeter": measurementIn3d ? await getDistanceIn3d([...measurementIn3d.coordinates, measurementIn3d.coordinates[0]], "m", false) : '-'
            }
          ] : null
        this.setState({
          selectedMeasurement: { ...selectedMeasurement, measurements: updatedMeasurementStats },
        }, () => {
          if ((this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) && !updateFromAnotherMachine) API.updateMeasurement(measurementIn3d || selectedMeasurement);
        })
      }
      if (selectedMeasurement.is3d) updateMeasurement(selectedMeasurement);
      else if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getMeasurementsInThreed(this.state.orthoImageData.task_id, this.state.permissions, [selectedMeasurement]).then((data3d => {
        updateMeasurement(data3d.measurements[0])
      })).catch((e) => {
        updateMeasurement(false)
      })
      else updateMeasurement(false)
    }
  }

  decideMeasurementVisibility = (measurementIndex, measurement) => {
    if (!measurement.show) {
      if (!(this.state.allMeasurementsShow || (!measurement.plan_id && this.state.mapMeasurementsShow) || (measurement.plan_id && this.state.mapMeasurementsShow))) {
        this.measurementHideShow(measurementIndex, false)
      } else {

      }
    }
  }

  updateMeasurement = async (updatedMeasurement, updateFromAnotherMachine) => {
    let { measurements, drawnMeasurements, map } = this.state
    // this is used to save update measurement into the database
    const updatedIndex = measurements.findIndex(
      (measurement) => measurement.id === updatedMeasurement.id
    )
    const isShow = this.state.measurements[updatedIndex]?.show

    if (updatedIndex >= 0) {
      let altitude = 0.0
      if (updatedMeasurement.type == "Marker" && (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) && updatedMeasurement.coordinates?.lat)
        updatedMeasurement.altitude = Number(updatedMeasurement.coordinates.elevation || await this.getElevation(updatedMeasurement.coordinates, false)).toFixed(2)
      const oldMeasurementLayer = this.state.drawnMeasurements[updatedIndex]
      if (updatedMeasurement.type === "Marker") {
        if (this.getTiffAvailable() && this.state.drawnMeasurements[updatedIndex] && updatedMeasurement.coordinates?.lat) {
          this.state.drawnMeasurements[updatedIndex].setLatLng(updatedMeasurement.coordinates)
          this.updateTooltip(this.state.drawnMeasurements[updatedIndex], updatedMeasurement)
        }
        this.state.measurements[updatedIndex] = updatedMeasurement
        this.setState({ selectedMeasurement: this.state.measurements[updatedIndex], showElevationProfile: false })
        if ((this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) && !updateFromAnotherMachine) API.updateMeasurement(updatedMeasurement);
      } else {
        if (updatedMeasurement.coordinates[0].lat) {
          drawMeasurements(this.state.selectedUnit.value, this.state.toolTipShow, map, [updatedMeasurement], this.measurementClicked, this.markerDragEnd, updatedIndex, this.state.permissions).then(async (data) => {
            // this.setActiveEditLayer(newlyDrawnMeasurements[0])
            oldMeasurementLayer.remove()
            await removeExistingMeasurementTooltips(oldMeasurementLayer)
            const newlyDrawnMeasurement = data.drawnMeasurements[0]
            if (!isShow) {
              newlyDrawnMeasurement.remove()
              updatedMeasurement.show = false
            } else if (this.state.selectedMeasurement?.id === updatedMeasurement.id) {
              newlyDrawnMeasurement.enableEdit()
              this.state.activeDrawnMeasurement = newlyDrawnMeasurement
            }
            this.updateTooltip(newlyDrawnMeasurement, updatedMeasurement)
            drawnMeasurements[updatedIndex] = newlyDrawnMeasurement
            this.setState({ drawnMeasurements }, () => { })
            measurements[updatedIndex] = {
              ...updatedMeasurement,
            }
            if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) API.getMeasurementsInThreed(this.state.orthoImageData?.task_id, this.state.permissions, [measurements[updatedIndex]]).then((data3d) => {
              measurements[updatedIndex] = (data3d.measurements[0])
            })
            this.setState({
              showElevationProfile: false,
              measurements,
              selectedMeasurement: this.state.selectedMeasurement?.id === updatedMeasurement.id ? {
                ...measurements[updatedIndex],
                altitude,
                measurements: measurements[updatedIndex].type === "Polyline" ? [
                  {
                    "2D Length": getDistance(measurements[updatedIndex].coordinates, "m", true, !(this.getTiffAvailable()))
                  },
                  {
                    "3D Length": updatedMeasurement.is3d ? await getDistanceIn3d(updatedMeasurement.coordinates, "m", false) : "loading"
                  }
                ] : measurements[updatedIndex].type === "Polygon" ? [
                  {
                    "2D Area": getArea(measurements[updatedIndex].coordinates, "m", true, !(this.getTiffAvailable()))
                  },
                  {
                    "3D Area": updatedMeasurement.is3d ? await get3dPolygonArea(updatedMeasurement.coordinates, "m", false) : "loading"
                  },
                  {
                    "2D Perimeter": getDistance([...measurements[updatedIndex].coordinates, measurements[updatedIndex].coordinates[0]], "m", true, !(this.getTiffAvailable()))
                  },
                  {
                    "3D Perimeter": updatedMeasurement.is3d ? await getDistanceIn3d([...updatedMeasurement.coordinates, updatedMeasurement.coordinates[0]], "m", false) : "loading"
                  }
                ] : null
              } : this.state.selectedMeasurement
            }, () => {
              // if (updateFromAnotherMachine) this.decideMeasurementVisibility()
              if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable && !(updatedMeasurement.is3d)) this.update3dParameters(this.state.selectedMeasurement, updateFromAnotherMachine)
              else if ((this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) && !updateFromAnotherMachine) {
                if (updatedMeasurement.task_id) API.updateMeasurement(updatedMeasurement)
                else API.updateGlobalMeasurement(updatedMeasurement)
              }
            })

          })
        } else {
          this.setState({
            showElevationProfile: false,
            measurements, selectedMeasurement: {
              ...measurements[updatedIndex],
              altitude,
              measurements: measurements[updatedIndex].type === "Polyline" ? [
                {
                  "2D Length": getDistance(measurements[updatedIndex].coordinates, "m", true, !(this.getTiffAvailable()))
                },
                {
                  "3D Length": updatedMeasurement.is3d ? await getDistanceIn3d(updatedMeasurement.coordinates, "m", false) : "loading"
                }
              ] : measurements[updatedIndex].type === "Polygon" ? [
                {
                  "2D Area": getArea(measurements[updatedIndex].coordinates, "m", true, !(this.getTiffAvailable()))
                },
                {
                  "3D Area": updatedMeasurement.is3d ? await get3dPolygonArea(updatedMeasurement.coordinates, "m", false) : "loading"
                },
                {
                  "2D Perimeter": getDistance([...measurements[updatedIndex].coordinates, measurements[updatedIndex].coordinates[0]], "m", true, !(this.getTiffAvailable()))
                },
                {
                  "3D Perimeter": updatedMeasurement.is3d ? await getDistanceIn3d([...updatedMeasurement.coordinates, updatedMeasurement.coordinates[0]], "m", false) : "loading"
                }
              ] : null
            }
          }, () => {
            if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable && !(updatedMeasurement.is3d)) this.update3dParameters(this.state.selectedMeasurement)
            else if (this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) API.updateMeasurement(updatedMeasurement);
          })
        }
      }
    }
  }

  updateLayer = (coords, type, layer) => {
    //this function is fired after vertex dragged and for rectangle and circle if user create new rectangle and circle we have to save it instead of update
    //if there is no any selected measurement present in the states thats mean user created new rectangle or circle if present we have to update selected rectangle or circle
    // if user drag vertex of polyline and polygon when drawing new layer we have to ignore it
    if (!this.state.selectedMeasurement) {
      if (type === "Circle") {
        this.saveLayer(coords, type, layer)
      }
    } else {
      // existing measurement update
      const { map, selectedMeasurement, drawnMeasurements } = this.state
      let measurement = {
        ...selectedMeasurement,
        is3d: false,
        measurements: undefined,
        coordinates: coords,
        stats: null,
        cut_volume: null,
        fill_volume: null,
        volume: null,
        calc_method: null
      }
      this.updateMeasurement(measurement)
    }
  }

  saveMeasurementDetails = (measurement) => {
    let { measurements, selectedMeasurement } = this.state
    const updatedIndex = measurements.findIndex(
      (measurement) => measurement.id === selectedMeasurement.id
    )
    measurements[updatedIndex] = measurement
    this.setState({
      measurements
    })
    if (this.state.drawnMeasurements[updatedIndex]) this.updateTooltip(this.state.drawnMeasurements[updatedIndex], measurement)
    if (this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) {
      if (measurement.task_id) API.updateMeasurement(measurement).then(result => this.setState({ saveNameState: false, saveDesState: false }));
      else API.updateGlobalMeasurement(measurement).then(result => this.setState({ saveNameState: false, saveDesState: false }));
    }
  }

  updateMeasurementDetails = (temp1) => {
    let { measurements, selectedMeasurement } = this.state
    if (this.state.mentionMessage) selectedMeasurement.description = this.state.mentionValue
    // this is used to save update measurement into the database
    let measurement = {
      ...selectedMeasurement,
      measurements: undefined,
    }

    let temp = measurement.name.trim()
    if (temp1) {
      this.setState({
        saveDesState: true,
        mentionMessage: undefined,
      })
      this.saveMeasurementDetails(measurement)
    } else {
      if (temp.length > 0) {
        this.setState({
          saveNameState: true,
        })
        this.saveMeasurementDetails(measurement)
      } else {
        this.setState({
          textboxValid: false,
          errorMsg: "Shape name cannot be empty."
        })
      }
    }


  }

  deleteMeasurement = async (deletedMeasurementFromAnotherMachineId) => {
    let { measurements, selectedMeasurement, drawnMeasurements } = this.state
    // this is used to delete measurement from database
    const deletedMeasurementIndex = measurements.findIndex(
      (measurement) => measurement.id === (deletedMeasurementFromAnotherMachineId || selectedMeasurement.id)
    )
    //if user in 3d view remove it from 3d view scene
    if (this.potree.current) this.potree.current.setMeasurementVisibility(this.state.selectedMeasurement.id, false)
    if (drawnMeasurements[deletedMeasurementIndex]) {
      drawnMeasurements[deletedMeasurementIndex].remove()
      await removeExistingMeasurementTooltips(drawnMeasurements[deletedMeasurementIndex])
      drawnMeasurements.splice(deletedMeasurementIndex, 1)
    }
    measurements.splice(deletedMeasurementIndex, 1);

    this.setState({
      showElevationProfile: deletedMeasurementFromAnotherMachineId ? this.state.showElevationProfile : false,
      sidebarPanel: deletedMeasurementFromAnotherMachineId ? this.state.sidebarPanel : false,
      measurements,
      drawnMeasurements,
      selectedMeasurement: deletedMeasurementFromAnotherMachineId ? this.state.selectedMeasurement : undefined
    },)

    if ((this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DELETE) && !deletedMeasurementFromAnotherMachineId) {
      if (selectedMeasurement.task_id) API.deleteMeasurement(selectedMeasurement)
      else API.deleteGlobalMeasurement(selectedMeasurement.id)
    }

  }

  setDrawnMeasurements = (newlyDrawnMeasurements) => {
    // this is used to maintain local drawn measurements array
    const { drawnMeasurements } = this.state
    if (drawnMeasurements.length > 0) {
      this.setState({
        drawnMeasurements: [
          ...drawnMeasurements,
          ...newlyDrawnMeasurements
        ]
      })
    } else {
      this.setState({
        drawnMeasurements: newlyDrawnMeasurements
      })
    }
  }

  handleMapClick = async (event) => {
    this.managePopup("minimizedFloorPlanningViewer")
    let clickedPoint = this.state.map.mouseEventToLatLng(event.originalEvent)
    if (this.state.drawMarker) {
      //this is used to draw marker
      let taskId = this.state.orthoImageData?.task_id
      let measurement = {
        id: uuid(),
        name: "Marker",
        type: "Marker",
        coordinates: clickedPoint,
        description: null,
        taskId: taskId,
        is3d: false,
        color: "red"
      }
      drawMeasurements(this.state.selectedUnit.value, this.state.toolTipShow, this.state.map, [measurement], this.measurementClicked, this.markerDragEnd, this.state.drawnMeasurements.length, this.state.permissions).then((data) => {
        // this.setActiveEditLayer(newlyDrawnMeasurements[0])
        this.setDrawnMeasurements([data.drawnMeasurements[0]])
        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) {
          if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) API.getMeasurementsInThreed(taskId, this.state.permissions, [measurement]).then((data3d) => {
            this.saveMeasurement(data3d.measurements[0])
          }).catch(e => {
            this.saveMeasurement(measurement)
          })
          else this.saveMeasurement(measurement)
        }

      })
    } else if (this.state.showOnclickPointDetails) {
      await this.addPointClickPopup(clickedPoint)
    }
  }

  addPointClickPopup = async (clickedPoint) => {
    let { user, orthoImageData, map, processTileIndex, DSMAvailable, NDVIShow } = this.state
    let ndviIndexCalculating = NDVIShow ? `<div>${processTileIndex == 'NDVI (Blue)' ? 'NDVI(B)' : processTileIndex}  : Calculating... </div>` : ''
    let elevationCalculating = DSMAvailable && DSMAvailable !== NotSelected ? `<br><img src=${elevation} height='12px' width='12px' style='margin-right:3px;'></img>Calculating...` : ''
    var elevationData = null
    if (this.state.onclickMarker)
      this.state.onclickMarker.remove()
    let task_id = this.state.orthoImageData.task_id
    let copyText = clickedPoint.lat.toFixed(8) + ', ' + clickedPoint.lng.toFixed(8)
    var p = new L.Popup({ direction: "top", offset: [2, 13], permanent: true, interactive: true }).setContent(
      `<img src=${markerInactive} height='12px' width='12px' style='margin-right:3px;'></img>${Number(clickedPoint.lat).toFixed(8)} , ${Number(clickedPoint.lng).toFixed(8)}`
      + elevationCalculating + ndviIndexCalculating + `${(!DSMAvailable || DSMAvailable === NotSelected) && !NDVIShow ?
        `<img style='cursor:pointer; margin-left:5px' onclick='document.getElementById("copy").click()' src=${CopyIcon} height='12px' width='12px'></img>` : ''}`
    ).setLatLng([clickedPoint.lat, clickedPoint.lng])
    p.addTo(map)
    this.setState({ onclickMarker: p, clickedPoint, copyText })
    let data = { lat: clickedPoint.lat, lng: clickedPoint.lng }
    if (DSMAvailable && DSMAvailable !== NotSelected) {
      elevationData = await this.getElevation(data, true)
      let copyText = clickedPoint.lat.toFixed(8) + ', ' + clickedPoint.lng.toFixed(8) + `${elevationData == 'NA' ? '' : `, ${elevationData}`}`
      this.setState({ copyText })
      this.state.onclickMarker.setContent(
        `<img src=${markerInactive} height='12px' width='12px' style='margin-right:3px;'></img>${Number(clickedPoint.lat).toFixed(8)} , ${Number(clickedPoint.lng).toFixed(8)}
       ${this.state.DSMAvailable && this.state.DSMAvailable !== NotSelected ?
          `<div style='display: flex; width: 100%; justify-content: space-between;'>
            <div>
              <img src=${elevation} height='12px' width='12px' style='margin-right:3px;'></img>${elevationData}
            </div>
            <div>
            ${NDVIShow ? '' : `<img style='cursor:pointer;' onclick='document.getElementById("copy").click()' src=${CopyIcon} height='12px' width='12px'></img>`}
            </div>
          </div>` : <></>
        }
        ${ndviIndexCalculating}  
        `).setLatLng([clickedPoint.lat, clickedPoint.lng])
    }
    if (NDVIShow) {
      var indexData = await this.getIndex(data)
      let copyText = clickedPoint.lat.toFixed(8) + ', ' + clickedPoint.lng.toFixed(8) + `${elevationData == 'NA' ? '' : `, ${elevationData}`}` + `${indexData == 'NA' ? '' : processTileIndex == ', NDVI (Blue)' ? 'NDVI(B)' : `, ${processTileIndex} : ${indexData}`}`
      this.setState({ copyText })
      this.state.onclickMarker.setContent(
        `<img src=${markerInactive} height='12px' width='12px' style='margin-right:3px;'></img>${Number(clickedPoint.lat).toFixed(8)} , ${Number(clickedPoint.lng).toFixed(8)}
         ${!DSMAvailable || DSMAvailable === NotSelected ? '' : `<div><img src=${elevation} height='12px' width='12px' style='margin-right:3px;'></img>${elevationData ? elevationData : this.state.DSMAvailable != NotSelected && this.state.DSMAvailable ? 'Calculating...' : 'NA'}</div>`}
          <div style='display: flex; width: 100%; justify-content: space-between;'>
            <div>${processTileIndex == 'NDVI (Blue)' ? 'NDVI(B)' : processTileIndex} : ${indexData}</div>
            <div>
              <img style='cursor:pointer;' onclick='document.getElementById("copy").click()' src=${CopyIcon} height='12px' width='12px'></img>
            </div>
          </div>
      `).setLatLng([clickedPoint.lat, clickedPoint.lng])
    }
  }

  getIndex = (data) => {
    return new Promise((resolve, reject) => {
      let { user, orthoImageData, processTileIndex, algoMax, algoMin } = this.state
      let task_id = this.state.orthoImageData.task_id
      let dataObj = { task_id, blob_container: this.state.permissions.container, sas_token: this.state.permissions.st, lat: data.lat, lng: data.lng, algorithm: processTileIndex, min: algoMin, max: algoMax }
      if (this.state.permissions[DRONENAKSHA_FEATURES.REPORTS].READ) API.getPlantHealthIndexOfPoint(dataObj).then(result => {
        let indexData = result.index !== undefined && result.index != 'NA' ? result.index.toFixed(4) : 'NA'
        resolve(indexData)
      })
    })
  }

  getElevation = (data, unit) => {
    return new Promise((resolve, reject) => {
      let { user, orthoImageData } = this.state
      let task_id = this.state.orthoImageData.task_id
      let dataObj = { task_id, blob_container: this.state.permissions.container, sas_token: this.state.permissions.st, lat: data.lat, lng: data.lng }
      if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getElevationOfPoint(dataObj).then(result => {
        let elevationData = result.elevation && result.elevation != 'NA' ? unit ? this.state.selectedUnit.value == 'm' ? `${result.elevation.toFixed(2)} m` : `${(result.elevation * 3.28084).toFixed(2)} ft` : result.elevation.toFixed(2) : 'NA'
        resolve(elevationData)
      })
    })
  }

  selectMarkerOnMap = (selectedIndex) => {
    this.state.measurements.map((m, index) => {
      if (m.type === "Marker") {
        if (selectedIndex === index && m.coordinates.lat && this.state.drawnMeasurements[selectedIndex] && !this.state.showOnclickPointDetails) {
          this.state.drawnMeasurements[selectedIndex].setIcon(new L.Icon({ iconUrl: selectedMarker, iconSize: [30, 30], iconAnchor: [15, 30] }))
        }
        else if (this.state.drawnMeasurements[index]?.setIcon && m.coordinates.lat) {
          this.state.drawnMeasurements[index].setIcon(new L.Icon({ iconUrl: MarkerIcon, iconSize: [20, 28], iconAnchor: [10, 28] }))
        }
      }
    })
  }

  markerDragEnd = async (id, coords) => {
    if (this.state.showOnclickPointDetails) return;
    const { selectedMeasurement, measurements } = this.state
    const index = measurements.findIndex(m => m.id === id)
    let measurement = {
      ...measurements[index],
      is3d: false,
      coordinates: coords,
    }
    this.selectMarkerOnMap(index)
    const setTostate = (measuerement3d) => {
      measurements[index] = measuerement3d || measurement
      this.setState({
        measurements, selectedMeasurement: measuerement3d || measurement
      })
      if (this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) {
        if (measuerement3d.task_id || measurement.task_id) API.updateMeasurement(measuerement3d || measurement);
        else API.updateGlobalMeasurement(measuerement3d || measurement)
      }
    }
    if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) {
      if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getMeasurementsInThreed(this.state.orthoImageData.task_id, this.state.permissions, [measurement]).then((data3d) => {
        setTostate({ ...data3d.measurements[0], altitude: data3d.measurements[0].coordinates.elevation.toFixed(2) })
      }).catch(e => {
        setTostate(false)
      })
    } else {
      setTostate(false)
    }

  }

  handleMoveStart = (event) => {
    this.managePopup("minimizedFloorPlanningViewer")
  }

  measurementClicked = async (id, clickedFrom3dScene) => {
    this.setState({ measurementFromNotification: false }, async () => {
      if (!(this.state.compare)) { this.toggleSidepanelData(activeSidebarMeasurement) }

      if (this.state.showPointer) {
        await this.changedPrvShpClr()
        this.setState({
          clickedPolyFromShape: undefined,
          textboxValid: true,
          errorMsg: "",
        })
        const { measurements, drawnMeasurements } = this.state
        const index = measurements.findIndex(m => m.id === id)
        if (measurements[index]) this.setState({ isRegionInOrtho: this.isRegionInsideImageBounds(measurements[index]?.coordinates?.[0] ? measurements[index].coordinates : [measurements[index].coordinates]) })
        let altitude = 0.0
        if (measurements[index]) {
          if (measurements[index].type === "Marker") {
            this.selectMarkerOnMap(index)

            if (this.potree.current) this.potree.current.indicateMarkerInScene(measurements[index].id)
            if (this.state.updatingExisting)
              this.state.updatingExisting.disableEdit();
            if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable)
              altitude = (measurements[index].coordinates.elevation || await this.getElevation({ lat: measurements[index].coordinates.lat, lng: measurements[index].coordinates.lng }, false))
          }//when we clicked on marker previously clickd polygon polyline not editing not disabling thats why we disable it manually
          else this.selectMarkerOnMap(null);
          let measurement = {
            ...measurements[index],
            altitude: Number(altitude).toFixed(2),
            measurements: measurements[index].type === "Polyline" ?
              [
                {
                  "2D Length": getDistance(measurements[index].coordinates, "m", true, !(this.getTiffAvailable() && measurements[index].coordinates[0].lat))
                },
                {
                  "3D Length": await getDistanceIn3d(measurements[index].coordinates, "m", false)
                },
              ] : measurements[index].type === "Polygon" ? [
                {
                  "2D Area": getArea(measurements[index].coordinates, "m", true, !(this.getTiffAvailable() && measurements[index].coordinates[0].lat))
                },
                {
                  "3D Area": await get3dPolygonArea(measurements[index].coordinates, 'm', false)
                },
                {
                  "2D Perimeter": getDistance([...measurements[index].coordinates, measurements[index].coordinates[0]], "m", true, !(this.getTiffAvailable() && measurements[index].coordinates[0].lat))
                },
                {
                  "3D Perimeter": await getDistanceIn3d([...measurements[index].coordinates, measurements[index].coordinates[0]], "m", false)
                }
              ] : null
          }
          if (measurements[index].type === "Polyline" && measurements[index]?.countour) {
            let elv = { "Elevation": measurements[index]?.countour }
            measurement.measurements.push(elv)
          }
          this.setState({
            selectedMeasurement: measurement,
            activeDrawnMeasurement: this.state.drawnMeasurements[index],
            calculationMethod: measurement.calc_method ? measurement.calc_method : "fit_plane",
            showElevationProfile: false,
            mentionValue: measurement.description || ""
          }, () => {
            if (this.potree.current && !clickedFrom3dScene) this.potree.current.selectMeasurement(this.state.selectedMeasurement.id)
            if (this.state.measurements[index].show && measurements[index].type !== "Marker" && this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) {
              if (this.state.drawnMeasurements[index] && this.state.measurements[index]?.coordinates[0]?.lat) {
                if (this.state.map.hasLayer(this.state.drawnMeasurements[index])) this.state.drawnMeasurements[index].enableEdit()
              }
            }
          })
        }
      }
    })
  }

  setActiveEditLayer = (activeEditLayer) => {
    if (this.state.drawPolygon || this.state.drawPolyline) {
      this.setState({ activeEditLayer })
    } else {
      this.setState({ updatingExisting: activeEditLayer })
    }
  }

  validateLayersToggle = () => {
    this.setState({
      mapMeasurementsShow: !(this.state.measurements.some(mes => mes.show === false && mes.task_id && !(mes.plan_id))),
      globalMeasurementsShow: !(this.state.measurements.some(mes => mes.show === false && mes.plan_id && !(mes.task_id))),
    }, () => {
      this.setState({
        allMeasurementsShow: this.state.mapMeasurementsShow && this.state.globalMeasurementsShow,
      })
    })
  }

  measurementHideShow = (index, show) => {
    //this is used to show/hide threed measurement
    if (this.potree.current && this.state.measurements[index]) this.potree.current.setMeasurementVisibility(this.state.measurements[index].id, show);
    //--------//

    this.setState({
      textboxValid: true,
      errorMsg: ""
    })
    let { measurements, drawnMeasurements } = this.state
    toggleMeasurementLabels(show && drawnMeasurements[index], drawnMeasurements[index], this.state.map, this.state.selectedUnit.value, measurements[index])
    if (show && drawnMeasurements[index]) {
      this.state.map.addLayer(drawnMeasurements[index])
      measurements[index].show = true
      this.setState({
        measurements
      }, this.validateLayersToggle)

    } else if (drawnMeasurements[index]) {
      drawnMeasurements[index].remove()
      measurements[index].show = false
      this.setState({
        measurements
      }, this.validateLayersToggle)
    }
  }
  //.........................leaflet end.................................
  addDNReport = () => {
    let { processTileIndex, processTileType, processTileMin, processTileMax } = this.state
    let report_type = 'PLANTHEALTH'
    this.setState((state) => ({
      ...state,
      reportLoader: true
    }), () => {
      if (this.state.permissions[DRONENAKSHA_FEATURES.REPORTS].EDIT) API.addDNReport(this.state.orthoImageData.task_id, processTileIndex, processTileType, processTileMin, processTileMax, report_type).then((data) => {
        let reportStatus = data.status
        if (reportStatus == 201) {
          this.setState((state) => ({
            ...state,
            reportMsg: "Added to report.",
            reportMsgColor: 'green',
            reportLoader: false
          }), () => {
            setTimeout(() => {
              this.setState((state) => ({
                ...state,
                reportMsg: undefined
              }))
            }, 1000)
          })
        } else if (reportStatus == 409) {
          this.setState((state) => ({
            ...state,
            reportMsg: "Already added.",
            reportMsgColor: 'red',
            reportLoader: false
          }), () => {
            setTimeout(() => {
              this.setState((state) => ({
                ...state,
                reportMsg: undefined
              }))
            }, 1000)
          })
        } else {
          this.setState((state) => ({
            ...state,
            reportMsg: "Something went wrong.",
            reportMsgColor: 'red',
            reportLoader: false
          }), () => {
            setTimeout(() => {
              this.setState((state) => ({
                ...state,
                reportMsg: undefined
              }))
            }, 1000)
          })
        }

      })
    })

  }

  closeActivityPopup = () => {
    this.setState((state) => ({
      ...state,
      showProcessPopup: false,
      processMessage: null
    }))
  }

  zoomIn = () => {
    if (this.state.scale < 15) {
      var myImg = document.getElementById("action-image")
      var currWidth = myImg.clientWidth;
      var currHeight = myImg.clientHeight;
      myImg.style.width = (currWidth + 100) + "px";
      this.setState((state) => ({
        ...state,
        scale: this.state.scale + 1
      }))
      myImg.style.height = (currHeight + 100) + "px";
    }
  }

  zoomOut = () => {
    if (this.state.scale != 0) {
      var myImg = document.getElementById("action-image")
      var currWidth = myImg.clientWidth;
      var currHeight = myImg.clientHeight;
      this.setState((state) => ({
        ...state,
        scale: this.state.scale - 1
      }))
      myImg.style.width = (currWidth - 100) + "px";
      myImg.style.height = (currHeight - 100) + "px";
    }

  }

  updateDataAsPerUnit = () => {
    let { drawnMeasurements, measurements, elevationData, showElevationProfile, showOnclickPointDetails, clickedPoint } = this.state
    if (showElevationProfile) {
      let graphData = this.getElevationData(elevationData)
      this.setState({ graphData })
    }
    if (showOnclickPointDetails)
      this.addPointClickPopup(clickedPoint)
    for (let i = 0; i < drawnMeasurements.length; i++) {
      if (measurements[i].type !== "Marker" && drawnMeasurements[i])
        this.updateTooltip(drawnMeasurements[i], measurements[i])
    }
  }

  openImage = (idx) => {
    this.setState((state) => ({
      ...state,
      Idx: idx,
      imageLoad: true,
      scale: 0,

    }), () => {
      this.loadTiffImageSrc(idx)
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '.popup-content {width: 800px !important; border-radius:15px;}';
      document.getElementsByTagName('head')[0].appendChild(style);
      document.getElementById("view-image-popup-button").click()
    })
  }

  getImageCollections = () => {
    if (this.state.permissions[DRONENAKSHA_FEATURES.IMAGECOLLECTIONS].READ)
      API.getImageCollections(this.state.project.id, this.state.plan.id).then((data) => {
        this.setState((state) => ({
          ...state,
          collections: data.collections ? data.collections : [],
          loading: false
        }))
      }, (e) => {
        console.log(e);
        this.setState((state) => ({
          ...state,
          loading: false
        }))
      })
    else this.setState((state) => ({
      ...state,
      loading: false
    }))
  }

  // function to load tiff thumbnails
  loadTiff = async () => {
    let { collections, user } = this.state
    var thumbURL = []
    for (let i = 0; i < this.state.collections.length; i++) {
      if (collections[i].file && collections[i].file.file_name && collections[i].file.file_name != undefined) {
        let name = collections[i].file.file_name.toLowerCase()
        let turl = `${BLOB_URL}/${this.state.permissions.container}/FlightImages/collection-${collections[i].id}/thumb-${collections[i].file.file_name}?${this.state.permissions.st}`
        thumbURL[i] = turl
        this.setState((state) => ({
          ...state,
          thumbURLs: thumbURL,
        }))
      }
    }
  }

  // function to load tiff thumbnails
  loadImageTiff = async () => {
    let { images, user } = this.state
    var imageURL = []
    for (let i = 0; i < this.state.images.length; i++) {
      if (images[i].file_name) {
        let name = images[i].file_name.toLowerCase()
        // if ((name.indexOf(".tif")) == -1) {
        let turl = `${BLOB_URL}/${this.state.permissions.container}/FlightImages/collection-${this.state.orthoImageData.collection_id}/thumb-${images[i].file_name}?${this.state.permissions.st}`
        imageURL[i] = turl
        this.setState((state) => ({
          ...state,
          imageURLs: imageURL,
        }))
        // } else {
        //   // for thumbnails
        //   var xhr = new XMLHttpRequest();
        //   xhr.responseType = 'arraybuffer';
        //   let url = `${BLOB_URL}/${this.state.permissions.container}/FlightImages/collection-${this.state.orthoImageData.collection_id}/thumb-${images[i].file_name}?${this.state.sasToken}`
        //   xhr.open('GET', url);
        //   xhr.onload = await function (e) {
        //     var arraybuffer = e.target.response
        //     Tiff.initialize({
        //       TOTAL_MEMORY: 16777216 * 10
        //     });
        //     var tiff = new Tiff({
        //       buffer: arraybuffer
        //     })
        //     var dataUrl = tiff.toDataURL();
        //     let url = e.target.responseURL
        //     var index = 0
        //     this.state.images.map((image, j) => {
        //       if (url.indexOf(encodeURIComponent(image.file_name)) != -1) {
        //         index = j
        //       }
        //     })
        //     imageURL[index] = dataUrl   // to insert url at specific position
        //     this.setState((state) => ({
        //       ...state,
        //       imageURLs: imageURL,
        //     }))
        //   }.bind(this);
        //   xhr.send()
        // }
      }
    }
  }

  // to load tiff image
  loadTiffImageSrc = (i) => {
    let { images, user } = this.state
    var imageURL = ""
    if (images[i].file_name) {
      let name = images[i].file_name.toLowerCase()
      if ((name.indexOf(".tif")) == -1) {
        let iurl = `${BLOB_URL}/${this.state.permissions.container}/FlightImages/collection-${this.state.orthoImageData.collection_id}/${images[i].file_name}?${this.state.permissions.st}`
        imageURL = iurl
        this.setState((state) => ({
          ...state,
          tiffSrc: imageURL,
        }))
      } else {
        // for image
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'arraybuffer';
        let url = `${BLOB_URL}/${this.state.permissions.container}/FlightImages/collection-${this.state.orthoImageData.collection_id}/${images[i].file_name}?${this.state.permissions.st}`
        xhr.open('GET', url);
        xhr.onload = function (e) {
          var arraybuffer = e.target.response
          Tiff.initialize({
            TOTAL_MEMORY: 16777216 * 10
          });
          var tiff = new Tiff({
            buffer: arraybuffer
          })
          var dataUrl = tiff.toDataURL();
          let url = e.target.responseURL
          var index = 0
          this.state.images.map((image, j) => {
            if (url.indexOf(encodeURIComponent(image.file_name)) != -1) {
              index = j
            }
          })
          imageURL = dataUrl   // to insert url at specific position
          this.setState((state) => ({
            ...state,
            tiffSrc: imageURL,
          }))
        }.bind(this);
        xhr.send()
      }
    }
  }

  downloadActiveLayer = (type) => {
    if (this.state.orthoImageData) {
      if (type === 'ortho') {
        // let url = this.state.orthoImageData.image_url
        let url = `${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData.task_id}/orthomosaic.tif?${this.state.permissions.st}`
        // let fileName = this.state.orthoImageData.task_name
        // let extension = url.split('.').reverse()[0]
        window.open(`${url}`, "_blank")
      }
      if (type === 'ndvi') {
        this.setState((state) => ({
          ...state,
          showAddImagePopup: false,
          itemName: "Layer",
          processPopupIcon: "WAIT",
          processAction: "WAIT",
          processMessage: "Downloading Layer, Please Wait...",
          showProcessPopup: true,
        }))
        this.updateHistogram().then(() => {
          let taskId = this.state.orthoImageData.task_id
          let name = this.state.orthoImageData.task_name
          let { processTileIndex, processTileType, processTileMin, processTileMax, user } = this.state
          let sas = encodeURIComponent(this.state.permissions.st)
          let blobContainer = this.state.permissions.container
          let algorithm = processTileIndex
          if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) API.downloadNDVIImage({ taskId, algorithm, processTileType, processTileMin, processTileMax, name, sas, blobContainer })
            .then((data) => {
              this.setState({
                showProcessPopup: false,
              })
            })
            .catch((data) => {
              this.setState((state) => ({
                ...state,
                itemName: "Layer",
                processPopupIcon: "ERROR",
                processAction: "COMPLETE",
                processMessage: "Error occured while downloading layer",
                showProcessPopup: true,
              }))
            })

        })
      }
      if (type === 'dem') {
        // let url = this.state.orthoImageData.image_url.replace("orthomosaic.", "dem.")
        let url = `${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData.task_id}/dem.tif?${this.state.permissions.st}`;
        // let fileName = this.state.orthoImageData.task_name
        // let extension = url.split('.').reverse()[0]
        window.open(`${url}`, "_blank")
      }
      if (type === 'dtm') {
        // let url = this.state.orthoImageData.image_url.replace("orthomosaic.", "dtm.")
        let url = `${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData.task_id}/dtm.tif?${this.state.permissions.st}`
        // let fileName = this.state.orthoImageData.task_name
        // let extension = url.split('.').reverse()[0]
        window.open(`${url}`, "_blank")
      }
    }
  };

  //Color picker toggle function
  toggleColorPicker = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  //get teams and team related function start which now only passed for edit plan and get plan after 
  //get logged in user team

  getOwnerTeam = (teams) => {
    return new Promise((resolve, reject) => {
      let { user } = this.state
      teams.map(team => {
        if (user.userid == team.owner_id) {
          resolve(team)
        }
      })
    })
  }

  switchBaseLayer = () => {
    const { map1 } = this.state
    this.setState({ activeBaseLayer: this.state.activeBaseLayer == "satelite" ? "terrain" : "satelite" }, () => {
      this.state.baseLayer.setUrl(this.state.activeBaseLayer === "satelite" ? MAP_URLS.SATELITE : MAP_URLS.ROAD_MAP)
    })
  }

  setBaseLayerToState = (baseLayer) => {
    this.setState({ baseLayer })
    // alert("tata")
  }

  compareSlider = () => {
    const { selectedLayer1, selectedLayer2, map, processTileIndex, processTileType, processTileMin, processTileMax, leftLayer, rightLayer, compareControl } = this.state
    this.removeLayer("orthoLayer").then(() => {
      let taskid1 = this.state.orthoImageData.task_id
      let taskid2 = this.state.orthoImageData1.task_id
      let blobContainer = this.state.permissions.container;
      let sas = encodeURIComponent(this.state.permissions.st);
      let bounds = [[this.state.bounds[1], this.state.bounds[0]], [this.state.bounds[3], this.state.bounds[2]]]
      let bounds1 = [[this.state.bounds1[1], this.state.bounds1[0]], [this.state.bounds1[3], this.state.bounds1[2]]]
      let type1 = selectedLayer1 == "pointCloud" || selectedLayer1 == "threeD" ? (this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable ? 'orthomosaic' : this.state.DSMAvailable != NotSelected && this.state.DSMAvailable ? 'dem' : 'dtm') : selectedLayer1
      let type2 = selectedLayer2 == "pointCloud" || selectedLayer2 == "threeD" ? (this.state.OrthomosaicAvailable1 ? 'orthomosaic' : this.state.DSMAvailable1 ? 'dem' : 'dtm') : selectedLayer2
      let bandsSelection = `${this.state.RGBShow && !(this.state.defaultOrtho) ? `&bands=${this.state.band1},${this.state.band2},${this.state.band3}` : "&viewDefault=true"}`
      let leftLayerPath = selectedLayer1 == "orthomosaic" || selectedLayer1 == "dem" || selectedLayer1 == "dtm" ? `${tilesServer}/tiles/${taskid1}/${type1}/{z}/{x}/{y}.png?sas=${sas}&blobContainer=${blobContainer}${bandsSelection}` :
        `${tilesServer}/tiles/${taskid1}/${type1}/{z}/{x}/{y}.png?sas=${sas}&blobContainer=${blobContainer}&algorithm=${processTileIndex}&min=${processTileMin}&max=${processTileMax}&filterType=${processTileType}`

      let rightLayerPath = selectedLayer2 == "orthomosaic" || selectedLayer2 == "dem" || selectedLayer2 == "dtm" ? `${tilesServer}/tiles/${taskid2}/${type2}/{z}/{x}/{y}.png?sas=${sas}&blobContainer=${blobContainer}${bandsSelection}` :
        `${tilesServer}/tiles/${taskid2}/${type2}/{z}/{x}/{y}.png?sas=${sas}&blobContainer=${blobContainer}&algorithm=${processTileIndex}&min=${processTileMin}&max=${processTileMax}&filterType=${processTileType}`

      if (compareControl) {
        if (selectedLayer1 != "base") {
          leftLayer.setUrl(leftLayerPath, false).setOpacity(1)
        }
        else leftLayer.setOpacity(0)

        if (selectedLayer2 != "base") {
          rightLayer.setUrl(rightLayerPath, false).setOpacity(1)
        }
        else rightLayer.setOpacity(0)
      } else {
        let leftLayer = L.tileLayer(
          leftLayerPath
          , {
            minZoom: 1,
            maxZoom: 25,
            bounds: bounds
          }).addTo(map);

        let rightLayer = L.tileLayer(
          rightLayerPath,
          {
            minZoom: 1,
            maxZoom: 25,
            bounds: bounds1
          }).addTo(map);

        let compareControl = L.control.sideBySide(leftLayer, rightLayer)
        compareControl.addTo(map)
        this.setState({ leftLayer, rightLayer, compareControl })
      }
    })
      .catch((error) => {
        console.log("Error :", error)
      })
  }

  compareFunction = async () => {
    this.checkDataAvailable1().then(async () => {
      await this.getTilesBounds1(this.state.OrthomosaicAvailable1 ? 'orthomosaic' : this.state.DSMAvailable1 ? 'dem' : 'dtm')
      this.managePopup()
      this.setState((state) => ({
        ...state,
        planShow: false,
        compare: true,
        inspectShow: false,
        selectedLayer1: this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable ? 'orthomosaic'
          : this.state.DSMAvailable != NotSelected && this.state.DSMAvailable ? 'dem'
            : this.state.DTMAvailable != NotSelected && this.state.DTMAvailable ? 'dtm' : 'base',
        selectedLayer2: this.state.OrthomosaicAvailable1 ? 'orthomosaic' : this.state.DSMAvailable1 ? 'dem' : this.state.DTMAvailable1 ? 'dtm' : 'base'
      }), () => {
        this.compareSlider()
        this.inspectImages()
      })
    })
  }

  updateHistogram = async () => {
    return new Promise((resolve, reject) => {
      this.setState({ imageAnalysisLoader: true })
      let taskId = this.state.orthoImageData.task_id
      let { processTileIndex, processTileType, processTileMin, processTileMax, user } = this.state
      let sas = encodeURIComponent(this.state.permissions.st)
      let blobContainer = this.state.permissions.container
      let algorithm = processTileIndex
      if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getHistogram({ taskId, algorithm, processTileType: processTileType ? processTileType : "RGB", processTileMin, processTileMax, sas, blobContainer }).then((data) => {
        this.setState((state) => ({
          ...state,
          utmDetails: utm.convertLatLngToUtm(data.bounds[1], data.bounds[0], 10),
          reportMsg: undefined,
          algoMin: data.statistics[1].min.toFixed(4),
          algoMax: data.statistics[1].max.toFixed(4),
          statistics: data.statistics,
          algorithms: data.algorithms,
          bounds: data.bounds,
          bandsList: data.band_descriptions,
          tileMinZoom: data.minzoom - ZOOM_EXTRA_LEVELS,
          tileMaxZoom: data.maxzoom + ZOOM_EXTRA_LEVELS,
          tilesBounds: data.tilesBounds,
          processTileMin: data.statistics[1].percentiles[0].toFixed(4),
          processTileMax: data.statistics[1].percentiles[1].toFixed(4),
          processTileIndex: this.state.processTileIndexNum >= 0 ? data.algorithms[this.state.processTileIndexNum].id : data.algorithms[0].id,
          activeProcessTileType: this.state.processTileIndexNum >= 0 ? data.algorithms[this.state.processTileIndexNum].filters : data.algorithms[0].filters,
          processTileIndexNum: this.state.processTileIndexNum >= 0 ? this.state.processTileIndexNum : 0,
          processTileType: processTileType ? this.state.processTileType : data.algorithms[0].filters[0]
        }), () => {
          this.setSelectComponentData()
          var algorithms = []
          this.state.algorithms.forEach((alg, key) => {
            algorithms.push([{ value: alg.id, label: key }])
          })
          var filters = []
          var selectedFilter = []
          this.state.activeProcessTileType.forEach((t) => {
            filters.push([{ value: t, label: t }])
            if (this.state.processTileType == t)
              selectedFilter = [{ value: t }]
          })
          this.setState({
            selectFilters: filters.flat(),
            selectAlgorithms: algorithms.flat(),
            selectedAlgorithm: algorithms[this.state.processTileIndexNum ? this.state.processTileIndexNum : 0],
            selectedFilter: selectedFilter.length > 0 ? selectedFilter : filters[0],
            imageAnalysisLoader: false,
            mapDataLoaded: true
          })
          resolve(true)
        })
      })
        .catch(error => {
          reject();
        })

    })
  }

  setSelectComponentData = () => {
    var selectBandsList = []
    if (this.state.bandsList && this.state.bandsList.length > 0) {
      this.state.bandsList.forEach((band) => {
        selectBandsList.push([{ value: band[0], label: band[1] == "" ? band[0] : (band[1]).toUpperCase() }])
      })
      this.setState({
        selectBandsList: selectBandsList.flat(),
        selectedBand1: selectBandsList[0],
        selectedBand2: selectBandsList[1],
        selectedBand3: selectBandsList[2],
      })
    }
  }

  getTilesBounds = async (tiffModelType) => {
    return new Promise((resolve, reject) => {
      let tiffType = tiffModelType || "orthomosaic"
      let taskId = this.state.orthoImageData.task_id
      let sas = encodeURIComponent(this.state.permissions.st)
      let blobContainer = this.state.permissions.container
      API.getTilesBounds({ taskId, tiffType, sas, blobContainer }).then((data) => {
        this.setState({
          tilesBounds: data.tilesBounds,
          bandsList: data.band_descriptions,
          bounds: data.bounds,
          tileMinZoom: data.minZoom - ZOOM_EXTRA_LEVELS,
          tileMaxZoom: data.maxZoom + ZOOM_EXTRA_LEVELS,
          defaultOrtho: true,
          band1: "1",
          band2: "2",
          band3: "3"
        }, async () => {
          const drawingBounds = [[this.state.bounds[1], this.state.bounds[0]], [this.state.bounds[3], this.state.bounds[2]]]
          const result = await utm.convertLatLngToUtm(drawingBounds[0][0], drawingBounds[0][1], 2);
          this.setState({
            imageAnalysisLoader: false,
            mapDataLoaded: true,
            zoneLetter: result.ZoneLetter,
            zoneNumber: result.ZoneNumber
          }, () => {
          })
          this.setSelectComponentData()
          resolve(true)
        })
      })
    })
  }

  getTilesBounds1 = async (tiffModelType1) => {
    return new Promise((resolve, reject) => {
      let tiffType = tiffModelType1 || "orthomosaic"
      let taskId = this.state.orthoImageData1.task_id
      let sas = encodeURIComponent(this.state.permissions.st)
      let blobContainer = this.state.permissions.container
      API.getTilesBounds({ taskId, tiffType, sas, blobContainer }).then((data) => {
        this.setState({
          tilesBounds1: data.tilesBounds,
          bounds1: data.bounds,
          defaultOrtho: true,
          band1: "1",
          band2: "2",
          band3: "3",
        }, () => {
          this.setSelectComponentData()
          resolve(true)
        })
      }, (e) => {

      })
    })
  }

  handleHistogramUpdate = e => {
    this.setState({ processTileMin: e.min, processTileMax: e.max, reportMsg: undefined }, () => {
      this.overlayTilesLayerOf("plantHealth");
    })
  }

  drawBoundsborder = () => {
    const { map } = this.state
    if (!(this.state.boundsLayer) && this.state.orthoImageData) {
      let bounds = [[this.state.bounds[1], this.state.bounds[0]], [this.state.bounds[3], this.state.bounds[2]]]
      let boundsLayer = L.rectangle(bounds, { color: 'white', weight: 1, fillColor: "none" });
      boundsLayer.addTo(map)
      this.setState({ boundsLayer })
    }
  }

  inspectImages = () => {
    if (this.state.inspectShow) {
      const { images, map } = this.state
      images.forEach((image, index) => {
        if (image.latitude == "" || image.longitude == "" || image.latitude == null || image.longitude == null) {
        } else {
          let lat = Number(image.latitude)
          let lng = Number(image.longitude)
          let latlng = [lat, lng]
          let circle = L.circleMarker(latlng, {
            color: 'black',
            fillColor: '#2989Cf',
            fillOpacity: 1,
            radius: 7,
            weight: 1,
          }).addTo(map).on('click', () => { this.openImage(index) });
          marker2[index] = circle
        }
      })

      this.setMapCenter()
    } else {
      for (let i = 0; i < marker2.length; i++) {
        marker2[i].remove();
      }
    }
  }

  getGCPData = () => {
    return new Promise((resolve, reject) => {
      if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) {
        API.getCSV_GCP(this.state.orthoImageData.collection_id).then((data) => {
          if (data) {
            this.setState({
              GCPPoints: data.gcp_points
            })
          }
          resolve()
        })
      } else {
        resolve()
      }
    })
  }

  showGCP = () => {
    const { map } = this.state
    if (this.state.GCPShow) {
      if (this.state.GCPPoints.length > 0) {
        this.state.GCPPoints.forEach((image, index) => {
          var customPopup = `<b>${image.gcp_name}</b><br>${Number(image.latitude).toFixed(8)},<br> ${Number(image.longitude).toFixed(8)}`
          var customOptions =
          {
            'width': '200'
          }
          let lat = Number(image.latitude)
          let lng = Number(image.longitude)
          var myIcon = L.icon({
            iconUrl: redFlag,
            iconSize: [20, 20],
            iconAnchor: [10, 20],
            popupAnchor: [2, -15],
            // shadowUrl: 'my-icon-shadow.png',
            shadowSize: [68, 95],
            shadowAnchor: [22, 94]
          });
          const marker = L.marker([lat, lng], { icon: myIcon }).addTo(map).bindPopup(customPopup, customOptions)
          marker1[index] = marker
        })
      }
    } else {
      for (let i = 0; i < marker1.length; i++) {
        marker1[i].remove();
      }
    }
  }

  removeLayer = async (layer) => {
    let removeLayer = this.state[layer]
    this.setState({ [layer]: undefined }, () => {
      if (removeLayer) {
        removeLayer.remove()
      }
    })
  }

  overlayTilesLayerOf = async (type) => {
    //type should be - orthomosaic || ndvi || dem
    let { map } = this.state
    this.removeLayer("orthoLayer").then(() => {
      if (this.state.orthoImageData) {
        let taskid = this.state.orthoImageData.task_id
        let { processTileIndex, processTileType, processTileMin, processTileMax, tilesBounds, tileMinZoom, tileMaxZoom, rangeMin, rangeMax } = this.state
        let blobContainer = this.state.permissions.container;
        let sas = encodeURIComponent(this.state.permissions.st);
        let bounds = [[this.state.bounds[1], this.state.bounds[0]], [this.state.bounds[3], this.state.bounds[2]]]
        let center = new L.bounds(bounds).getCenter()
        let bandsSelection = `${this.state.RGBShow && !(this.state.defaultOrtho) ? `&bands=${this.state.band1},${this.state.band2},${this.state.band3}` : "&viewDefault=true"}`
        if (type == "plantHealth") {
          var plantHealthURL = `${tilesServer}/tiles/${taskid}/plantHealth/{z}/{x}/{y}.png?sas=${sas}&blobContainer=${blobContainer}&algorithm=${processTileIndex}&min=${processTileMin}&max=${processTileMax}&filterType=${processTileType}`
          if (this.state.showRangeData)
            plantHealthURL = `${tilesServer}/tiles/${taskid}/rangeData/{z}/{x}/{y}.png?sas=${sas}&blobContainer=${blobContainer}&algorithm=${processTileIndex}&min=${rangeMin}&max=${rangeMax}&filterType=${processTileType}`
          let orthoLayer = L.tileLayer(plantHealthURL, {
            tileSize: 256,
            maxZoom: 28,
            bounds: bounds
          }).addTo(map);
          this.setState({
            orthoLayer,
            center: { lat: center.x, lng: center.y }
          })
        } else if (!(this.state.orthoLayer)) {
          let orthoLayer = L.tileLayer(`${tilesServer}/tiles/${taskid}/${type}/{z}/{x}/{y}.png?sas=${sas}&blobContainer=${blobContainer}${bandsSelection}`, {
            tileSize: 256,
            maxZoom: 28,
            bounds: bounds
          }).addTo(map);
          orthoLayer.on("load", () => { this.removeLayer("boundsLayer") });
          this.setState({
            orthoLayer,
            center: { lat: center.x, lng: center.y }
          })
        }
      }
    })
  }

  setMapCenter = async () => {
    if (this.state.bounds == undefined) {
      return;
    }
    let bounds = [[this.state.bounds[1] - EXTENDBOUNDS, this.state.bounds[0] - EXTENDBOUNDS], [this.state.bounds[3] + EXTENDBOUNDS, this.state.bounds[2] + EXTENDBOUNDS]]
    if (this.state.map) {
      this.state.map.fitBounds(bounds);
    }
  }

  toggleLayer = async (type) => {
    this.toggleMeasurement("showPointer")
    this.closeFloorPlanning()
    let { google, map } = this.state

    if (type === "orthomosaic") {
      await this.getTilesBounds('orthomosaic')
      this.setMapCenter()
      this.managePopup()
      if (!(this.state.compare || this.state.activeSidepanel === activeSidebarLayers)) { this.toggleSidepanelData(OrthomosaicAnalysis) }
      if (imageMapType) {
        map.overlayMapTypes.pop();
      }
      this.setState({
        RGBShow: true,
        NDVIShow: false,
        DEMShow: false,
        ThreeDShow: false,
        pointCloudShow: false,
        bothShowPT: false,
        DTMShow: false,
        showElevationProfile: false,
      }, () => {
        if (this.state.RGBShow) {
          this.overlayTilesLayerOf("orthomosaic")
        }
      })
    }
    if (type === "plantHealth") {
      this.managePopup()
      if (!(this.state.compare || this.state.activeSidepanel === activeSidebarLayers)) { this.toggleSidepanelData(PlantHealthAnalysis) }
      if (imageMapType) {
        map.overlayMapTypes.pop();
      }
      this.updateHistogram()
        .then((res) => {
          this.setState({
            ThreeDShow: false,
            pointCloudShow: false,
            bothShowPT: false,
            RGBShow: false,
            NDVIShow: true,
            DEMShow: false,
            DTMShow: false,
            imageAnalysisLoader: false,
            showElevationProfile: false,
            showRangeData: false,
            rangeMax: 1.0,
            rangeMin: -1.0,
          }, () => {
            if (this.state.NDVIShow) {
              this.overlayTilesLayerOf("plantHealth")
              this.setMapCenter()
            }
          })
        })

    }
    if (type === "dsm") {
      await this.getTilesBounds('dem')
      this.setMapCenter()
      if (!(this.state.compare || this.state.activeSidepanel === activeSidebarLayers)) { this.toggleSidepanelData(elevationAnalysis) }
      if (imageMapType) {
        map.overlayMapTypes.pop();
      }
      this.setState({
        RGBShow: false,
        NDVIShow: false,
        DEMShow: true,
        ThreeDShow: false,
        pointCloudShow: false,
        bothShowPT: false,
        DTMShow: false,
        DEMType: "DSM",
        showElevationProfile: false,
      },
        () => {
          if (this.state.DEMShow) {
            if (this.state.DEMShowPopup) {
              this.managePopup("DEMShowPopup")
            }
            this.overlayTilesLayerOf("dem")
          }
        })
    }
    if (type === "dtm") {
      await this.getTilesBounds('dtm')
      this.setMapCenter()
      if (!(this.state.compare || this.state.activeSidepanel === activeSidebarLayers)) { this.toggleSidepanelData(elevationAnalysis) }
      if (imageMapType) {
        map.overlayMapTypes.pop();
      }
      this.setState({
        RGBShow: false,
        NDVIShow: false,
        DEMShow: false,
        DTMShow: true,
        ThreeDShow: false,
        pointCloudShow: false,
        bothShowPT: false,
        DEMType: "DTM",
        showElevationProfile: false,
      }, () => {
        if (this.state.DTMShow) {
          if (this.state.DEMShowPopup) {
            this.managePopup("DEMShowPopup")
          }
          this.overlayTilesLayerOf("dtm")
        }
      })
    }
    if (type === "ThreeD") {
      if (this.state.ThreeDShowPopup) {
        this.managePopup()
      } else {
        this.managePopup("ThreeDShowPopup")
      }
      this.setState({
        RGBShow: false,
        NDVIShow: false,
        DEMShow: false,
        DTMShow: false,
        ThreeDShow: true,
        pointCloudShow: false,
        bothShowPT: false,
        showElevationProfile: false,
      })
    }
    if (type === "pointCloud") {
      if (this.state.ThreeDShowPopup) {
        this.managePopup()
      } else {
        this.managePopup("ThreeDShowPopup")
      }
      this.setState({
        RGBShow: false,
        NDVIShow: false,
        DEMShow: false,
        DTMShow: false,
        ThreeDShow: false,
        pointCloudShow: true,
        bothShowPT: false,
        DEMShowPopup: false,
        sidebarPanel: false,
        showElevationProfile: false,
      })

    }

    if (type === "bothPT") {
      if (this.state.ThreeDShowPopup) {
        this.managePopup()
      } else {
        this.managePopup("ThreeDShowPopup")
      }
      this.setState({
        RGBShow: false,
        NDVIShow: false,
        DEMShow: false,
        DTMShow: false,
        ThreeDShow: false,
        pointCloudShow: false,
        bothShowPT: true,
        showElevationProfile: false,
      })

    }
  }

  isUserOwnerOfCollection = () => {
    const { collection_id } = this.state.orthoImageData
    const { id } = this.state.project
    API.isUserProjectOwner(id, collection_id)
      .then((result) => {
        this.setState({
          isOwner: result.isShared ? false : true,
          isAllowToDownload: result.access_level == "DOWNLOAD" ? true : false,
          sharedBy: result.sharedBy
        })
      })
      .catch((err) => {
        this.setState((state) => ({
          ...state,
          itemName: "",
          processPopupIcon: "ERROR",
          processAction: "ADD",
          processMessage: "Something went wrong while getting owner information",
          showProcessPopup: true,
          loading: false,
          isOwner: false,
          isAllowToDownload: false
        }))

      })
  }

  openOrthoErrorPopup = () => {
    this.setState((state) => ({
      ...state,
      itemName: "Orthomosaic Data",
      processPopupIcon: "ERROR",
      processAction: "ADD",
      processMessage: "Error while getting Orthomosaic Data",
      showProcessPopup: true,
      loading: false,
      mapDataLoaded: true,
      orthoImageData: undefined
    }))
  }

  openDataNotAvailablePopup = (dataName) => {
    this.setState((state) => ({
      ...state,
      itemName: dataName,
      processPopupIcon: "ERROR",
      processAction: "ADD",
      processMessage: dataName + " is not available",
      showProcessPopup: true,
      loading: false
    }))
  }

  getImageOrthomosaicImages = () => {

    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) {
      API.getImageOrthomosaicImages(this.props.location.state.plan.id).then((data) => {

        let { orthoImageCollectionId } = this.props.location.state
        // let shpFiles=data.images.filter((img,)=>img.image_type===AppConstants.ASSETS.SHP&& img.task_id===)

        let orthoImages = data.images ? data.images.filter((obj, index, self) => {
          const firstIndex = self.findIndex(item => item.task_id === obj.task_id);
          return index === firstIndex;
        }) : []
        // let orthoImagesCurrentCollectrion = data.images ? data.images.filter(image => image.collection_id == orthoImageCollectionId) : []
        if (orthoImages.length > 0) {

          if (this.state.orthoImageCollectionId) {
            //if plan view is opened from images page then ortho image will be opened according to that collection
            let index = orthoImages.findIndex(image => image.collection_id == orthoImageCollectionId);
            this.setState((state) => ({
              ...state,
              orthomosaicImages: [...orthoImages],
              // assetsLayers:[...orthoImages[index].filter(img=>img.image_type===AppConstants.ASSETS.SHP)],
              orthoImageData: orthoImages[index],
              orthoImageData1: orthoImages[index],
              [this.props.location.state.layerShow]: orthoImages[index] ? true : false,
              activeOrtho: index,
              activeOrtho1: index,
              orthoImageSet: '',
              collection_id: orthoImages[index].collection_id,
            }), () => {
              // this.getCurrentLayers(this.props.location.state.plan.id)

              this.initTeamsLiveChangesSetup()
              this.checkDataAvailable().then((res) => {
                this.modelIndependetView()
              }).catch((err) => {
                this.openOrthoErrorPopup()
              })
            })
          }
          else {
            //if plan view is opened other than images page then 1st orthomosaicImage will be loaded
            this.setState((state) => ({
              ...state,
              // assetsLayers:[...orthoImages[0].filter(img=>img.image_type===AppConstants.ASSETS.SHP)],
              orthomosaicImages: [...orthoImages],
              orthoImageData: orthoImages[0],
              orthoImageData1: orthoImages.length > 1 ? orthoImages[1] : orthoImages[0],
              activeOrtho: 0,
              activeOrtho1: orthoImages.length > 1 ? 1 : 0,
              orthoImageSet: '',
              collection_id: orthoImages[0].collection_id
            }), () => {
              this.checkDataAvailable().then((res) => {
                this.modelIndependetView()
              }).catch((err) => {

                this.openOrthoErrorPopup()
              })
            })
          }
        } else if (this.props.location.state.orthoImageCollectionId) {
          this.checkDataAvailable().then((res) => {
            this.modelIndependetView()
          }).catch((err) => {

            this.openOrthoErrorPopup()
          })
        } else {
          this.setState({
            mapDataLoaded: true,
            loading: false,
            orthomosaicImages: [],
            orthoImageData: undefined,
            orthoImageData1: undefined,
            activeOrtho: undefined,
            activeOrtho1: undefined,
            orthoImageSet: '',
            collection_id: '',
          })
        }
      }, (e) => {
        this.openOrthoErrorPopup()
      })
    } else {
      this.setState({
        mapDataLoaded: false,
        loading: false,
        orthomosaicImages: [],
        RGBShow: false,
        orthoImageData: undefined,
        orthoImageData1: undefined,
        RGBShow: false,
        activeOrtho: undefined,
        activeOrtho1: undefined,
        orthoImageSet: '',
        collection_id: '',
      })
    }
  }

  modelIndependetView = async () => {
    await this.getGCPData()
    this.getInviteUsersList()
    this.getImages()
    if (this.state.OrthomosaicAvailable && this.state.OrthomosaicAvailable != NotSelected && this.state.RGBShow) {
      await this.updateHistogram()
      await this.getTilesBounds('orthomosaic')
      this.toggleLayer('orthomosaic')
      this.setMapCenter()
    } else if (this.state.DSMAvailable && this.state.DSMAvailable != NotSelected && this.state.DEMShow) {
      await this.getTilesBounds('dem')
      this.toggleLayer('dsm')
      this.setMapCenter()
    } else if (this.state.DTMAvailable && this.state.DTMAvailable != NotSelected && this.state.DEMShow) {
      await this.getTilesBounds('dtm')
      this.toggleLayer('dtm')
      this.setMapCenter()
    } else if (this.state.indPointCloudAvailable && this.state.indPointCloudAvailable != NotSelected && this.state.pointCloudShow) {
      this.setState({ showElevationProfile: false }, () => {
        this.toggleLayer('pointCloud')
        this.setState({
          imageAnalysisLoader: false,
          mapDataLoaded: true
        })
      })
    } else if (this.state.indThreeDAvailable && this.state.indThreeDAvailable != NotSelected && this.state.ThreeDShow) {
      this.setState({ showElevationProfile: false }, () => {
        this.toggleLayer('ThreeD')
        this.setState({
          imageAnalysisLoader: false,
          mapDataLoaded: true
        })
      })
    } else {
      // this.openOrthoErrorPopup()
    }
  }

  modelIndependetView1 = async () => {
    await this.getGCPData()
    this.getInviteUsersList()
    this.getImages()
    if (this.state.OrthomosaicAvailable && this.state.OrthomosaicAvailable != NotSelected) {
      await this.updateHistogram()
      await this.getTilesBounds('orthomosaic')
      this.toggleLayer('orthomosaic')
      this.setMapCenter()
    } else if (this.state.DSMAvailable && this.state.DSMAvailable != NotSelected) {
      ;
      await this.getTilesBounds('dem')
      this.toggleLayer('dsm')
      this.setMapCenter()
    } else if (this.state.DTMAvailable && this.state.DTMAvailable != NotSelected) {
      await this.getTilesBounds('dtm')
      this.toggleLayer('dtm')
      this.setMapCenter()
    } else if (this.state.indPointCloudAvailable && this.state.indPointCloudAvailable != NotSelected) {
      this.setState({ showElevationProfile: false }, () => {
        this.toggleLayer('pointCloud')
        this.setState({
          imageAnalysisLoader: false,
          mapDataLoaded: true
        })
      })
    } else if (this.state.indThreeDAvailable && this.state.indThreeDAvailable != NotSelected) {
      this.setState({ showElevationProfile: false }, () => {
        this.toggleLayer('ThreeD')
        this.setState({
          imageAnalysisLoader: false,
          mapDataLoaded: true
        })
      })
    } else {
      this.openOrthoErrorPopup()
    }
  }

  onChangeTeamMember = (e, value, message, mentions) => {
    const count = (e.target.value.match(new RegExp('@', 'g')) || []).length;
    if (message.length <= 100) {
      if (!(count > 1))
        this.setState({
          mentionValue: value,
          mentionMessage: message,
          mentionedUser: mentions?.[0]?.id
        })
    }
  }

  handlePaste = (event) => {
    const pastedText = event.clipboardData.getData('text');

    const { current } = this.inputRef;
    if (current) {
      const { selectionStart, selectionEnd } = current;
      const updatedValue =
        this.state.mentionMessage.slice(0, selectionStart) +
        pastedText +
        this.state.mentionMessage.slice(selectionEnd);
      this.setState({ mentionMessage: updatedValue }, () => {
        // Move the cursor to the end of the pasted text
        current.selectionStart = selectionStart + pastedText.length;
        current.selectionEnd = selectionStart + pastedText.length;
      });
    }
    event.preventDefault(); // Prevent default paste behavior
  };



  sendNotification = () => {
    if (this.state.mentionedUser) {
      let props = {
        pathname: '/dronenaksha/view_plan',
        state: {
          type: this.state.type,
          plan: { id: this.state.plan.id, plan_name: this.state.plan.plan_name, project_name: this.state.plan.project_name, sharedData: this.state.plan.sharedData, collection_id: this.state.plan.collection_id },
          project: { id: this.state.project.id, project_name: this.state.project.project_name, sharedData: this.state.project.sharedData, collection_id: this.state.project.collection_id },
          collection: this.state.collection_id,
          orthoImageCollectionId: this.state.orthoImageCollectionId,
          layerShow: this.state.layerShow ? this.state.layerShow : "RGBShow",
          sidebarMode: this.state.sidebarMode,
          selectedMeasurement: this.state.selectedMeasurement,
          measurementFromNotification: this.state.selectedMeasurement ? true : false,
          showOnclickPointDetails: this.state.selectedMeasurement.type !== "Marker",
          activeSidepanel: this.state.activeSidepanel
        }
      }
      if (this.state.mentionMessage !== undefined) {
        API.addNotification(this.state.mentionedUser, this.state.mentionMessage, props, 1).then(result => {
          this.setState({
            selectedMeasurement: {
              ...this.state.selectedMeasurement,
              description: this.state.mentionValue,
            },
          }, () => {
            this.updateMeasurementDetails(true)
          })
        })
      }
    } else {
      this.setState({
        selectedMeasurement: {
          ...this.state.selectedMeasurement,
          description: this.state.mentionValue
        },
      }, () => {
        this.updateMeasurementDetails(true)
      })
    }
  }
  sendAnnotationNotification = (mentionedUser, mentionMessage, selectedTab) => {
    if (mentionedUser) {
      let props = {
        pathname: '/dronenaksha/view_plan',
        state: {
          type: this.state.type,
          plan: { id: this.state.plan.id, plan_name: this.state.plan.plan_name, project_name: this.state.plan.project_name, sharedData: this.state.plan.sharedData, collection_id: this.state.plan.collection_id },
          project: { id: this.state.project.id, project_name: this.state.project.project_name, sharedData: this.state.project.sharedData, collection_id: this.state.project.collection_id },
          collection: this.state.collection_id,
          orthoImageCollectionId: this.state.orthoImageCollectionId,
          layerShow: this.state.layerShow ? this.state.layerShow : "RGBShow",
          sidebarMode: this.state.sidebarMode,
          showFloors: this.state.showFloors,
          selectedFloor: this.state.selectedFloor,
          activeSidepanel: this.state.activeSidepanel,
          activeSideBarFloor: this.state.activeSideBarFloor,
          selectedTab,
          // minimizedFloorPlanningViewer: this.state.minimizedFloorPlanningViewer,
          // FloorImagesViewer: this.state.FloorImagesViewer,
          // panning: this.state.panning,
          // taggedIssue: mentionIssue,
          sidebarPanel: this.state.sidebarPanel,
        }

      }
      API.addNotification(mentionedUser, mentionMessage, props, 1).then(result => {

      })
    }
  }

  getImages = () => {
    const { user, type, userdisplay, currentpage, userperpage, key, counts, requestStatus } = this.state;
    const lastIndex = currentpage * userperpage;
    const firstpage = lastIndex - userperpage;
    const currentuser = userdisplay.slice(firstpage, lastIndex);
    const totalpages = userdisplay.length / userperpage;

    if (this.state.orthoImageData) {
      this.isUserOwnerOfCollection()
      if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].READ) API.getImageCollectionImages(this.state.orthoImageData.collection_id, " ", userperpage, firstpage).then((data) => {

        this.setState((state) => ({
          ...state,
          loading: false,
          images: data.images,
          img: data.images,
          sasToken: data.sasToken,
          counts: data.totalCount,
          showCheckboxes: false,
          selectedImageCount: 0,

        }))
      }, (e) => {
        this.setState((state) => ({
          ...state,
          itemName: "Images",
          processPopupIcon: "ERROR",
          processAction: "ADD",
          processMessage: "Something went wrong while getting images",
          showProcessPopup: true,
          loading: false
        }))
      })
      else {
        this.setState((state) => ({
          ...state,
          loading: false
        }))
      }
    }
  }

  removeGCP = () => {
    return new Promise((resolve, reject) => {
      if (marker1.length > 0) {
        for (let i = 0; i < marker1.length; i++) {
          marker1[i].remove();
        }
      }
      this.setState({ GCPPoints: [] })
      resolve()
    })
  }

  changeOrtho = () => {
    if (this.state.measurements.length != 0) this.setState({ measurements: [] })
    if (this.state.contour?.shapeLayer) {
      this.state.contour.shapeLayer.removeFrom(this.state.map)
    }
    this.closeFloorPlanning()
    this.checkDataAvailable().then(() => {
      this.getMeasurements().then(async (data) => {
        await this.removeGCP()
        await this.getGCPData()
        // this.showMeasurements()
        // this.showGCP()
        if (this.state.showMeasurements) this.showMeasurements("changeOrtho")
        if (this.state.GCPShow) this.showGCP()
      })
      if (this.state.compare) {
        this.setState({
          selectedLayer1: this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable ? 'orthomosaic'
            : this.state.DSMAvailable != NotSelected && this.state.DSMAvailable ? 'dem'
              : this.state.DTMAvailable != NotSelected && this.state.DTMAvailable ? 'dtm' : 'base',
        }, async () => {
          await this.getTilesBounds(this.state.OrthomosaicAvailable && this.state.OrthomosaicAvailable != NotSelected ? 'orthomosaic'
            : this.state.DSMAvailable && this.state.DSMAvailable != NotSelected ? 'dem' : 'dtm')
          await this.setMapCenter()
          this.removeLayer("leftLayer")
          this.removeLayer("rightLayer")
          this.removeLayer("compareControl").then(() => {
            this.compareSlider()
          })
          if (this.state.OrthomosaicAvailable && this.state.OrthomosaicAvailable != NotSelected) {
            this.updateHistogram()
          }
        })
      } else {
        this.setState({
          selectedLayer1: this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable ? 'orthomosaic'
            : this.state.DSMAvailable != NotSelected && this.state.DSMAvailable ? 'dem'
              : this.state.DTMAvailable != NotSelected && this.state.DTMAvailable ? 'dtm' : 'base',
          selectedLayer2: this.state.OrthomosaicAvailable1 ? 'orthomosaic' : this.state.DSMAvailable1 ? 'dem' : this.state.DTMAvailable1 ? 'dtm' : 'base'
        }, () => {
          this.modelIndependetView1()
          this.setState({ allMeasurementsShow: true }, () => {
            this.toggleAllMeasurements()
          })
        })
      }
    }).catch((err) => {
      this.openOrthoErrorPopup()
    })
  }

  chnageOrtho1 = () => {
    this.checkDataAvailable1().then(() => {
      this.setState({
        selectedLayer2: this.state.OrthomosaicAvailable1 ? 'orthomosaic' : this.state.DSMAvailable1 ? 'dem' : this.state.DTMAvailable1 ? 'dtm' : 'base'
      }, async () => {
        await this.getTilesBounds1(this.state.OrthomosaicAvailable1 ? 'orthomosaic' : this.state.DSMAvailable1 ? 'dem' : 'dtm')
        this.removeLayer("leftLayer")
        this.removeLayer("rightLayer")
        this.removeLayer("compareControl").then(() => {
          this.compareSlider()
        })
      })

    })
  }

  nextImg = () => {
    this.setState({
      ...this.state,
      imageLoad: true,
      Idx: this.state.Idx + 1
    }, () => this.loadTiffImageSrc(this.state.Idx))
  }

  prevImg = () => {
    this.setState({
      ...this.state,
      imageLoad: true,
      Idx: this.state.Idx - 1
    }, () => this.loadTiffImageSrc(this.state.Idx))
  }
  getCurrentLayers = (plan_id) => {
    this.setState({
      assetsLayers: this.state.assetsLayers.map(lyr => {
        if (lyr?.showLayer === true && lyr.shapeLayer) lyr.shapeLayer.removeFrom(this.state.map)
        return lyr
      })
    }, () => {
      API.getMapAssets(plan_id).then(layers => {
        this.setState({

          assetsLayers: layers.images.map(layer => {
            return { showLayer: false, color: layer?.properties?.color || 'red', ...layer }
          })
        })
      }).catch(err => console.log(err))
    })
  }
  nextOrtho = () => {
    if (this.state.compare) {
      this.setState({
        ...this.state,
        activeOrtho: this.state.activeOrtho + 1,
        orthoImageData: this.state.orthomosaicImages[this.state.activeOrtho + 1],
      }, () => {
        this.changeOrtho()
      })
    } else {
      this.getCurrentLayers(this.props.location.state.plan.id)
      this.setState({
        ...this.state,
        activeOrtho: this.state.activeOrtho + 1,
        orthoImageData: this.state.orthomosaicImages[this.state.activeOrtho + 1],
        activeOrtho1: this.state.activeOrtho1 + 1,
        orthoImageData1: this.state.orthomosaicImages[this.state.activeOrtho1 + 1],
      }, () => {
        this.changeOrtho()
      })
    }

  }

  prevOrtho = () => {
    if (this.state.compare) {
      this.setState({
        ...this.state,
        activeOrtho: this.state.activeOrtho - 1,
        orthoImageData: this.state.orthomosaicImages[this.state.activeOrtho - 1],
      }, () => {
        this.changeOrtho()
      })
    } else {
      this.getCurrentLayers(this.props.location.state.plan.id)
      this.setState({
        ...this.state,
        activeOrtho: this.state.activeOrtho - 1,
        orthoImageData: this.state.orthomosaicImages[this.state.activeOrtho - 1],
        activeOrtho1: this.state.activeOrtho1 - 1,
        orthoImageData1: this.state.orthomosaicImages[this.state.activeOrtho1 - 1],
      }, () => {
        this.changeOrtho()
      })
    }
  }

  nextOrtho1 = () => {
    this.setState({
      ...this.state,
      activeOrtho1: this.state.activeOrtho1 + 1,
      orthoImageData1: this.state.orthomosaicImages[this.state.activeOrtho1 + 1],
    }, () => {
      this.chnageOrtho1()
    })
  }

  prevOrtho1 = () => {
    this.setState({
      ...this.state,
      activeOrtho1: this.state.activeOrtho1 - 1,
      orthoImageData1: this.state.orthomosaicImages[this.state.activeOrtho1 - 1],
    }, () => {
      this.chnageOrtho1()
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    let { RGBShow, NDVIShow, DEMShow, DTMShow, ThreeDShow, pointCloudShow, bothShowPT, showFloors,
      OrthomosaicAvailable, DSMAvailable, DTMAvailable,
    } = this.state;

    if (prevState.orthomosaicImages?.length !== this.state.orthomosaicImages?.length && this.state.orthomosaicImages?.length > 0) {
      this.setState({ threeDHighResAvailable: this.state.orthomosaicImages.find(lyr => lyr.task_id === this.state.orthoImageData.task_id && lyr.image_type === 'ThreeDHigh') ? true : false })
    }
    if (!prevState.map && this.state.map) {
      this.focusOnSelectedMeasurement(this.props.location.state.selectedMeasurementIndex, this.props.location.state.selectedMeasurement)
    }
    if (this.state.activeSidepanel && this.state.measurements.length > 0 && (this.state.activeSidepanel === OrthomosaicAnalysis || this.state.activeSidepanel === activeSidebarMeasurement) && this.state.drawnMeasurements.length > 0) {
      if (this.state.measurementFromNotification) {
        this.measurementClicked(this.props.location.state.selectedMeasurement.id);
      }
    }
    if (prevProps.location.state.notificationId != this.props.location.state.notificationId) {
      this.setState(state => ({ ...state, ...this.props.location.state }), () => {
        this.mapInitialized()
        window.location.reload()
      })
    }

    if (prevProps.location.state.notificationTempId !== this.props.location.state.notificationTempId) {
      this.setState(state => ({ ...state, ...this.props.location.state }), () => {
        this.mapInitialized()
        window.location.reload()
      })
    }

    if (prevState.minimizedFloorPlanningViewer !== this.state.minimizedFloorPlanningViewer && this.state.minimizedFloorPlanningViewer === false) {
      setTimeout(() => {
        this.setState({
          minimizedFloorPlanningViewer: false,
        })
      }, 500)

    }

    if (prevState.minimizedFloorPlanningViewer !== this.state.minimizedFloorPlanningViewer) {
      setTimeout(() => {
        this.setState({
          bounds: this.state.bounds
        })
      }, 500)
    }

    if (this.state.activeSidepanel !== prevState.activeSidepanel) {
      if (this.state.activeSidepanel === this.state.activeSideBarFloor)
        this.setState({ showFloors: true, })
      else this.setState({
        showFloors: false, activeSideBarFloor: "", FloorImagesViewer: false,
        minimizedFloorPlanningViewer: true,
      })
    }

    if (this.state.showFloors && this.state.showFloors !== prevState.showFloors) {
      if (this.state.activeSideBarFloor) {
        this.setState({ showFloors: true })
      } else {
        let toggleType = (OrthomosaicAvailable != NotSelected && OrthomosaicAvailable) ? "orthomosaic"
          : (DSMAvailable != NotSelected && DSMAvailable) ? "dsm"
            : (DTMAvailable != NotSelected && DTMAvailable) ? "dtm" : undefined;
        this.setState({
          showFloors: false,
          RGBShow: toggleType == "orthomosaic",
          DEMShow: toggleType == "dsm",
          DTMShow: toggleType == "dtm"
        }, () => {
          if (toggleType) this.toggleLayer(toggleType)
        })
      }
    }
  }

  componentWillUnmount() {

    updateOutTime(this.state.outId)
    imageMapType1 = undefined
    imageMapType = undefined


    marker1 = []
    poly = undefined
    poly1 = undefined
    gmarkers = [];
    gmarkers1 = [];
    marker = [];
    poly2 = undefined;
  }

  managePopup = (keepActive, closeSidePanelAlso = false) => {
    // if you pass empty parameters to this function it will close all popups
    // if you want to keep active any poppup pass its state key to this function it will keep active this popup
    // if you want to close sidepanel pass closeSidepanelAlso = true
    this.setState({
      orthoImageSet: keepActive == "orthoImageSet" ? "expand" : "",
      DEMShowPopup: keepActive == "DEMShowPopup" ? true : false,
      ThreeDShowPopup: keepActive == "ThreeDShowPopup" ? true : false,
      shareInviteModal: keepActive == "shareInviteModal" ? true : false,
      sidebarPanel: closeSidePanelAlso ? false : this.state.sidebarPanel,
      activeSidepanel: closeSidePanelAlso ? false : this.state.activeSidepanel,
      minimizedFloorPlanningViewer: keepActive === "minimizedFloorPlanningViewer" ? this.state.minimizedFloorPlanningViewer : true,
      showFloorPopUp: keepActive === "showFloorPopUp"
    })
  }

  toggleSidepanelData = (activeSidepanel) => {
    this.setState({
      activeSidepanel,
      sidebarPanel: true,
      shareInviteModal: false
    }, () => {
      if (!this.state.notificationViewed) {
        this.setState(state => ({ ...state, ...this.props.location.state, notificationViewed: true }))
      }

    })
  }

  //Polygon name handler
  measurementNameHandler = (e) => {
    this.setState({
      selectedMeasurement: {
        ...this.state.selectedMeasurement,
        name: e.target.value
      },
      errorMsg: "",
      textboxValid: true
    })
  }

  checkDataAvailable = () => {
    return new Promise((resolve, reject) => {
      let collectionId = this.state.orthoImageData && this.state.orthoImageData.collection_id ? this.state.orthoImageData.collection_id : this.props.location.state.orthoImageCollectionId
      API.getTaskDetails(collectionId, 3).then(async tasks => {
        if (tasks.tasks.length > 0) {
          this.setState({
            lasFilePath: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/point_cloud.laz?${this.state.permissions.st}`) ? `${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/point_cloud.laz?${this.state.permissions.st}` : false,
            OrthomosaicAvailable: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/orthomosaic.tif?${this.state.permissions.st}`) ?
              true : tasks.tasks[0].task_parameters && tasks.tasks[0].task_parameters.elevation ? false : NotSelected,

            DSMAvailable: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/dem.tif?${this.state.permissions.st}`) ?
              true : tasks.tasks[0].task_parameters && tasks.tasks[0].task_parameters.elevation ? false : NotSelected,

            DTMAvailable: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/dtm.tif?${this.state.permissions.st}`) ?
              true : tasks.tasks[0].task_parameters && tasks.tasks[0].task_parameters.elevation ? false : NotSelected,

            ThreeDAvailable: (await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/ept/ept.json?${this.state.permissions.st}` ||
              await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/cloud/cloud.js?${this.state.permissions.st}`))) ||
              await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/threeD/textured_model_geo.obj?${this.state.permissions.st}`) &&
              await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/threeD/textured_model_geo.mtl?${this.state.permissions.st}`) ?
              true : tasks.tasks[0].task_parameters && tasks.tasks[0].task_parameters["3dmodel"] ? false : NotSelected,

            indThreeDAvailable: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/threeD/textured_model_geo.obj?${this.state.permissions.st}`) &&
              await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/threeD/textured_model_geo.mtl?${this.state.permissions.st}`) ?
              true : tasks.tasks[0].task_parameters && tasks.tasks[0].task_parameters["3dmodel"] ? false : NotSelected,

            indPointCloudAvailable: (
              await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/ept/ept.json?${this.state.permissions.st}`)
              || await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${tasks.tasks[0].task_id}/cloud/cloud.js?${this.state.permissions.st}`)
            ) ? true : tasks.tasks[0].task_parameters && tasks.tasks[0].task_parameters["3dmodel"] ? false : NotSelected,

            urlExits: (await checkURLExist(`${BLOB_URL}/${this.state.permissions?.container}/orthomosaicImages/${tasks.tasks[0].task_id}/reports/main_report.pdf?${this.state.permissions?.st}`) ?
              `${BLOB_URL}/${this.state.permissions?.container}/orthomosaicImages/${tasks.tasks[0].task_id}/reports/main_report.pdf?${this.state.permissions?.st}` : false)

          }, () => {
            resolve()
          })
        }
      })

    })
  }

  checkDataAvailable1 = () => {
    return new Promise(async (resolve, reject) => {
      this.setState({
        OrthomosaicAvailable1: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/orthomosaic.tif?${this.state.permissions.st}`) ?
          true : false,

        DSMAvailable1: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/dem.tif?${this.state.permissions.st}`) ?
          true : false,

        DTMAvailable1: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/dtm.tif?${this.state.permissions.st}`) ?
          true : false,

        ThreeDAvailable1: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/ept/ept.json?${this.state.permissions.st}`) ||
          await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/threeD/textured_model_geo.obj?${this.state.permissions.st}`) &&
          await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/threeD/textured_model_geo.mtl?${this.state.permissions.st}`) ?
          true : false,

        indThreeDAvailable1: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/threeD/textured_model_geo.obj?${this.state.permissions.st}`) &&
          await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/threeD/textured_model_geo.mtl?${this.state.permissions.st}`) ?
          true : false,

        indPointCloudAvailable1: await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/ept/ept.json?${this.state.permissions.st}`)
          || await checkURLExist(`${BLOB_URL}/${this.state.permissions.container}/orthomosaicImages/${this.state.orthoImageData1.task_id}/cloud/cloud.js?${this.state.permissions.st}`) ?
          true : false,
      }, () => {
        resolve()
      })
    })
  }

  importFiles = (accept) => {
    const fileImporter = document.getElementById("fileImporter")
    fileImporter.setAttribute('accept', accept);
    fileImporter.click()
  }

  addToComparison(measurement_id, plan_id, task_id) {
    API.addCompareMeasurements(measurement_id, plan_id).then((response) => {
      API.getMeasurements(task_id).then((data) => {
        if (data && data.measurements && data.measurements.length > 0) this.setState({ showCompareReportCard: data.measurements.some(m => m.compared != null) ? true : false });
      }).catch((e) => { console.log("error :", e) })
    })
      .catch(err => {
        console.log(err);
      })
  }
  async fetchGeoJSON(image_url, id, color, image_type) {
    if (this.state.permissions.st) {
      let blobURL = image_url.split(image_type === AppConstants.ASSETS.SHP ? ".zip" : image_type === AppConstants.ASSETS.KML ? ".kml" : (image_type === AppConstants.ASSETS.CAD ? ".dxf" : image_type === AppConstants.ASSETS.DETECTION ? ".json" : image_type === AppConstants.ASSETS.GEOJSON ? ".json" : image_type === AppConstants.ASSETS.CONTOUR ? '.zip' : ""))[0] + "." + "json" + `?${this.state.permissions.st}`
      const handleDownload = async () => {

        try {
          const url = blobURL; // Replace with your file URL
          const response = await fetch(url);

          const blob = await response.blob();
          // Read the content of the file
          const reader = new FileReader();
          reader.onload = async () => {

            try {
              const fileContent = reader.result;
              let geoJSON = await JSON.parse(fileContent)
              if (await checkURLExist(url)) {
                if (image_type === AppConstants.ASSETS.CAD && !this.checkIsLatLng(geoJSON)) {
                  this.setState({ uploadedCadData: { geoJSON, savedAsset: { id, image_type, color } } }, () => {
                    this.openSelectZoneWarning()
                  })
                }
                else {
                  if (image_type === AppConstants.ASSETS.CAD) this.setState({ uploadedCadData: { geoJSON, savedAsset: { id, image_type, color } } })
                  if (image_type == "SHP") {
                    this.setState({ selectedLayerGeoJson: { geoJSON, color, id, image_type }, selectedLabel: Object.keys(geoJSON.features[0]?.properties)[0] })
                  } else if (image_type == "KML") {
                    this.setState({ selectedLayerGeoJsonForKML: { geoJSON, color, id, image_type }, selectedLabel: Object.keys(geoJSON.features[0]?.properties)[0] })
                  }
                  else {
                    if (!geoJSON.features) geoJSON = JSON.parse(geoJSON)
                    this.importGeoJson(geoJSON, color || 'red', id, image_type)
                  }
                }
              } else {
                this.setState({ disableLayers: false })
              }
            } catch (err) {
              this.setState({ disableLayers: false })
              this.setState({
                universalActivityPopup_icon: "ERROR", universalActivityPopup_msg: "Something went wrong while fetching layer data.", showUniversalActivityPopup: true, assetsLayers: image_type === AppConstants.ASSETS.CONTOUR ? this.state.assetsLayers : this.state.assetsLayers.map(lyr => {
                  if (lyr.id === id) return { ...lyr, showLayer: false };
                  else return lyr
                }),
                contour: image_type === AppConstants.ASSETS.CONTOUR ? { ...this.state.contour, showLayer: false } : this.state.contour
              })
            }
          };
          reader.readAsText(blob);
        } catch (error) {
          console.error('Error downloading the file:', error);
          this.setState({ disableLayers: false })
        }
      };
      await handleDownload()

      this.setState({ importLoading: false, disableLayers: false })
    } else {
      this.setState({ disableLayers: false })
    }
  }
  focusOnSelectedMeasurement = (index, selectedMeasurement) => {
    if (selectedMeasurement) {
      if (this.state.map) {

        if (selectedMeasurement.type === "Marker") {
          const { lat, lng, y } = selectedMeasurement.coordinates
          var latLon = L.latLng([lat, lng]);
          var bounds = latLon.toBounds(100); // 500 = metres
          this.state.map.panTo(latLon).fitBounds(bounds);
        } else {
          var bounds = new L.LatLngBounds();
          selectedMeasurement.coordinates.forEach(function (location) {
            bounds.extend([location.lat, location.lng]);
          });
          // Fit the map to the bounds
          this.state.map.fitBounds(bounds);
        }
        this.setState({
          selectedMeasurement,
        })
      }
    }
  }
  componentWillMount() {
    document.title = "DroneNaksha - Plan";
    getFeaturesPermissions([DRONENAKSHA_FEATURES.REPORTS, DRONENAKSHA_FEATURES.MAPS, DRONENAKSHA_FEATURES.IMAGECOLLECTIONS, GCS_FEATURES.PLANS])
      .then(permissions => {

        this.setState({ permissions }, () => {

          addUserAnalytic(this.props.location.pathname)
            .then(id => {
              this.setState((state) => ({
                outId: id
              }))
            })
          window.addEventListener('resize', () => {
            if (this.state.NDVIShow) {
              this.updateHistogram()
            }
          })

          // if orthomosaic image viewd from image collection images 
          this.setState({
            orthoImageCollectionId: this.props.location.state.orthoImageCollectionId ? this.props.location.state.orthoImageCollectionId : undefined,
            // selectedTab: this.props.location?.state?.selectedTab,
            measurementFromNotification: this.props.location.state.measurementFromNotification,
            showOnclickPointDetails: this.props.location.state.showOnclickPointDetails

          })

          this.getImageOrthomosaicImages()
          this.getCurrentLayers(this.props.location.state.plan.id)
          this.getAllFloors()

          if (this.props.location.state.user.avatar_url && this.props.location.state.user.avatar_url.length > 0) {
            this.setState((state) => ({
              ...state,
              avatarURL: `${this.props.location.state.user.avatar_url}?${this.state.permissions.st
                }&t${new Date().getTime()}`,
            }));
          } else {
            let avatarURL = `/images/${this.props.location.state.user.first_name[0].toLowerCase()}.PNG`;
            this.setState((state) => ({
              ...state,
              avatarURL: avatarURL,
            }));
          }


          this.setState((prevState) => ({
            ...prevState,
            gmarkers: this.props.location.gmarkers,
            gmarkers: this.props.location.gmarkers,
            plan: this.props.location.state.plan,
            project: this.props.location.state.project,
          }), () => {
            this.getImageCollections()
          });

          if (!this.props.location.state) {
            API.getUserType().then(
              ([registered, type, user]) => {
                // if promise is resolved, update state and redirect user
                this.setState((state) => ({
                  ...state,
                  registered,
                  type,
                  user,
                  orthoImageData: this.props.location.state.orthoImageData
                }), () => {
                  // this.getTeamsList()
                });
              },
              (e) => {
                // if promise is rejected, log the error, and display message to user
                this.setState({
                  user: {},
                  type: "unknown",
                });
                window.location.replace("/login");
              }
            );
          } else {
            if (this.props.location.state.config) {
              this.setState((state) => ({
                ...state,
                user: this.props.location.state.config.user,
                type: this.props.location.state.config.type,
                orthoImageData: this.props.location.state.orthoImageData
              }), () => {
                // this.getTeamsList()
              });
            } else if (this.props.location.state.user) {
              this.setState((state) => ({
                ...state,
                user: this.props.location.state.user,
                type: this.props.location.state.type,
                orthoImageData: this.props.location.state.orthoImageData,
                permissions,

              }), () => {
                // this.getTeamsList()
              });
            }
          }

          getActiveTeamActiveMembers().then(members => {
            this.setState(state => ({
              ...state,
              ...this.props.location.state,
              teamMembers: members.map(m => ({ id: m.id, display: m.userFullName }))
            }))
          })
        })
      })
      .catch(e => {
        window.location.replace("/")
      })
  }

  isRegionInsideImageBounds = (coordinates) => {
    if (coordinates?.[0]?.lat) {
      let result = coordinates.map((coord) => {
        if (coord) {
          if (!Array.isArray(coord.lat) && !Array.isArray(coord.lng)) {
            if (this.state.bounds) {
              const drawingBounds = [[this.state.bounds[1], this.state.bounds[0]], [this.state.bounds[3], this.state.bounds[2]]]
              const boundsPolygon = turf.bboxPolygon(drawingBounds.flat());
              const points = turf.points(coordinates?.map(latLng => [latLng.lat, latLng.lng]),);
              if ((turf.pointsWithinPolygon(points, boundsPolygon)).features.length === points.features.length) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          }
          else {
            return false
          }
        }
      })
      return result.includes(true);
    } else return false
  }

  changedPrvShpClr = () => {
    return new Promise(resolve => {
      if (this.state.clickedPolyFromShape && !(this.state.clickedPolyFromShape instanceof L.Marker)) {
        this.state.clickedPolyFromShape.setStyle(this.state.clickedPolyFromShape?.dn_style)
        resolve()
      } else resolve()
    })
  }

  clickedShapeFile = async (layer, countour, lt) => {
    if (this.state.showPointer) {
      this.toggleMeasurement("showPointer");
      await this.changedPrvShpClr()
      this.setState({ clickedPolyFromShape: layer, selectedShapeCountour: countour }, () => {
        if (lt != "Point") layer.setStyle({ color: "green" })
        this.toggleSidepanelData(activeSidebarMeasurement)
      })
    }

  }

  saveShapeFilePoly = (layer, countour) => {
    this.setState({
      activeEditLayer: layer,
      shapeFileLayers: this.state.shapeFileLayers.filter(l => l && l._leaflet_id != layer._leaflet_id)
    }, async () => {
      this.setState({ clickedPolyFromShape: undefined })
      let coordinates =
        (layer instanceof L.Polygon) ? (layer.getLatLngs())[0].map((latlng) => { return { lat: latlng.lat, lng: latlng.lng } })
          : (layer instanceof L.Polyline) ? (layer.getLatLngs()).map((latlng) => { return { lat: latlng.lat, lng: latlng.lng } })
            : (layer._latlng)

      await this.saveLayer(coordinates, (layer instanceof L.Polygon) ? "Polygon" : (layer instanceof L.Polyline) ? "Polyline" : "Marker", layer, countour)
      this.managePopup(false, true);
    })
  }


  setAllValuesToNull = () => {
    let tempObj = this.state.finalOtherProperties;
    for (let key in tempObj) {
      if (tempObj.hasOwnProperty(key)) {
        tempObj[key] = null;
      }
    }
    this.setState({
      finalOtherProperties: tempObj
    })
  }

  exportMeasurements = async (type, dnwType, isGlobal = false) => {
    this.setState({
      shapeFileItems: "WAIT",
      shapeFileIcon: "WAIT",
      shapeFileMsg: "Exporting measurements...",
      shapeFilePopup: true,
    })
    const errorOccured = () => {
      this.setState({
        shapeFileItem: "ERROR",
        shapeFileIcon: "ERROR",
        shapeFileMsg: "Something went wrong while exporting...",
        shapeFilePopup: true
      })
    }
    try {
      this.setAllValuesToNull()
      const features = await Promise.all(this.state.measurements.map(async (measurement, key) => {
        const keysToRemove = ['compared', 'properties', 'coordinates', 'date_created', 'plan_id', 'show', 'date_created', 'measurements'];
        const filteredObject = Object.fromEntries(
          Object.entries(measurement).filter(([key]) => !keysToRemove.includes(key))
        );

        let measurement1 = {
          measurements:
            measurement.type === "Polyline" ?
              [
                {
                  "2D Length": getDistance(measurement.coordinates, "m", true, !(this.getTiffAvailable() && measurement.coordinates[0].lat)),
                  "3D Length": await getDistanceIn3d(measurement.coordinates, "m", false)
                },
              ] :
              measurement.type === "Polygon" ? [
                {
                  "2D Area": getArea(measurement.coordinates, "m", true, !(this.getTiffAvailable() && measurement.coordinates[0].lat)),
                  "3D Area": await get3dPolygonArea(measurement.coordinates, 'm', false),
                  "2D Perimeter": getDistance([...measurement.coordinates, measurement.coordinates[0]], "m", true, !(this.getTiffAvailable() && measurement.coordinates[0].lat)),
                  "3D Perimeter": await getDistanceIn3d([...measurement.coordinates, measurement.coordinates[0]], "m", false)
                }
              ] : {}
        }

        const feature = {
          "type": "Feature",
          "properties": { ...this.state.finalOtherProperties, ...measurement.properties, ...measurement1.measurements[0], "DNtype": measurement.type, "name": measurement.name, "desc": extractMessageAfterMention(measurement.description) },
          "geometry":
            measurement.type === POLYGON ? {
              "type": POLYGON,
              "coordinates": [[...(await Promise.all(measurement.coordinates.map(async latLng => [latLng.lng, latLng.lat]))), [measurement.coordinates[0].lng, measurement.coordinates[0].lat]]]

            } : (measurement.type === POLYLINE ? {
              "type": LINESTRING,
              "coordinates": await Promise.all(measurement.coordinates.map(async latLng => [latLng.lng, latLng.lat]))
            } :
              measurement.type === MARKER ? {
                "type": POINT,
                "coordinates": [measurement.coordinates.lng, measurement.coordinates.lat]
              } : undefined
            )
        }

        if (dnwType == 'all') return feature
        if (isGlobal && measurement.plan_id) return feature
        if (dnwType == 'map' && !(measurement.plan_id)) return feature

      }))
      const geoJSON = {
        "type": "FeatureCollection",
        "features": features.filter(f => f?.geometry)

      }
      if (type === "shapeFile") {
        // console.log("geoJSON : ", geoJSON)
        const blob = await API.exportShapeFile(geoJSON)
        triggerBlobDownload(blob, "shapeFile.zip")

        this.setState({
          shapeFilePopup: false
        })
      }
    } catch (e) {
      console.log(e)
      errorOccured()
    }
  }

  importGeoJson = async (event, color, id, image_type, showLabel) => {
    const data = event.target ? JSON.parse(event.target.result) : event
    const GeoJSON = Array.isArray(data) ? await getSingleGeoJSON(data) : data
    if (GeoJSON.features.length == 0) {
      return;
    }
    setTimeout(async () => {
      const newLayerDrawn = (layer, properties, layerType) => {
        let countourOrElevOrKML = properties?.[showLabel];
        if (countourOrElevOrKML) {
          let p = new L.Tooltip({ className: "countour-popup ", pane: 'tooltips' }).setContent(`${countourOrElevOrKML}`)
          if (showLabel === "icon") {
            // layer.bindTooltip(`<div style='background-color:none;'><img src=${countourOrElev} width='30' /></div>`);
          } else {
            layer.bindTooltip(p)
            var tooltip = layer.getTooltip();
            if (tooltip) {
              tooltip.options.zIndex = 1000;
            }
          }

          layer.on('mouseover', function (e) {
            this.openTooltip(e.latlng);
          });

          layer.on('mouseout', function (e) {
            this.closeTooltip();
          });

          layer.on('mousemove', function (e) {
            this.openTooltip(e.latlng);
          })
        }

        if (id) layer.addTo(layerGrp)
        // if (isRegionOutOfBound && image_type !== AppConstants.ASSETS.CAD) {
        //   if (layerType != 'Point') {
        //     layer.dn_style = { color: 'white', fillColor: 'grey', opacity: '0.5' }
        //     layer.setStyle({ color: 'white', fillColor: 'grey', opacity: '0.5' })
        //   }

        // } else {
        if (layerType != 'Point') {
          layer.dn_style = { color: color, fillColor: color }
          layer.setStyle({ color: color, fillColor: color })
        }
        if ((image_type !== AppConstants.ASSETS.CAD && layerType !== POINT) || properties?.DNtype === "Marker") {
          layer.on('click', () => {
            // layer.color = color
            layer.properites = { ...layer.properites, color }
            this.clickedShapeFile(layer, countourOrElevOrKML, layerType)
          })
        }

        // }
      }

      // const boundsPolygon = turf.bboxPolygon([this.state.bounds[1] - EXTENDBOUNDS, this.state.bounds[0] - EXTENDBOUNDS, this.state.bounds[3] + EXTENDBOUNDS, this.state.bounds[2] + EXTENDBOUNDS]);
      let multiPolygonsLayers = []
      let allLayers = []
      let layerGrp = L.layerGroup()
      let tempLayersArr = []
      var cadTextGroup = L.markerClusterGroup({
        // Customize the cluster icon
        iconCreateFunction: function (cluster) {
          return L.divIcon({
            html: '',
            className: 'cluster-icon' // Add a custom class for the cluster icon
          });
        }
        , showCoverageOnHover: false,
        maxClusterRadius: 20
      });
      const groupedData = Array.from({ length: 100 }, (_, i) => GeoJSON.features.slice(i * 100, (i + 1) * 100));
      for (let group of groupedData) {
        const layers = await Promise.all(
          group.map(feature => {
            return new Promise(async (resolve) => {
              if (feature?.geometry?.type === POINT && feature.geometry.coordinates?.[0]) {
                if (image_type === AppConstants.ASSETS.CAD) {
                  const coordinates = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]]
                  let layer = L.marker(coordinates, {}).bindTooltip(feature.properties.Text, {
                    className: "leaflet-tooltip-own",
                    permanent: true,
                    direction: "top"
                  }
                  );
                  layer.setOpacity(0)
                  if (feature.properties.Text) {
                    cadTextGroup.addLayer(layer)
                  }
                  resolve({ ...layer })
                } else {
                  const coordinates = [feature.geometry?.coordinates[1], feature.geometry?.coordinates[0]]
                  // const points = turf.points([coordinates]);
                  // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                  let layer = {}

                  layer.properties = feature?.properties
                  if (layer?.properties?.DNtype === "Marker") {
                    var markerOptions = {
                      title: layer.properties.name,
                      clickable: true,
                      draggable: this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT && !this.state.showOnclickPointDetails ? true : false,
                      autoPanOnFocus: true,
                      icon: new L.Icon({ iconUrl: MarkerIcon, iconSize: [20, 28], iconAnchor: [10, 28] })
                    }
                    layer = new L.Marker(coordinates, markerOptions).addTo(this.state.map)
                    layer.properties = feature.properties
                  } else {
                    if (feature?.properties?.icon) {
                      var markerOptions = {
                        autoPanOnFocus: true,
                        icon: new L.Icon({ iconUrl: feature.properties.icon, iconSize: [28, 28], iconAnchor: [10, 28] })
                      }
                      layer = new L.Marker(coordinates, markerOptions).addTo(this.state.map)
                      layer.setZIndexOffset(100);
                    } else {
                      layer = new L.circleMarker(coordinates, { radius: 3, fillColor: color, color, fillOpacity: 1 })
                    }
                  }
                  newLayerDrawn(layer, feature.properties, POINT)
                  resolve({ ...layer })
                }
              }
              else if ((feature?.geometry?.type === POLYGON || feature?.geometry?.type === BOX)) {
                let coordinates = []
                if (feature.geometry?.coordinates?.[0]?.[0]?.[0]) {

                  coordinates = [feature.geometry.coordinates[0].map(coord => {
                    return ([coord[1], coord[0]])
                  })]
                } else if (feature.geometry?.coordinates?.[0]?.[0]) {
                  coordinates = [feature.geometry.coordinates.map(coord => {
                    return ([coord[1], coord[0]])
                  })]
                }
                // const points = turf.points(coordinates[0]);
                // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                const layer = new L.polygon(coordinates)
                layer.properties = feature.properties
                newLayerDrawn(layer, feature.properties)
                resolve({ ...layer })
              }
              else if (feature?.geometry?.type === MULITPOLYGON) {
                const multiPolygons = await Promise.all(feature.geometry?.coordinates.map(poly => {
                  return new Promise((resolve) => {
                    if (poly?.[0]?.[0]?.[0]) {
                      const coordinates = [poly[0].map(coord => {
                        return ([coord[1], coord[0]])
                      })]
                      // const points = turf.points(coordinates[0]);
                      // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                      const layer = new L.polygon(coordinates)
                      layer.properties = feature.properties
                      newLayerDrawn(layer, feature.properties)
                      resolve(layer)
                    } else {
                      resolve()
                    }
                  })
                }))
                if (multiPolygons?.length > 0) multiPolygonsLayers = [...multiPolygonsLayers, ...multiPolygons]
                resolve()
              }
              else if ((feature?.geometry?.type === LINESTRING && feature.geometry?.coordinates?.[0]?.[0])) {
                const coordinates = feature.geometry.coordinates.map(coord => {
                  return ([coord[1], coord[0]])
                })
                // const points = turf.points(coordinates);
                // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                const layer = new L.polyline(coordinates)
                layer.properties = feature.properties
                newLayerDrawn(layer, feature.properties)
                resolve(layer)
              } else if (feature?.geometry?.type === MULTILINESTRING && feature.geometry?.coordinates?.[0]?.[0]?.[0]) {
                let pointsArray = []
                const coordinates = feature.geometry.coordinates.map(coords => {
                  return coords.map(crd => {
                    pointsArray.push([crd[1], crd[0]])
                    return [crd[1], crd[0]]
                  })
                })
                // const points = turf.points(pointsArray);
                // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                const layer = new L.polyline(coordinates)
                newLayerDrawn(layer, feature.properties)
                resolve(layer)
              }
              else if (feature?.geometry?.type === GEOMETRYCOLLECTION) {
                let geometryLayers = await Promise.all(feature.geometry.geometries.map(gm => {
                  return new Promise(async (resolve, reject) => {
                    if (gm?.type === POINT) {
                      const coordinates = [gm.coordinates[1], gm.coordinates[0]]
                      // const points = turf.points([coordinates]);
                      // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                      let layer = L.marker(coordinates, {}).bindTooltip(feature.properties.Text, {
                        className: "leaflet-tooltip-own",
                        permanent: true,
                        direction: "top"
                      }
                      );
                      layer.setOpacity(0)
                      if (feature.properties.Text) {
                        cadTextGroup.addLayer(layer)
                      }
                      resolve(gm)
                    }
                    else if (gm?.type === POLYGON) {
                      const coordinates = gm.coordinates.map(coord => {
                        return ([coord[1], coord[0]])
                      })
                      // const points = turf.points(coordinates);
                      // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                      const layer = new L.polygon(coordinates)
                      layer.properties = feature.properties
                      newLayerDrawn(layer, feature.properties)
                      resolve(gm)
                    } else if (gm?.type === LINESTRING) {
                      const coordinates = gm.coordinates.map(coord => {
                        return ([coord[1], coord[0]])
                      })
                      // const points = turf.points(coordinates)
                      // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                      const layer = new L.polyline(coordinates)
                      newLayerDrawn(layer, feature.properties)
                      resolve(layer)
                    } else if (gm?.type === MULTILINESTRING) {
                      let pointsArray = []
                      const coordinates = await Promise.all(gm.coordinates.map(async (coords) => {
                        return new Promise(async (resolve, reject) => {
                          resolve(coords.map(crd => {
                            pointsArray.push([crd[1], crd[0]])
                            return [crd[1], crd[0]]
                          }))
                        })
                      }))

                      // const points = turf.points(pointsArray);
                      // const isRegionOutOfBound = (turf.pointsWithinPolygon(points, boundsPolygon)).features.length !== points.features.length
                      const layer = new L.polyline(coordinates)
                      newLayerDrawn(layer, feature.properties)
                      resolve(layer)
                    } else if (gm?.type === MULITPOLYGON) {
                    }
                    else resolve()
                  })
                }))
                resolve({ ...feature, geometry: geometryLayers })
              }
              else {
                resolve()
              }
            })
          })
        )
        allLayers = [...allLayers, ...layers]
      }
      if (cadTextGroup.getLayers().length > 0) {
        layerGrp.addLayer(cadTextGroup)
      }
      layerGrp.addTo(this.state.map)
      let featureGrp = L.featureGroup(layerGrp.getLayers())
      this.state.map.fitBounds(featureGrp.getBounds())
      this.setState({
        disableLayers: false,
        shapeFileLayers: [...this.state.shapeFileLayers, ...allLayers, ...multiPolygonsLayers],
        saveShapeFilePopup: false,
        shapeFilePopup: false,
        assetsLayers: image_type === AppConstants.ASSETS.CONTOUR ? this.state.assetsLayers : this.state.assetsLayers.map(lyr => {
          if (lyr.id === id) return { ...lyr, shapeLayer: layerGrp }
          else return lyr;
        }),
        contour: image_type === AppConstants.ASSETS.CONTOUR ? { ...this.state.contour, shapeLayer: layerGrp } : this.state.contour,
        tempLayersArr,
      })
    }, 300)
  }


  extractShapes = (kmlContent) => {
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(kmlContent, 'text/xml');
      const placemarkElements = xmlDoc.getElementsByTagName('Placemark');
      const shapes = [];

      for (let i = 0; i < placemarkElements.length; i++) {
        const placemarkElement = placemarkElements[i];
        const geometryElement = placemarkElement.getElementsByTagName('Point')[0] ||
          placemarkElement.getElementsByTagName('LineString')[0] ||
          placemarkElement.getElementsByTagName('Polygon')[0];

        if (geometryElement) {
          const shapeType = geometryElement.tagName;
          let coordinates = [];

          if (shapeType === 'Point') {
            const coordinateText = geometryElement.getElementsByTagName('coordinates')[0].textContent.trim();
            const coordinateValues = coordinateText.split(',');
            if (coordinateValues.length >= 2) {
              const lng = parseFloat(coordinateValues[0]);
              const lat = parseFloat(coordinateValues[1]);
              const altitude = coordinateValues.length === 3 ? parseFloat(coordinateValues[2]) : null;
              coordinates = [{ lng, lat, altitude }];
            }
          } else if (shapeType === 'LineString' || shapeType === 'Polygon') {
            const coordinateElements = geometryElement.getElementsByTagName('coordinates');
            if (coordinateElements.length > 0) {
              const coordinateText = coordinateElements[0].textContent.trim();
              const coordinatePairs = coordinateText.split(' ');

              for (let j = 0; j < coordinatePairs.length; j++) {
                const coordinatePair = coordinatePairs[j].trim();
                const coordinateValues = coordinatePair.split(',');

                if (coordinateValues.length >= 2) {
                  const lng = parseFloat(coordinateValues[0]);
                  const lat = parseFloat(coordinateValues[1]);
                  const altitude = coordinateValues.length === 3 ? parseFloat(coordinateValues[2]) : null;

                  coordinates.push({ lng, lat, altitude });
                }
              }
            }
          }

          if (coordinates.length > 0) {
            shapes.push({ type: shapeType, coordinates });
          }
        }
      }

      return shapes;
    } catch (error) {
      console.error('Error extracting shapes from KML:', error);
      return [];
    }
  };



  handleClearFile = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = ''; // Reset the value to clear the selected file
    }
  };
  getSelectedLocation = async (loc) => {
    if (loc) {
      const result = await utm.convertLatLngToUtm(loc.lat, loc.lng, 10);
      this.setState({
        zoneLetter: result.ZoneLetter,
        zoneNumber: result.ZoneNumber,
      }, () => {
        this.setState({
          openCadlocationPopup: false,
        }, () => {
          this.convertAndReplaceCadGeojson()
        })
      })
    } else {
    }
  }
  openSelectZoneWarning = () => {
    this.setState({
      // showImportFilePopUp: false,
      cadFileItems: "WAIT",
      cadFileIcon: "",
      cadFileMsg: "Please select a location which will allow us to locate the zone of CAD file more accurately on map",
      cadFilePopup: true,
    });



    //set state that user has selected the location on map

    //if uloadedFilesEvetn and that state is true
    //continue uploading CAD

  }
  onSelectFiles = async (e) => {
    this.setState({

      showImportFilePopUp: false,
      shapeFileItems: "WAIT",
      shapeFileIcon: "WAIT",
      shapeFileMsg: "Importing file...",
      shapeFilePopup: true,
    });

    try {
      if ((e.target.files[0].type === "application/zip" || e.target.files[0].type === "application/x-zip-compressed") && this.state.selectedFilesExt == ".zip") {

        this.setState({ uploadFileEvent: { file: e.target.files[0], type: AppConstants.ASSETS.SHP }, saveShapeFilePopup: true })

      }
      else if ((e.target.files[0].type.includes(".kml") || e.target.files[0].name.includes(".kml")) && this.state.selectedFilesExt == ".kml") {
        this.setState({ uploadFileEvent: { file: e.target.files[0], type: "KML" }, saveShapeFilePopup: true })
      }
      else if ((((e.target.files[0].type).toLowerCase().includes(".dxf") || (e.target.files[0].name).toLowerCase().includes(".dxf")) && this.state.selectedFilesExt == ".dxf") || (((e.target.files[0].type).toLowerCase().includes(".dwg") || (e.target.files[0].name).toLowerCase().includes(".dwg")))) {
        this.setState({ uploadFileEvent: { file: e.target.files[0], type: e.target.files[0].name.toLowerCase().includes(".dwg") ? AppConstants.ASSETS.DWG : AppConstants.ASSETS.DXF } }, () => {
        })

      }

      else if (e.target.files[0].type === "application/json" || e.target.files[0].type === "application/geo+json") {
        this.setState({ uploadFileEvent: { file: e.target.files[0], type: AppConstants.ASSETS.GEOJSON, saveShapeFilePopup: true } }, () => {
        })
      }
      else {
        console.log("Invlaid file for import with ext =", e.target.files[0].type)
        this.setState({
          showImportFilePopUp: false,
          shapeFileItems: "ERROR",
          shapeFileIcon: "ERROR",
          shapeFileMsg: "Invalid file for import.",
          shapeFilePopup: true,
        });
      }
    } catch (error) {
      console.log("Error importing,", error)
    }
    this.handleClearFile()
  }
  handleDeleteMultipleLayers = async () => {

    const deleteCondition = (lyr) => this.state.isFloorCad ? (lyr.showLayer && lyr.image_type === AppConstants.ASSETS.CAD && lyr.image_url.includes("/floorData")) : this.state.deleteMultipleLayerType === "Imported" ? (lyr.showLayer && this.isImportedLayer(lyr)) : this.state.deleteMultipleLayerType === "Detection" ? (lyr.showLayer && lyr.image_type == AppConstants.ASSETS.DETECTION) : false
    const deleteData = this.state.assetsLayers.filter(lyr => deleteCondition(lyr)).map(lyr => {
      const { image_url, image_type, id, shapeLayer } = lyr
      let blobURL = image_url.split(image_type === AppConstants.ASSETS.SHP ? ".zip" : image_type === AppConstants.ASSETS.KML ? ".kml" : image_type === AppConstants.ASSETS.CAD ? ".dxf" : "")[0] + "." + "json"
      return { id, image_url: blobURL }
    })
    API.deleteMultipleMapAssets({ deleteData })
      .then(res => {
        this.state.assetsLayers.filter(lyr => deleteCondition(lyr)).map(lyr => {
          const { image_url, image_type, id, shapeLayer } = lyr
          if (shapeLayer) shapeLayer.removeFrom(this.state.map)
        })
        const filteredLayers = this.state.assetsLayers.filter(lyr => !deleteCondition(lyr))
        this.setState({
          assetsLayers: filteredLayers, isFloorCad: false,
          showDeletePopup: {
            item: "COMPLETE",
            open: true,
            icon: "COMPLETE",
            msg: "Selected layers deleted sucessfully.",
          }
        })


      }).catch(err => {
        this.setState({ universalActivityPopup_msg: "Something went wrong while deleting layers.", universalActivityPopup_icon: "ERROR", showUniversalActivityPopup: true })
      })

  }

  handleSelectAllLayers = async () => {
    this.setState({
      allAssetLayersSelected: !this.state.allAssetLayersSelected
    }, async () => {
      if (this.state.allAssetLayersSelected) {//if all layers are dsiabled its time to enable them
        for (const layer of this.state.assetsLayers)
          if (!layer.showLayer) {
            await this.handleLayerToggle(layer)
          }
      } else {//time to disable all layers bcoz they were enabled
        for (const layer of this.state.assetsLayers)
          if (layer.showLayer) {
            await this.handleLayerToggle(layer)
          }
      }
    })
  }
  updatelayerColor = async (layer, color) => {
    if (layer.showLayer) { //if lr is visible ,remove it
      const layers = layer.shapeLayer.getLayers().map(lr => {
        if (lr instanceof L.Marker) {
        } else {
          lr.setStyle({
            color,
            fillColor: color,
            fillOpacity: 0.2

          });
          lr.dn_style = { color, fillColor: color }
        }
        return lr
      })
      layer.shapeLayer.removeFrom(this.state.map)

      const newLyrGrp = L.layerGroup(layers)
      layer.shapeLayer = newLyrGrp
      newLyrGrp.addTo(this.state.map)
      this.setState(state => ({
        assetsLayers: state.assetsLayers.map(l => {
          if (layer.id === l.id) {
            return layer
          }
          else return l
        })
      }))
    } else {
      if (layer.shapeLayer) {

        const layers = layer.shapeLayer.getLayers().map(lr => {
          if (lr instanceof L.Marker) {
          } else {
            lr.setStyle({
              color,
              fillColor: color,
              fillOpacity: 0.2

            });
            lr.dn_style = { color, fillColor: color }
          }
          return lr
        })
        layer.shapeLayer.removeFrom(this.state.map)

        const newLyrGrp = L.layerGroup(layers)
        layer.shapeLayer = newLyrGrp
        this.setState(state => ({
          assetsLayers: state.assetsLayers.map(l => {
            if (layer.id === l.id) {
              return layer
            }
            else return l
          })
        }))
      } else {
        this.setState(state => ({
          assetsLayers: state.assetsLayers.map(l => {
            if (layer.id === l.id) {
              return layer
            }
            else return l
          })
        }))
      }
    }

  }
  handleLayerToggle = async (layer, type) => {
    if (!layer?.properties?.color) {
      layer.properties = { color: 'blue' }
    }
    return new Promise((resolve, reject) => {
      this.setState({
        importLoading: true,
        disableLayers: true,
        shapeFileLayers: [],
        assetsLayers: type === AppConstants.ASSETS.CONTOUR ? this.state.assetsLayers : this.state.assetsLayers.map(asset => {
          if (asset.id === layer.id) {
            if (asset.image_type === ASSETS.CAD) this.setState({
              minimizedFloorPlanningViewer: true
            });
            return { ...asset, showLayer: !asset.showLayer }
          }
          else return asset
        }),
        contour: type === AppConstants.ASSETS.CONTOUR ? { ...this.state.contour, showLayer: !this.state.contour?.showLayer } : this.state.contour
      }, async () => {

        if ((layer.image_type == "SHP" || layer.image_type == "KML") && !layer.showLayer && layer.image_url) {
          this.fetchGeoJSON(layer.image_url, layer.id, layer.properties.color, layer.image_type)
        }
        else {
          if (layer.showLayer && !type) this.setState({ allAssetLayersSelected: false })//if incoming layer had checkmark on,this means this func is called to tuen off the layer,so one of the layer out of all layers is turned off so sett the all layers selected state as false
          if (layer.shapeLayer) { //if shape layer already has drawn layer

            if (layer.showLayer) {

              let allLayersDeselected = true
              if (type === AppConstants.ASSETS.CONTOUR) {

              } else {

                await Promise.all(this.state.assetsLayers.map(lyr => {
                  return new Promise((resolve, reject) => {
                    if (lyr.showLayer) allLayersDeselected = false
                    resolve()
                  })
                }))
              }
              layer.shapeLayer.removeFrom(this.state.map)
              this.setState({ importLoading: false, disableLayers: false }, () => {
              })
            }
            else {
              layer.shapeLayer.addTo(this.state.map)
              let featureGrp = L.featureGroup(layer.shapeLayer.getLayers())
              this.state.map.fitBounds(featureGrp.getBounds())
              this.setState({ importLoading: false, disableLayers: false })
            }
          }
          else if (!layer.showLayer && layer.image_url) {
            this.fetchGeoJSON(layer.image_url, layer.id, layer.properties.color, layer.image_type) //else send to fetch geojson for drawing shapelayer
          }
        }
      })
      resolve()
    })
  }
  downloadContourShapeFile = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    triggerBlobDownload(blob, "contour_shape.zip")
  }
  downloadContourDXFFile = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    triggerBlobDownload(blob, "contour_dxf.zip")
  }
  handleLayerDownload = async (image_url, image_type, file_name) => {
    const url = image_url + "?" + this.state.permissions.st; // Replace with your temporary link URL
    if (image_type === AppConstants.ASSETS.DETECTION) {
      const response = await fetch(url);
      const blob = await response.blob();
      if (file_name) triggerBlobDownload(blob, `${file_name}.json`)
      else triggerBlobDownload(blob, "detection.json")
    }
    else if (image_type === AppConstants.ASSETS.KML) {
      const response = await fetch(url);
      const blob = await response.blob();
      if (file_name) triggerBlobDownload(blob, `${file_name}.kml`)
      else triggerBlobDownload(blob, "output.kml")
    }
    else if (image_type === AppConstants.ASSETS.SHP) {
      const response = await fetch(url);
      const blob = await response.blob();
      if (file_name) triggerBlobDownload(blob, `${file_name}.zip`)
      else triggerBlobDownload(blob, "output.zip")
    }
    else if (image_type === AppConstants.ASSETS.GEOJSON) {
      const response = await fetch(url);
      const blob = await response.blob();
      if (file_name) triggerBlobDownload(blob, `${file_name}.json`)
      else triggerBlobDownload(blob, "output.json")
    }
    else if (image_type === AppConstants.ASSETS.CONTOUR) {
      this.downloadContourShapeFile(url)
      const dxf_url = url.replace('contour_shape', 'contour_dxf')
      this.downloadContourDXFFile(dxf_url)
    }
    else {
      // alert(image_type)
      const link = document.createElement('a');
      link.href = url;
      link.click();
    }
  }
  getImportedFileName = (file, fileInfo) => {
    let assetType = ""
    if (fileInfo.type === AppConstants.ASSETS.SHP || fileInfo.type === AppConstants.ASSETS.KML || fileInfo.type === AppConstants.ASSETS.GEOJSON) assetType = "imported"
    if (fileInfo.type === AppConstants.ASSETS.CAD || fileInfo.type === AppConstants.ASSETS.DWG || fileInfo.type === AppConstants.ASSETS.DXF) assetType = "cad"
    if (fileInfo.type === "Detection") assetType = "detection"
    let splitedFile = file.includes(".") ? file.substring(0, file.lastIndexOf(".")) : file
    splitedFile = splitedFile.replace(/\./g, '_')
    const sameFileNameCount = this.state.assetsLayers.filter(lyr => lyr.task_name === splitedFile && (assetType === "imported" ? (lyr.image_type === AppConstants.ASSETS.SHP || lyr.image_type === AppConstants.ASSETS.KML || lyr.image_type === AppConstants.ASSETS.GEOJSON) : assetType === "detection" ? (lyr.image_type === AppConstants.ASSETS.DETECTION) : assetType === "cad" ? (lyr.image_type === AppConstants.ASSETS.CAD && (this.state.selectedFloor?.id ? (lyr.image_url.includes(this.state.selectedFloor?.id)) : true)) : "")).length;
    if (sameFileNameCount > 0) return splitedFile + "_" + (Math.floor((new Date()) / 1000))
    else return splitedFile
  }


  handleDeleteLayer = async ({ image_url, image_type, id, shapeLayer }) => {
    let blobURL = image_url.split(image_type === AppConstants.ASSETS.SHP ? ".zip" : image_type === AppConstants.ASSETS.KML ? ".kml" : image_type === AppConstants.ASSETS.CAD ? ".dxf" : "")[0] + "." + "json"

    this.setState({
      showImportFilePopUp: false,
      shapeFileItems: "WAIT",
      shapeFileIcon: "WAIT",
      shapeFileMsg: "Deleting Layer...",
      shapeFilePopup: true,
    });

    await API.deleteMapAssets(id, blobURL).then(result => {
      if (shapeLayer) shapeLayer.removeFrom(this.state.map)
      this.setState({
        showImportFilePopUp: false,
        shapeFileItems: undefined,
        shapeFileIcon: undefined,
        shapeFileMsg: undefined,
        shapeFilePopup: false,
        layerToDelete: undefined,
        assetsLayers: this.state.assetsLayers.filter(lyr => lyr.id !== id), activityPopupObj: {
          item: "COMPLETE",
          open: true,
          icon: "COMPLETE",
          msg: "Layer deleted successfully. ",
        }
      }, () => {

      })
    }).catch(err => {
      console.log(err)
      this.setState({ universalActivityPopup_msg: "Something went wrong while deleting layer.", universalActivityPopup_icon: "ERROR", showUniversalActivityPopup: true })
    }
    )

  }

  openDeleteLayerConfirmation = (data) => {
    this.setState({
      layerToDelete: data,
      deleteMultipleLayers: false,
      deleteLayerItems: "WARNING",
      deleteLayerIcon: "WARNING",
      deleteLayerMsg: `Are you sure, you want to delete ?`,
      deleteLayerPopup: true,
      deleteMultipleLayerType: "Imported"
    })
  }

  toggleLayerOptions = (id) => {
    this.setState({
      assetsLayers: this.state.assetsLayers.map(lyr => {
        if (lyr.id === id) {
          return { ...lyr, showOptions: !(lyr.showOptions) }
        } else return { ...lyr, showOptions: false }
      })
    })
  }
  checkIsLatLng = (geojson) => {
    let isLatLngs = false;
    let coord = geojson.features[0].geometry.coordinates

    if (geojson.features[0].geometry.type === "Point") {
      isLatLngs = coord[0] && (coord[0].toString().split(".")[0].length <= 3 && coord[0] >= -90 && coord[0] <= 90)
    } else if (geojson.features[0].geometry.type === "Polygon") {
      isLatLngs = (coord[0]?.[0]?.[0] && (coord[0][0][0].toString().split(".")[0].length <= 3 && coord[0][0][0] >= -90 && coord[0][0][0] <= 90)) || (coord[0][0] && (coord[0][0].toString().split(".")[0].length <= 3 && coord[0][0] >= -90 && coord[0][0] <= 90))
    } else if (geojson.features[0].geometry.type === "LineString") {
      isLatLngs = (coord[0]?.[0] && (coord[0][0].toString().split(".")[0].length <= 3 && coord[0][0] >= -90 && coord[0][0] <= 90))
    } else if (geojson.features[0].geometry.type === "MultiLineString") {
      isLatLngs = (coord[0]?.[0]?.[0] && (coord[0][0][0].toString().split(".")[0].length <= 3 && coord[0][0][0] >= -90 && coord[0][0][0] <= 90))
    }
    else if (geojson.features[0].geometry.type === "GeometryCollection") {
      let coord = geojson.features[0].geometry.geometries[0]
      if (coord.type === "Point") {
        isLatLngs = (coord.coordinates[0] && (coord.coordinates[0].toString().split(".")[0].length <= 3 && coord.coordinates[0] >= -90 && coord.coordinates[0] <= 90))
      } else if (coord.type === "Polygon") {
        isLatLngs = (coord.coordinates[0]?.[0] && (coord.coordinates[0][0].toString().split(".")[0].length <= 3 && coord.coordinates[0][0] >= -90 && coord.coordinates[0][0] <= 90))
      } else if (coord.type === "LineString") {
        isLatLngs = (coord.coordinates[0]?.[0] && (coord.coordinates[0][0].toString().split(".")[0].length <= 3 && coord.coordinates[0][0] >= -90 && coord.coordinates[0][0] <= 90))
      } else if (coord.type === "MultiLineString") {
        isLatLngs = (coord.coordinates[0]?.[0]?.[0] && (coord.coordinates[0][0][0].toString().split(".")[0].length <= 3 && coord.coordinates[0][0][0] >= -90 && coord.coordinates[0][0][0] <= 90))
      }
    }
    return isLatLngs
  }

  convertUtmToLatLng = async (GeoJSON) => {
    let typeOfGeometry = []
    return new Promise(async (resolve, reject) => {
      const features = Array.isArray(GeoJSON?.features) ? GeoJSON.features : []
      resolve({
        ...GeoJSON, features: await Promise.all(features.map((feature, i) => {
          return new Promise((resolve, reject) => {

            const geom = feature?.geometry
            const gtype = geom?.type
            typeOfGeometry.push(gtype ? gtype : feature?.type ? feature?.type : feature)

            if (!geom || !gtype) {
              resolve(feature)
              return
            }

            if (gtype === "Point" && Array.isArray(geom.coordinates)) {
              let { lat, lng } = utm.convertUtmToLatLng(geom.coordinates[0], geom.coordinates[1], this.state.zoneNumber, this.state.zoneLetter,)
              resolve({ ...feature, geometry: { ...geom, coordinates: [lng, lat] } })
            } else if (gtype === "LineString" && Array.isArray(geom.coordinates)) {
              let coordinates = geom.coordinates.map(coords => {
                let { lat, lng } = utm.convertUtmToLatLng(coords[0], coords[1], this.state.zoneNumber, this.state.zoneLetter,)
                return [lng, lat]
              })
              resolve({ ...feature, geometry: { ...geom, coordinates } })
            } else if (gtype === "Polygon" && Array.isArray(geom.coordinates?.[0])) {
              let coordinates = geom.coordinates[0].map(coords => {
                let { lat, lng } = utm.convertUtmToLatLng(coords[0], coords[1], this.state.zoneNumber, this.state.zoneLetter,)
                return [lng, lat]
              })
              resolve({ ...feature, geometry: { ...geom, coordinates } })
            } else if (gtype === "MultiLineString" && Array.isArray(geom.coordinates)) {
              let coordinates = geom.coordinates.map(coords => {
                let crds = Array.isArray(coords) ? coords.map(crd => {
                  let { lat, lng } = utm.convertUtmToLatLng(crd[0], crd[1], this.state.zoneNumber, this.state.zoneLetter,)
                  return [lng, lat]
                }) : []
                return crds
              })
              resolve({ ...feature, geometry: { ...geom, coordinates } })
            } else if (gtype === "GeometryCollection") {
              const geoms = Array.isArray(geom.geometries) ? geom.geometries : []
              let geometries = geoms.map(gm => {
                if (!gm?.type) return gm
                if (gm.type === "Point" && Array.isArray(gm.coordinates)) {
                  let { lat, lng } = utm.convertUtmToLatLng(gm.coordinates[0], gm.coordinates[1], this.state.zoneNumber, this.state.zoneLetter,)
                  return { ...gm, coordinates: [lng, lat] }
                } else if (gm.type === "LineString" && Array.isArray(gm.coordinates)) {
                  let coordinates = gm.coordinates.map(coords => {
                    let { lat, lng } = utm.convertUtmToLatLng(coords[0], coords[1], this.state.zoneNumber, this.state.zoneLetter,)
                    return [lng, lat]
                  })
                  return { ...gm, coordinates }
                } else if (gm.type === "Polygon" && Array.isArray(gm.coordinates?.[0])) {
                  let coordinates = gm.coordinates[0].map(coords => {
                    let { lat, lng } = utm.convertUtmToLatLng(coords[0], coords[1], this.state.zoneNumber, this.state.zoneLetter,)
                    return [lng, lat]
                  })
                  return { ...gm, coordinates }
                } else if (gm.type === "MultiLineString" && Array.isArray(gm.coordinates)) {
                  let coordinates = gm.coordinates.map(coords => {
                    return (Array.isArray(coords) ? coords : []).map(crd => {
                      let { lat, lng } = utm.convertUtmToLatLng(crd[0], crd[1], this.state.zoneNumber, this.state.zoneLetter,)
                      return [lng, lat]
                    })
                  })
                  return { ...gm, coordinates }
                }
                return gm
              })
              resolve({ ...feature, geometry: { ...geom, geometries } })
            }
            else {
              resolve(feature)
            }
          })
        }))
      })
    })
  }
  replaceCADUTM = (geoJson, fileName, planId, floorId) => {
    API.replaceCADUTM({ geoJson, fileName, planId, floorId }).then(res => {
    })

  }
  convertAndReplaceCadGeojson = async () => {
    let geoJSON = await this.convertUtmToLatLng(this.state.uploadedCadData.geoJSON)
    this.replaceCADUTM(geoJSON, this.state.uploadedCadData.savedAsset.id, this.props.location.state.plan.id, this.state.selectedFloor?.id)
    await this.importGeoJson(geoJSON, this.state.uploadedCadData.savedAsset.color, this.state.uploadedCadData.savedAsset.id, this.state.uploadedCadData.savedAsset.image_type)
  }

  addFloor = (newFloor) => {
    API.addFloor({ ...newFloor, plan_id: this.props.location.state.plan.id }).then(res => {
      this.setState({ floors: [...this.state.floors, res.floor] })
    })
  }
  getAllFloors = () => {
    API.getAllFloors(this.props.location.state.plan.id).then(res => {
      if (res.floors) {

        this.setState({ floors: res.floors })
      } else {
      }
    })
  }

  deleteFloor = (id) => {
    API.deleteFloor(id).then(res => {
      if (this.state.activeSidepanel === this.state.activeSideBarFloor && this.state.sidebarPanel) {
        this.managePopup(false, true)
        this.setState({ activeSideBarFloor: "" }, () => {
          this.setState({ floors: this.state.floors.filter(flr => flr.id !== id) })
        })
      }
    })
  }

  closeFloorPlanning = () => {
    setTimeout(() => {
      if (this.state.map)
        this.state.map.invalidateSize()
    }, 600)
    this.setState({
      FloorImagesViewer: false,
      showFloors: false,
      minimizedFloorPlanningViewer: true,
      selectedFloor: undefined
      // activeSideBarFloor: undefined,
    })
  }
  handleImageAnnotationToolChange = (type, value) => {
    this.setState({ panning: value })
    this.toggleMeasurementButtons(type)
  }
  closeUniversalActivityPopup = (action) => {
    switch (action) {
      default:
    }
    this.setState({ universalActivityPopup_name: "", universalActivityPopup_msg: "", universalActivityPopup_icon: "", universalActivityPopup_action: "", showUniversalActivityPopup: false });
  }
  onOkUniversalActivityPopup = (action) => {
    switch (action) {
      default:
    }
    this.setState({ universalActivityPopup_name: "", universalActivityPopup_msg: "", universalActivityPopup_icon: "", universalActivityPopup_action: "", showUniversalActivityPopup: false });
  }

  updateRMAssignDroneState = (type) => {
    switch (type) {
      case "polygon":
        this.setState({
          showMeasurements: true,
          allMeasurementsShow: true,
          mapMeasurementsShow: true,
          globalMeasurementsShow: true
        }, () => { this.showMeasurements('polygon') })
        break;

      case "line":
        this.setState({
          showMeasurements: true,
          allMeasurementsShow: true,
          mapMeasurementsShow: true,
          globalMeasurementsShow: true
        }, () => { this.showMeasurements('line') })
        break;

      case "marker":
        this.setState({
          showMeasurements: true,
          allMeasurementsShow: true,
          mapMeasurementsShow: true,
          globalMeasurementsShow: true
        }, () => { this.showMeasurements('marker') })
        break;

      case "compare":
        this.setState((state) => ({
          ...state,
          inspectShow: false,
          showOnclickPointDetails: false,
          processTileIndex: "vNDVI"
        }), () => {
          this.toggleMeasurement("showPointer")
          this.updateHistogram()
          if (this.potree.current) {
            this.setState({ compare3DMode: true, drawVolumeBox: false }, () => {
              this.potree.current.toggleView()
              this.potree.current.exitPointCloudSlicing()
            })

          } else {
            this.compareFunction()
          }
        })
        break;

      case "inspect":
        this.setState((state) => ({
          ...state,
          inspectShow: !this.state.inspectShow,
          showMeasurements: false,
          toolTipShow: false,
          showOnclickPointDetails: false,

          allMeasurementsShow: this.state.inspectShow,
          mapMeasurementsShow: this.state.inspectShow,
          globalMeasurementsShow: this.state.inspectShow
        }), () => {
          this.inspectImages()
          if (!this.state.inspectShow) {
            this.setState({
              showMeasurements: true,
              toolTipShow: true,
            }, () => {
              this.showMeasurements("inspect_click")
            })
          }
          if (!(this.state.activeSidepanel === activeSidebarDownloadAssets || this.state.activeSidepanel === activeSidebarMapDetails)) {
            this.managePopup(false, true)
          }
        })

      default:
        break;
    }
  }

  callDrawingTool = (action) => {
    switch (action) {
      case "HOTSPOT":
        this.setState({ callMarkIssue: "HOTSPOT" })
        break;

      case "POLYGON":
        this.setState({ callMarkIssue: "POLYGON" })
        break;

      default: break;
    }
  }

  callback = (state) => {
    switch (state) {
      case "MARKISSUE":
        this.setState({ callMarkIssue: undefined })
        break;

      default:
        break;
    }
  }


  saveDetections = async (res, layerName) => {
    let features = [];
    let errorOccured = false;
    for (const r of res.ret) {
      const d = r.result.detections
      const isImgTiff = r.image.includes(".tif") || r.image.includes(".tiff")
      if (!isImgTiff) {
        errorOccured = true;
        break;
      }
      const resultArr = Object.entries(d)
      for (const det of resultArr) {
        let classFeatues = await Promise.all(det[1].data.map(dt => {

          return new Promise((resolve, reject) => {
            if (dt.poly.find(p => !p[0] || !p[1])) {
              errorOccured = true;
              resolve();
              return
            }

            resolve({
              "type": "Feature",
              "properties": {
                "className": det[0],
              },
              "geometry": {
                "type": dt.type || "Polygon",
                "coordinates": dt.poly.map(p => [p[1], p[0]])
              }
            })
          })
        }))
        features = [...features, ...classFeatues]
      }
      if (errorOccured) break;
    }
    if (errorOccured) {
      this.setState({
        showProcessPopup: true,
        processPopupIcon: "ERROR",
        processMessage: "Detection is invalid,make sure your detection features has valid coordinates!"
      })
      return;
    }
    let geoJSON = {
      "type": "FeatureCollection",
      "features": features
    }
    if (features.length === 0) {
      this.setState({
        showProcessPopup: true,
        processMessage: "Selected detection is empty!",
        processPopupIcon: "ERROR"
      })
      return;
    }
    let data = new FormData()
    data.append("test", 'test')
    data.append('planId', this.props.location.state.plan.id);
    data.append('taskId', this.state.orthoImageData?.task_id);
    data.append('layerName', this.getImportedFileName(layerName, { type: "Detection" }));
    data.append("layerType", AppConstants.ASSETS.DETECTION)
    data.append('geojson', JSON.stringify(geoJSON))
    API.saveMapAssets(data).then(async res => {
      const resp = await res.json();
      const color = getRandomHexColour()
      if (resp.geoJSON) {
        this.setState({ showProcessPopup: false, showEntitySelector: false, assetsLayers: [...this.state.assetsLayers, { ...resp.savedAsset[0], color, showLayer: true }] }, () => {
          this.importGeoJson(JSON.parse(resp.geoJSON), color, resp.savedAsset[0].id, resp.savedAsset[0].image_type)
        })
      }
    }).catch(err => console.log(err))
  }
  handleImportDetections = (detections) => {
    const detection = detections.entites[0]
    const type = detection.classes.map(cls => cls.name)
    API.getDetections(detection.task_id, type).then(async res => {
      this.saveDetections(res, detections.entites[0].task_name)
    })
  }
  isImportedLayer = (asset) => {
    return asset.image_type == AppConstants.ASSETS.GEOJSON || asset.image_type == AppConstants.ASSETS.KML || asset.image_type == AppConstants.ASSETS.SHP || (asset.image_type == AppConstants.ASSETS.CAD && asset.image_url.includes("/importedLayers"))
  }
  handleToggleLabels = (value) => {
    if (value && this.state.selectedMeasurement.coordinates.length > 1400) {
      CustomPopup.alert("WARNING", "The selected measurement is very large, viewing its labels may crash your system, Do you want to continue?", () => {
        this.setState({
          selectedMeasurement: { ...this.state.selectedMeasurement, showLabels: value },
          measurements: this.state.measurements.map(m => {
            if (m.id == this.state.selectedMeasurement.id) return { ...m, showLabels: value };
            else return m;
          })
        })
        const index = this.state.measurements.findIndex(m => m.id == this.state.selectedMeasurement.id)
        toggleMeasurementTooltips(value, this.state.drawnMeasurements[index], this.state.map, this.state.selectedUnit?.value, this.state.selectedMeasurement)
      })
    } else {

      this.setState({
        selectedMeasurement: { ...this.state.selectedMeasurement, showLabels: value },
        measurements: this.state.measurements.map(m => {
          if (m.id == this.state.selectedMeasurement.id) return { ...m, showLabels: value };
          else return m;
        })
      })
      const index = this.state.measurements.findIndex(m => m.id == this.state.selectedMeasurement.id)
      toggleMeasurementTooltips(value, this.state.drawnMeasurements[index], this.state.map, this.state.selectedUnit?.value, this.state.selectedMeasurement)
    }
  }
  render() {
    let { images, activeProcessTileType, errorWhileDownloading, bandsList } = this.state
    let { user, type } = this.state;
    return (
      <>
        <input
          id='fileImporter'
          style={{ display: 'none' }}
          type="file"
          ref={this.fileInputRef}
          onChange={(e) => this.onSelectFiles(e)}
        />
        {/* {this.state.importLoading && <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", fontSize: "200px", color: "white", zIndex: 99 }}>Loading......</div>} */}
        {/*  */}
        {(this.state.uploadFileEvent) ? <SaveShapeFile ref={this.fileEventRef}

          fileEvent={this.state.uploadFileEvent}
          taskObj={({ planId: this.props.location.state.plan.id, taskId: this.state.orthoImageData?.task_id, taskName: this.state.orthoImageData?.task_name, layerName: this.getImportedFileName(this.state.uploadFileEvent.file.name, this.state.uploadFileEvent), zoneLetter: this.state.zoneLetter, zoneNumber: this.state.zoneNumber, floorId: this.state.selectedFloor?.id, properties: { color: getRandomHexColour() } })}
          onFileUpload={async (geoJSON, savedAsset, showPopup) => {
            if (geoJSON?.features && geoJSON?.features?.length > 0) {
              const color = savedAsset?.properties?.color || "red"
              this.setState({ shapeFilePopup: false, saveShapeFilePopup: false, uploadFileEvent: undefined, shpFileEvent: undefined, assetsLayers: [...this.state.assetsLayers, { ...savedAsset, color, showLayer: true }], cadLocationSelected: false, }, () => {
              })
              if (savedAsset.image_type === AppConstants.ASSETS.CAD && !this.checkIsLatLng(geoJSON)) {
                this.setState({ uploadedCadData: { geoJSON, savedAsset: { ...savedAsset, color } } }, () => {
                  this.openSelectZoneWarning()
                })
              } else {
                if (savedAsset.image_type === AppConstants.ASSETS.CAD) this.setState({ uploadedCadData: { geoJSON, savedAsset: { ...savedAsset, color } } })
                else if (savedAsset.image_type === AppConstants.ASSETS.SHP) { this.setState({ selectedLayerGeoJson: { geoJSON, color, id: savedAsset.id, image_type: savedAsset.image_type }, selectedLabel: Object.keys(geoJSON.features[0]?.properties)[0] }) }
                else if (savedAsset.image_type === AppConstants.ASSETS.KML) { this.setState({ selectedLayerGeoJsonForKML: { geoJSON, color, id: savedAsset.id, image_type: savedAsset.image_type }, selectedLabel: Object.keys(geoJSON.features[0]?.properties)[0] }) }
                else this.importGeoJson(geoJSON, color, savedAsset.id, savedAsset.image_type)
              }
            }
            else {
              this.setState({
                invalidFileItems: "ERROR",
                invalidFileIcon: "ERROR",
                invalidFileMsg: "Invalid File",
                invalidFilePopup: true,
                saveShapeFilePopup: false, uploadFileEvent: undefined, shpFileEvent: undefined, shapeFilePopup: false,
              })
            }
          }}
        /> : <></>}

        {this.state.showEntitySelector &&
          <EntitySelector
            serviceList={[AppConstants.SERVICES.PICSTORK]}
            btnTitle={"Import"}
            show={this.state.showEntitySelector}
            entity={"detections"}
            onRequestClose={() => {
              this.setState({ showEntitySelector: false })
            }}
            callback={async (selectedEntities) => {
              this.setState({
                showProcessPopup: true,
                processPopupIcon: "WAIT",
                processMessage: `Importing ${selectedEntities.entityType} please wait...`
              }, () => {

                this.handleImportDetections(selectedEntities)
              })

            }}
          />}
        {/* Import file Popup */}
        {
          <AnimatedModal
            isOpen={this.state.showImportFilePopUp}
            height="212px"
            width="auto">

            <div>

              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <img src={transClose} style={{ width: '27px', margin: "7px 4px 0px", height: '18px', cursor: "pointer", opacity: '0.7' }}
                  onClick={() => {
                    this.setState({ showImportFilePopUp: false })
                  }}
                />
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", margin: "21px", height: "100px", columnGap: "20px" }}>
                {/* import shp */}

                <div style={{ textAlign: "center", width: "100px", height: "125px", border: "1px solid rgb(234, 234, 234)", borderRadius: "5px" }} >
                  <div style={{ height: "84px", backgroundColor: "#eaeaea", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }} >
                    <img src={shapeFileIcon} alter="Orthomosaic" style={{ height: "20px", width: "25px", margin: "25px 0 6px 0" }} /> <br />
                    <span style={{ fontSize: "12px", color: "#3c3c3c" }}> Shape</span>
                    <br />
                    <ButtonWithIcon text="Upload" height="20px" width="75px" margin="18px 10px 10px 10px" fontSize="8px" fontWeight="400"

                      onClick={() => {
                        this.importFiles(".zip,")
                        this.setState({ selectedFilesExt: ".zip" });
                      }}
                    />
                  </div>
                </div>

                {/* import kml */}
                <div style={{ textAlign: "center", width: "100px", height: "125px", border: "1px solid rgb(234, 234, 234)", borderRadius: "5px" }} >
                  <div style={{ height: "84px", backgroundColor: "#eaeaea", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }} >
                    <img src={kmlFileIcon} alter="Orthomosaic" style={{ height: "20px", width: "25px", margin: "25px 0 6px 0" }} /> <br />
                    <span style={{ fontSize: "12px", color: "#3c3c3c" }}> KML</span>
                    <br />
                    <ButtonWithIcon text="Upload" height="20px" width="75px" margin="18px 10px 10px 10px" fontSize="8px" fontWeight="400"

                      onClick={() => {
                        this.importFiles(".kml")
                        this.setState({ selectedFilesExt: ".kml" });
                      }}
                    />
                  </div>
                </div>
                {/* import CAD */}
                <div style={{ textAlign: "center", width: "100px", height: "125px", border: "1px solid rgb(234, 234, 234)", borderRadius: "5px" }} >
                  <div style={{ height: "84px", backgroundColor: "#eaeaea", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }} >
                    <img src={kmlFileIcon} alter="Orthomosaic" style={{ height: "20px", width: "25px", margin: "25px 0 6px 0" }} /> <br />
                    <span style={{ fontSize: "12px", color: "#3c3c3c" }}> CAD</span>
                    <br />
                    <ButtonWithIcon text="Upload" height="20px" width="75px" margin="18px 10px 10px 10px" fontSize="8px" fontWeight="400"

                      onClick={() => {
                        this.importFiles(".dxf, .dwg, .DWG, .DXF")
                        this.setState({ selectedFilesExt: ".dxf" });
                      }}
                    />
                  </div>
                </div>

                {/* import json/geojson */}
                <div style={{ textAlign: "center", width: "100px", height: "125px", border: "1px solid rgb(234, 234, 234)", borderRadius: "5px" }} >
                  <div style={{ height: "84px", backgroundColor: "#eaeaea", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }} >
                    <img src={kmlFileIcon} alter="Orthomosaic" style={{ height: "20px", width: "25px", margin: "25px 0 6px 0" }} /> <br />
                    <span style={{ fontSize: "12px", color: "#3c3c3c" }}> GeoJSON</span>
                    <br />
                    <ButtonWithIcon text="Upload" height="20px" width="75px" margin="18px 10px 10px 10px" fontSize="8px" fontWeight="400"

                      onClick={() => {
                        this.importFiles(".json, .geojson")
                        this.setState({
                          showImportFilePopUp: false,
                          selectedFilesExt: ".json"
                        })
                      }}
                    />
                  </div>
                </div>
                {/* import detections from picstork */}
                <div style={{ textAlign: "center", width: "100px", height: "125px", border: "1px solid rgb(234, 234, 234)", borderRadius: "5px" }} >
                  <div style={{ height: "84px", backgroundColor: "#eaeaea", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }} >
                    <img src={kmlFileIcon} alter="Orthomosaic" style={{ height: "20px", width: "25px", margin: "25px 0 6px 0" }} /> <br />
                    <span style={{ fontSize: "12px", color: "#3c3c3c" }}> Detections</span>
                    <br />
                    <ButtonWithIcon text="Import" height="20px" width="75px" margin="18px 10px 10px 10px" fontSize="8px" fontWeight="400"

                      onClick={() => {
                        this.setState({
                          showEntitySelector: true,
                          showImportFilePopUp: false
                        })
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </AnimatedModal >
        }
        {/* Import file Popup */}

        {/* select Label Popup for shp file */}
        {
          <AnimatedModal
            isOpen={this.state.selectedLayerGeoJson}
            height="225PX"
            width="290px">
            <div style={{ position: "relative", height: "100%", width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 10px 10px 20px", borderBottom: "1px solid #D9D9D9" }}>
                <div style={{
                  color: "#3C3C3C" //"#2989cf"
                }}>Select Label</div>
                <div style={{ cursor: "pointer" }} >
                  <img src={transClose} style={{ width: '18px', height: '18px', cursor: "pointer" }} onClick={() => {
                    this.importGeoJson(this.state.selectedLayerGeoJson.geoJSON, this.state.selectedLayerGeoJson.color, this.state.selectedLayerGeoJson.id, this.state.selectedLayerGeoJson.image_type, undefined);
                    this.setState({ selectedLayerGeoJson: undefined, selectedLabel: undefined })
                  }} />
                </div>
              </div>
              <div style={{
                height: "125px",
                textAlign: "left",
                overflow: "auto",
                color: "#666666",
              }}>
                {
                  this.state.selectedLayerGeoJson ? Object.keys(this.state.selectedLayerGeoJson?.geoJSON?.features[0]?.properties).map(label => {
                    if (!(label == "2D Area" || label == "2D Perimet" || label == "3D Area" | label == "3D Perimet")) {
                      return <div onClick={() => { this.setState({ selectedLabel: label }) }}
                        style={{
                          paddingLeft: "20px",
                          cursor: "pointer",
                          backgroundColor: this.state.selectedLabel == label && "#2989CF",
                          color: this.state.selectedLabel == label && "white",
                          height: "30px",
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          fontSize: "13px",
                        }}
                      >{label}</div>
                    }
                  }) : <></>
                }
              </div>
              <div style={{ bottom: "0px", display: "flex", width: "100%", borderTop: "1px solid #D9D9D9", justifyContent: "right", padding: "10px", right: "0px", position: "absolute" }}>
                <ButtonWithIcon text="Apply" isBtnActive
                  onClick={() => {
                    this.importGeoJson(this.state.selectedLayerGeoJson.geoJSON, this.state.selectedLayerGeoJson.color, this.state.selectedLayerGeoJson.id, this.state.selectedLayerGeoJson.image_type, this.state.selectedLabel)
                    this.setState({ selectedLayerGeoJson: undefined, selectedLabel: undefined })
                  }}
                />
              </div>
            </div>
          </AnimatedModal >
        }

        {/* select Label Popup for KML file */}
        {
          <AnimatedModal
            isOpen={this.state.selectedLayerGeoJsonForKML}
            height="225PX"
            width="290px">
            <div style={{ position: "relative", height: "100%", width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 10px 10px 20px", borderBottom: "1px solid #D9D9D9" }}>
                <div style={{
                  color: "#3C3C3C" //"#2989cf"
                }}>Select Label</div>
                <div style={{ cursor: "pointer" }} >
                  <img src={transClose} style={{ width: '18px', height: '18px', cursor: "pointer" }} onClick={() => {
                    this.importGeoJson(this.state.selectedLayerGeoJsonForKML.geoJSON, this.state.selectedLayerGeoJsonForKML.color, this.state.selectedLayerGeoJsonForKML.id, this.state.selectedLayerGeoJsonForKML.image_type, undefined);
                    this.setState({ selectedLayerGeoJsonForKML: undefined, selectedLabel: undefined })
                  }} />
                </div>
              </div>
              <div style={{
                height: "125px",
                textAlign: "left",
                overflow: "auto",
                color: "#666666",
              }}>
                {
                  this.state.selectedLayerGeoJsonForKML ? Object.keys(this.state.selectedLayerGeoJsonForKML?.geoJSON?.features[0]?.properties).map(label => {
                    if (!(label == "2D Area" || label == "2D Perimet" || label == "3D Area" | label == "3D Perimet")) {
                      return <div onClick={() => { this.setState({ selectedLabel: label }) }}
                        style={{
                          paddingLeft: "20px",
                          cursor: "pointer",
                          backgroundColor: this.state.selectedLabel == label && "#2989CF",
                          color: this.state.selectedLabel == label && "white",
                          height: "30px",
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          fontSize: "13px",
                        }}
                      >{label}</div>
                    }
                  }) : <></>
                }
              </div>
              <div style={{ bottom: "0px", display: "flex", width: "100%", borderTop: "1px solid #D9D9D9", justifyContent: "right", padding: "10px", right: "0px", position: "absolute" }}>
                <ButtonWithIcon text="Apply" isBtnActive
                  onClick={() => {
                    this.importGeoJson(this.state.selectedLayerGeoJsonForKML.geoJSON, this.state.selectedLayerGeoJsonForKML.color, this.state.selectedLayerGeoJsonForKML.id, this.state.selectedLayerGeoJsonForKML.image_type, this.state.selectedLabel)
                    this.setState({ selectedLayerGeoJsonForKML: undefined, selectedLabel: undefined })
                  }}
                />
              </div>
            </div>
          </AnimatedModal >
        }
        {/* -- Add field Popup -- */}

        <AnimatedModal
          isOpen={this.state.addProperty}
          // isOpen={true}
          height="290PX"
          width="380px"
        >
          <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", position: "relative" }}>
            <div style={{ color: "#2989cf", display: "flex", alignItems: "center", justifyContent: "space-between", textAlign: "left", backgroundColor: "#D9D9D9", padding: "10px 20px", fontWeight: "500", fontSize: "17px" }}>
              Add Field
              <img src={transClose} style={{ width: '18px', height: '18px', cursor: "pointer" }}
                onClick={() => {
                  this.setState({
                    addProperty: false,
                    propertyObj: {},
                    propertyKey: "",
                    propertyValue: "",
                  })
                }}
              />
            </div>

            <div style={{ display: "flex", borderBottom: '1px solid #e5e5e5', justifyContent: "space-between" }}>
              <div style={{ height: "100%", display: "flex", justifyContent: "center", color: "#666666", fontSize: "13px", padding: "10px 10px 1px 20px", columnGap: "90px" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "start", width: "100%", height: "70px" }}>
                  <div style={{ margin: "0 0 5px 5px" }}>Key</div>
                  <input maxLength={10} style={{ height: "27px", borderRadius: "5px", padding: "0px 10px", width: "100%", border: "1px solid #b4b4bb", outline: "none" }} type="text"
                    placeholder="Field Key"
                    value={this.state.propertyKey}
                    onChange={(e) => {
                      if (!(Boolean(e.target.value.match(/\s/)))) this.setState({ propertyKey: e.target.value.includes(" ") ? null : e.target.value, keyWarning: false, valueWarning: false })
                      else { e.target.value = ""; this.setState({ keyWarning: true, valueWarning: false }) }
                    }}
                  />
                  {this.state.keyWarning && <div style={{ fontSize: "9px", paddingTop: "5px", color: "red" }}>Spaces are prohibited.</div>}
                </div>
              </div>
              <div style={{ height: "100%", display: "flex", justifyContent: "center", color: "#666666", fontSize: "13px", padding: "10px 10px 10px 20px", columnGap: "90px" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "start", width: "100%", height: "70px" }}>
                  <div style={{ margin: "0 0 5px 5px" }}>Value</div>
                  <input maxLength={10} style={{ height: "27px", borderRadius: "5px", padding: "0px 10px", width: "100%", border: "1px solid #b4b4bb", outline: "none" }} type="text"
                    placeholder="Field value"
                    value={this.state.propertyValue}
                    onChange={(e) => {
                      if ((!(Boolean(/\s/.test(e.target.value)))))
                        this.setState({
                          propertyValue: e.target.value.includes(" ") ? null : e.target.value, valueWarning: false,
                          keyWarning: false
                        })
                      else {
                        e.target.value = "";
                        this.setState({ valueWarning: true, keyWarning: false })
                      }
                    }}
                  />
                  {this.state.valueWarning && <div style={{ fontSize: "9px", paddingTop: "5px", color: "red" }}>Spaces are prohibited.</div>}
                </div>
              </div>
              <div style={{ height: "70px", display: "flex", justifyContent: "center", color: "#666666", fontSize: "13px", padding: "34px 10px 10px 0px", columnGap: "90px" }}>
                <ButtonWithIcon text="add" icon={AddIcon}
                  isDisabled={!(this.state.propertyKey && this.state.propertyValue)}
                  onClick={() => {

                    let { selectedMeasurement, propertyKey, propertyValue, propertyObj } = this.state;

                    this.setState({
                      propertyObj: { ...propertyObj, [propertyKey]: propertyValue },
                      propertyKey: "",
                      propertyValue: "",
                    })
                  }}
                />
              </div>
            </div>
            <div style={{ borderBottom: '1px solid #e5e5e5', position: "relative", height: "100px", overflow: "auto", textAlign: "left" }}>
              {
                Object.keys(this.state.propertyObj).length > 0 ?
                  Object.keys(this.state.propertyObj).map((item) => {
                    return <div style={{ paddingLeft: "20px" }}>
                      <div style={{ color: "#666666", fontSize: "13px", marginTop: "5px" }}> {`${item} : ${this.state.propertyObj[item]}`} </div>
                    </div>
                  }) : <div style={{
                    top: "50%",
                    position: "absolute",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}>
                    <div style={{ color: "#666666", fontSize: "13px" }}> No fields are available </div>
                  </div>
              }
            </div>
            <div style={{
              height: "50px",
              display: "flex",
              justifyContent: "right",
              padding: "10px 10px",
            }}>
              <ButtonWithIcon text="Done" isBtnActive isDisabled={!(Object.keys(this.state.propertyObj).length > 0)}
                onClick={() => {
                  let { selectedMeasurement, measurements, propertyKey, propertyValue, propertyKeysArr, propertyObj, finalOtherProperties } = this.state;

                  this.setState({
                    selectedMeasurement: { ...selectedMeasurement, properties: { ...selectedMeasurement.properties, ...propertyObj } },
                    propertyKey: "",
                    propertyValue: "",
                    propertyObj: {},
                    finalOtherProperties: { ...finalOtherProperties, ...selectedMeasurement.properties, ...propertyObj }
                  }, () => {
                    let index = measurements.findIndex(item => item.id === selectedMeasurement.id);

                    if (index !== -1) {
                      const updatedItems = [
                        ...measurements.slice(0, index),
                        { ...this.state.selectedMeasurement },
                        ...measurements.slice(index + 1),
                      ];

                      // Update the state with the new array
                      this.setState({
                        measurements: updatedItems,
                        addProperty: false,
                        propertyKeysArr: [...propertyKeysArr, propertyKey]
                      }, () => {
                        this.saveMeasurementDetails(this.state.selectedMeasurement)
                      });
                    }
                  })



                }}
              />
            </div>
          </div>

        </AnimatedModal>

        {/* -- End Add field Popup -- */}


        {/* Import file Popup */}

        <div className="wrapper">
          <div style={{ display: 'flex' }}>
            <div ref={this.suggestionsPortalRef} style={{ position: 'absolute', zIndex: 100, }} />
            <div className="sidebar-expanded" style={{ paddingTop: "0px" }}>
              <div style={{ display: "flex", height: "40px" }}>
                <div style={{ height: "40px", transition: "0.3s", margin: 'auto' }}>
                  <img
                    src={AeroMeghLogo}
                    style={{ width: "65px", height: "20px", marginTop: "10px" }}
                  />
                </div>
              </div>
              <ul className="sidebar-nav" id="sidebar-nav">
                <div className={"nonSelectBorder"} >
                  <li>
                    <Link
                      to={{
                        pathname: "/",
                        state: {
                          type,
                          user,
                        },
                      }}
                    >
                      <div
                        className="sidecontent"
                        id="sidecontent"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="sidebar-icon">
                          <img
                            className="sidebar-icon"
                            src={service}
                            alt="serviceIcon"
                          />
                        </div>
                        <div
                          name="service"
                          className={"sidebaropt"}
                          // style={{ color: "#2989CF" }}
                          onClick={this.changeColor}
                        >
                          {"Services"}
                        </div>
                      </div>
                    </Link>
                  </li>
                </div>


                <div className={"nonSelectBorder"} >
                  <li>
                    <Link
                      to={{
                        pathname: "/dronenaksha/dashboard",
                        state: {
                          type,
                          user,
                        },
                      }}
                    >
                      <div
                        className="sidecontent"
                        id="sidecontent"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="sidebar-icon">
                          <img
                            className="sidebar-icon"
                            src={dashboardIcon}
                            alt="serviceIcon"
                          />
                        </div>
                        <div
                          name="service"
                          className={"sidebaropt"}
                          // style={{ color: "#2989CF" }}
                          onClick={this.changeColor}
                        >
                          {"DroneNaksha"}
                        </div>
                      </div>
                    </Link>
                  </li>
                </div>
                <div className={"nonSelectBorder"} >
                  <li>
                    <Link
                      to={{
                        pathname: "/dronenaksha/plan",
                        state: {
                          type,
                          user,
                          plan: this.props.location.state.plan,
                          project: this.props.location.state.project,
                        },
                      }}
                    >
                      <div
                        className="sidecontent"
                        id="sidecontent"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="sidebar-icon">
                          <img
                            className="sidebar-icon"
                            src={projectInactive}
                            alt="serviceIcon"
                          />
                        </div>
                        <div
                          name="service"
                          className={"sidebaropt"}
                          // style={{ color: "#2989CF" }}
                          onClick={this.changeColor}
                        >
                          {"Plan"}
                        </div>
                      </div>
                    </Link>
                  </li>
                </div>

                <div className="selectBorder" >
                  <li>
                    <Link
                      to={{
                        pathname: "/dronenaksha/view_plan",
                        state: {
                          type,
                          user,
                          plan: this.props.location.state.plan,
                          project: this.props.location.state.project,
                        },
                      }}
                    >
                      <div
                        className="sidecontent"
                        id="sidecontent"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="sidebar-icon">
                          <img
                            className="sidebar-icon"
                            src={planActive}
                            alt="serviceIcon"
                          />
                        </div>
                        <div
                          name="service"
                          className={"sidebaropt"}
                          style={{ color: "#2989CF" }}
                        >
                          {"Map"}
                        </div>
                      </div>
                    </Link>
                  </li>
                </div>
                {this.state.orthoImageData && this.state.permissions[DRONENAKSHA_FEATURES.IMAGECOLLECTIONS].READ ?
                  <div className={"nonSelectBorder"} >
                    <li>
                      <Link
                        to={{
                          pathname: "/dronenaksha/images",
                          state: {
                            user: this.state.user,
                            type: this.state.type,
                            collection: { id: this.state.orthoImageData.collection_id, collection_name: this.state.orthoImageData.task_name, plan_id: this.props.location.state.plan.id, project_id: this.props.location.state.project.id },
                            plan: this.props.location.state.plan,
                            project: this.props.location.state.project,
                          }
                        }}
                      >
                        <div
                          className="sidecontent"
                          id="sidecontent"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="sidebar-icon">
                            <img
                              className="sidebar-icon"
                              src={imagesInactive}
                              alt="serviceIcon"
                            />
                          </div>
                          <div
                            name="service"
                            className={"sidebaropt"}
                          // style={{ color: "#2989CF" }}
                          // onClick={this.changeColor}
                          >
                            {"Images"}
                          </div>
                        </div>
                      </Link>
                    </li>
                  </div> : <></>}
                <div className={"nonSelectBorder"} >
                  <li>
                    <div
                      className="onhoverext"
                      onClick={
                        () => {
                          window.open("https://dronenaksha-docs.aeromegh.com/", "_blank")
                        }
                      }
                    >
                      <div
                        className="sidecontent"
                        id="sidecontent"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="sidebar-icon">
                          <img
                            className="sidebar-icon"
                            src={Help}
                            alt="serviceIcon"
                          />
                        </div>
                        <div
                          name="service"
                          className={"sidebaropt"}
                        >
                          {"Help"}
                        </div>
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>

            {/* Side panel measurements */}
            <div className="slide" id="histogram"
              style={{ fontSize: "9px", zIndex: 3, backgroundColor: 'white', textAlign: 'left', width: '23vw', height: "calc(100%-40px)", right: this.state.sidebarPanel ? '0vw' : "-24vw", top: "39px", bottom: "0px", position: 'fixed', boxShadow: '0px 6px 10px rgb(0 0 0 / 30%)', color: "white", fontWeight: "500" }}>

              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", pointerEvents: "all", height: "100%" }}>
                <div className={this.state.mapDataLoaded || this.state.ThreeDAvailable ? "AeroFarm" : "disableDiv"}
                  style={{ fontSize: "9px", width: "23vw", height: "100%", borderRadius: '3px', backgroundColor: "white", fontWeight: "500", padding: "10px 0px", marginBottom: "10px", height: "100%", overflow: this.state.activeSidepanel === activeSidebarLayers ? "hidden" : 'auto' }}>

                  {this.state.activeSidepanel !== activeSidebarMeasurement ?
                    <>
                      <div style={{ display: "flex", justifyContent: "space-between", padding: `0px 10px 0px ${this.state.activeSidepanel === this.state.activeSideBarFloor ? "15px" : "30px"}`, }}>
                        <div style={{ color: "#2989CF", fontSize: "14px", }}>{this.state.activeSidepanel}</div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "8px" }}>
                          {
                            this.state.activeSidepanel == activeSidebarLayers ?
                              <div style={{ marginRight: "10px" }}>
                                <ButtonWithIcon text="Import"
                                  // icon={DownArrow}
                                  height="20px" padding="0px 10px " width="75px"
                                  isDisabled={!(this.state.permissions?.[DRONENAKSHA_FEATURES.MAPS].EDIT)}
                                  onClick={() => {
                                    if (this.state.permissions?.[DRONENAKSHA_FEATURES.MAPS].EDIT) {
                                      this.setState({ showImportFilePopUp: true })
                                    }
                                  }} />
                              </div>
                              : <></>
                          }{this.state.activeSidepanel === this.state.activeSideBarFloor &&
                            <div style={{ backgroundColor: 'white', opacity: this.state.permissions?.[DRONENAKSHA_FEATURES?.MAPS]?.DELETE ? "1" : "0.5" }}><img style={{ width: '20px', height: '20px', cursor: this.state.permissions?.[DRONENAKSHA_FEATURES?.MAPS]?.DELETE ? "pointer" : "default", padding: "1px", marginRight: "10px", opacity: !(this.state.loadingVolume) ? 1 : 0.7 }} src={DeleteIcon}
                              onClick={() => {
                                if (this.state.permissions?.[DRONENAKSHA_FEATURES.MAPS]?.DELETE) this.setState({ deleteFloorPopup: true, deleteFloorMsg: "Are you sure, you want to delete this floor ?", deleteFloorIcon: "WARNING" })
                              }} />
                            </div>}
                          <img src={transClose} style={{ width: '18px', height: '18px', cursor: "pointer" }}
                            onClick={
                              () => {
                                this.setState((state) => ({
                                  ...state,
                                  sidebarPanel: false,
                                  activeSideBarFloor: "",
                                }), () => {

                                  let prevAtvLyr = (
                                    this.state.previousRGBShow ? "previousRGBShow"
                                      : this.state.previousNDVIShow ? "previousNDVIShow"
                                        : this.state.previousDEMShow ? "previousDEMShow"
                                          : this.state.previousDTMShow ? "previousDTMShow"
                                            : this.state.previousThreeDShow ? "previousThreeDShow"
                                              : this.state.previousPointCloudShow ? "previousPointCloudShow"
                                                : this.state.previousBothShowPT ? "bothPT" : "showFloors")

                                  this.toggleLayer(prevAtvLyr)
                                })
                              }
                            }
                          />
                        </div>

                      </div>
                      <hr style={{ marginBottom: "0px", marginTop: "0px", width: "23vw", borderColor: "#EAEAEA" }} /></> : <></>
                  }

                  {this.state.imageAnalysisLoader ?
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "74px 0px 74px 40px", }}><img width="100px" src={Loader} /></div> : <>
                      {
                        this.state.activeSidepanel == PlantHealthAnalysis ?

                          <>
                            <div>
                              <Histogram width={19.5}
                                height={15}
                                loading={false}
                                statistics={this.state.statistics}
                                colorMap={colorsMap}
                                initialMin={this.state.processTileMin}
                                initialMax={this.state.processTileMax}
                                histogramUnavailable={this.state.histogramUnavailable}
                                onUpdate={
                                  this.handleHistogramUpdate
                                } />
                              <div style={{ display: "flex", alignItems: "center", marginBottom: "6px", padding: '0px 30px' }}>
                                <div style={{ color: "#666666", fontSize: "10px", marginRight: '20px', width: '70px', }}>Algorithm:</div>
                                <SelectComponent
                                  selected={this.state.selectedAlgorithm}
                                  itemsList={this.state.selectAlgorithms}
                                  labelField={"value"}
                                  onchangeHandler={(value) => {
                                    this.setState({
                                      selectedAlgorithm: value,
                                      processTileIndex: value[0].value,
                                      activeProcessTileType: this.state.algorithms[value[0].label].filters,
                                      processTileType: this.state.algorithms[value[0].label].filters[0],
                                      processTileIndexNum: value[0].label,
                                      // showingProcessedTile: event.target.value === "vari" ? "VARI" : "plantHealth",
                                      // selectedLayer1: "plantHealth",
                                      // selectedLayer2: "plantHealth",
                                    }, () => {
                                      if (this.state.onclickMarker)
                                        this.state.onclickMarker.remove()
                                      this.updateHistogram().then((res) => {
                                        this.overlayTilesLayerOf("plantHealth");
                                      });
                                    })
                                  }}
                                  fontSize={12}
                                  fontWeight={400}
                                  width={"120px"}
                                  height={"28px"}
                                  iconSize={"10px"}
                                  border={true}
                                  dropdownGap={1}
                                  dropdownHeight={"185px"}
                                />
                              </div>
                              <div style={{ display: "flex", alignItems: "center", marginBottom: "8px", padding: '10px 30px' }}>
                                <div style={{ color: "#666666", fontSize: "10px", marginRight: '20px', width: '70px', }}>Filter Type:</div>
                                <SelectComponent
                                  selected={this.state.selectedFilter}
                                  itemsList={this.state.selectFilters}
                                  labelField={"value"}
                                  onchangeHandler={(value) => {
                                    this.setState({ processTileType: value[0].value, selectedFilter: value }, () => {
                                      this.updateHistogram().then((res) => {
                                        this.overlayTilesLayerOf("plantHealth");
                                      });
                                    })
                                  }}
                                  fontSize={12}
                                  fontWeight={400}
                                  width={"120px"}
                                  height={"28px"}
                                  iconSize={"10px"}
                                  border={true}
                                  dropdownGap={1}
                                />
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0px 30px' }}>
                                {this.state.isOwner || this.state.permissions[DRONENAKSHA_FEATURES.REPORTS].EDIT ? <div style={{ fontSize: '12px', margin: '5px 0px', color: '#2989CF', cursor: 'pointer', }}
                                  onClick={() => {
                                    this.setState((state) => ({
                                      ...state,
                                      report_type: "PLANTHEALTH"
                                    }))
                                    this.addDNReport()

                                  }}
                                >Add To Report</div> :
                                  <div style={{ fontSize: '12px', margin: '5px 0px', color: '#666666', cursor: 'not-allowed', opacity: 0.5 }}>Add To Report
                                  </div>
                                }
                              </div>
                              {this.state.reportLoader ? <div style={{ height: '30px', width: '100%' }}><img style={{ height: '100%', width: '100%' }} src={Loader} /></div>
                                : this.state.reportMsg ?
                                  <div style={{ color: this.state.reportMsgColor ? this.state.reportMsgColor : 'red', fontSize: '10px', fontWeight: '400', display: 'flex', justifyContent: 'flex-end', padding: '0px 30px' }}>{this.state.reportMsg}</div>
                                  : <></>}
                            </div>
                            {/* --------------- Range data layer --------------- */}
                            <PlantHealthIndexLayer
                              rangeMin={this.state.rangeMin}
                              rangeMax={this.state.rangeMax}
                              changeMinMax={(target, value) => {
                                if (value >= -1 && value <= 1 && !isNaN(value))
                                  this.setState({
                                    [target]: value,
                                  })
                              }}
                              showRangeData={this.state.showRangeData}
                              loadTiles={(refresh) => {
                                if (refresh) {
                                  if (this.state.rangeMax < this.state.rangeMin) {
                                    let temp = this.state.rangeMax
                                    this.setState({ rangeMax: this.state.rangeMin, rangeMin: temp })
                                  }
                                  this.overlayTilesLayerOf("plantHealth")
                                }
                                else
                                  this.setState({ showRangeData: !(this.state.showRangeData) }, () => {
                                    this.overlayTilesLayerOf("plantHealth")
                                  })
                              }}
                            />
                          </>
                          :
                          <>
                            {this.state.activeSidepanel === elevationAnalysis ?
                              // DSM DTM Div
                              <div style={{ display: "flex", "justifyContent": "center", alignItems: 'center', height: '85vh', fontSize: "14px", color: "black" }}>
                                No information available.
                              </div>
                              :
                              // image analysis div
                              <>
                                {this.state.activeSidepanel === OrthomosaicAnalysis ?
                                  <>
                                    <div>
                                      <div style={{ fontSize: "11px", color: "#666666", margin: "10px 0px 10px 0px", padding: '0px 30px' }}>Total Bands : {bandsList ? bandsList.length : '0'}</div>
                                      <div style={{ display: "flex", alignItems: 'center', marginBottom: "15px", padding: '0px 30px' }}>
                                        <div style={{ color: "#666666", fontSize: "11px", marginRight: '20px', width: '70px', }}>Band 1:</div>
                                        <SelectComponent
                                          selected={this.state.selectedBand1}
                                          itemsList={this.state.selectBandsList}
                                          onchangeHandler={(value) => { this.setState({ band1: value[0]?.value, selectedBand1: value }) }}
                                          fontSize={"11px"}
                                          fontWeight={400}
                                          width={"120px"}
                                          height={"28px"}
                                          iconSize={"10px"}
                                          border={true}
                                        />
                                      </div>
                                      <div style={{ display: "flex", alignItems: 'center', marginBottom: "15px", padding: '0px 30px' }}>
                                        <div style={{ color: "#666666", fontSize: "11px", marginRight: '20px', width: '70px', }}>Band 2:</div>
                                        <SelectComponent
                                          selected={this.state.selectedBand2}
                                          itemsList={this.state.selectBandsList}
                                          onchangeHandler={(value) => { this.setState({ band2: value[0]?.value, selectedBand2: value }) }}
                                          fontSize={"11px"}
                                          fontWeight={400}
                                          width={"120px"}
                                          height={"28px"}
                                          iconSize={"10px"}
                                          border={true}
                                        />
                                      </div>
                                      <div style={{ display: "flex", alignItems: 'center', marginBottom: "15px", padding: '0px 30px' }}>
                                        <div style={{ color: "#666666", fontSize: "11px", marginRight: '20px', width: '70px', }}>Band 3:</div>
                                        <SelectComponent
                                          selected={this.state.selectedBand3}
                                          itemsList={this.state.selectBandsList}
                                          onchangeHandler={(value) => { this.setState({ band3: value[0]?.value, selectedBand3: value }) }}
                                          fontSize={"11px"}
                                          fontWeight={400}
                                          width={"120px"}
                                          height={"28px"}
                                          iconSize={"10px"}
                                          border={true}
                                        />
                                      </div>
                                      <hr style={{ marginBottom: "8px", marginTop: "0px", width: "23vw", borderColor: "#EAEAEA" }} />
                                      <div style={{ display: 'flex', alignItems: 'center', padding: '0px 30px' }}
                                        className="hoverPointer"
                                        onClick={() => {
                                          this.setState({ defaultOrtho: !(this.state.defaultOrtho) }, () => {
                                            this.overlayTilesLayerOf("orthomosaic")
                                          })
                                        }}
                                      >
                                        <input type='checkbox' style={{ height: '15px', width: '15px', cursor: 'pointer' }}
                                          checked={this.state.defaultOrtho}
                                        />
                                        <span style={{ fontSize: '12px', marginLeft: '10px', color: '#3C3C3C', fontWeight: '400', }}>View Default</span>
                                      </div>
                                      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0px 30px' }}>
                                        <ButtonWithIcon
                                          text="Apply"
                                          width="100px"
                                          onClick={() => {
                                            this.setState({ defaultOrtho: false }, () => {
                                              this.overlayTilesLayerOf("orthomosaic")
                                            })
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </>
                                  // image analysis div end
                                  : <>
                                    {this.state.activeSidepanel == activeSidebarLayers ?
                                      <div style={{ overflowY: "", height: "calc(100% - 30px)", display: "flex", flexDirection: "column" }}>

                                        <div style={{ padding: "5px 30px 0 30px" }} >

                                          <div style={{ borderBottom: "1px solid rgb(218,220,224)", color: "#3c3c3c", fontSize: "11px", padding: "10px 0px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                            <input type='checkbox' style={{ cursor: 'pointer', marginBottom: "2px", height: "15px", width: "15px" }}
                                              checked={this.state.allMeasurementsShow}
                                              onClick={() => {
                                                this.setState({ allMeasurementsShow: !(this.state.allMeasurementsShow) }, () => {
                                                  this.toggleAllMeasurements()
                                                })
                                              }}
                                            />
                                            <div style={{ marginLeft: "10px", minWidth: "55px", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400" }}>{`All Measurements`}</div>
                                            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                                              <div onClick={() => {
                                                this.setState({
                                                  AllMeasurementMenu: !this.state.AllMeasurementMenu,
                                                  LocalMeasurementMenu: false,
                                                  GlobalMeasurementMenu: false,
                                                })
                                              }}
                                                style={{ position: "relative", height: "15px", width: "15px", marginLeft: "20px", marginBottom: "2px", cursor: "pointer" }}>
                                                <img src={Menu} style={{ width: "100%", heigth: "100%" }} />
                                                {
                                                  this.state.AllMeasurementMenu ?
                                                    <div style={{ position: "absolute", top: "21px", right: "5px", background: "white", borderRadius: "2px", zIndex: 99, boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.15)" }}>
                                                      <div id="hoverBtn" onClick={() => {
                                                        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) {
                                                          this.setState({ AllMeasurementMenu: false })
                                                          this.exportMeasurements("shapeFile", "all")
                                                        }
                                                      }}
                                                        style={{ padding: "5px 10px", color: (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) ? "" : "grey", cursor: (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) ? "" : "not-allowed" }}>Download</div>
                                                    </div> : <></>
                                                }
                                              </div>
                                            </div>
                                          </div>

                                          {this.state.OrthomosaicAvailable && !this.potree.current ?
                                            <div style={{ borderBottom: "1px solid rgb(218,220,224)", color: "#3c3c3c", fontSize: "11px", padding: "10px 0px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                              <input type='checkbox' style={{ cursor: 'pointer', marginBottom: "2px", height: "15px", width: "15px" }}
                                                checked={this.state.mapMeasurementsShow}
                                                onClick={() => {
                                                  this.setState({ mapMeasurementsShow: !(this.state.mapMeasurementsShow) }, () => {
                                                    this.toggleMapMeasurement()
                                                  })
                                                }}
                                              />
                                              <div style={{ marginLeft: "10px", minWidth: "55px", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400" }}>{`All Map Measurements`}</div>
                                              <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                                                <div onClick={() => {
                                                  this.setState({
                                                    LocalMeasurementMenu: !this.state.LocalMeasurementMenu,
                                                    AllMeasurementMenu: false,
                                                    GlobalMeasurementMenu: false
                                                  })
                                                }}
                                                  style={{ position: "relative", height: "15px", width: "15px", marginLeft: "20px", marginBottom: "2px", cursor: "pointer" }}>
                                                  <img src={Menu} style={{ width: "100%", heigth: "100%" }} />
                                                  {
                                                    this.state.LocalMeasurementMenu ?
                                                      <div style={{ position: "absolute", top: "21px", right: "5px", background: "white", borderRadius: "2px", zIndex: 99, boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.15)" }}>
                                                        <div id="hoverBtn" onClick={() => {
                                                          if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) {
                                                            this.setState({ LocalMeasurementMenu: false })
                                                            this.exportMeasurements("shapeFile", "map")
                                                          }
                                                        }}
                                                          style={{ padding: "5px 10px", color: (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) ? "" : "grey", cursor: (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) ? "" : "not-allowed" }}>Download</div>
                                                      </div> : <></>
                                                  }
                                                </div>
                                              </div>
                                            </div> : <></>}

                                          {!this.potree.current ? <div style={{ borderBottom: "1px solid rgb(218,220,224)", color: "#3c3c3c", fontSize: "11px", padding: "10px 0px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                            <input type='checkbox' style={{ cursor: 'pointer', marginBottom: "2px", height: "15px", width: "15px" }}
                                              checked={this.state.globalMeasurementsShow}
                                              onClick={() => {
                                                this.setState({ globalMeasurementsShow: !(this.state.globalMeasurementsShow) }, () => {
                                                  this.toggleGlobalMeasurement()
                                                })
                                              }}
                                            />
                                            <div style={{ marginLeft: "10px", minWidth: "55px", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400" }}>{`All Global Measurements`}</div>
                                            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                                              <div onClick={() => {
                                                this.setState({
                                                  GlobalMeasurementMenu: !this.state.GlobalMeasurementMenu,
                                                  AllMeasurementMenu: false,
                                                  LocalMeasurementMenu: false,
                                                })
                                              }}
                                                style={{ position: "relative", height: "15px", width: "15px", marginLeft: "20px", marginBottom: "2px", cursor: "pointer" }}>
                                                <img src={Menu} style={{ width: "100%", heigth: "100%" }} />
                                                {
                                                  this.state.GlobalMeasurementMenu ?
                                                    <div style={{ position: "absolute", top: "21px", right: "5px", background: "white", borderRadius: "2px", zIndex: 99, boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.15)" }}>
                                                      <div id="hoverBtn" onClick={() => {
                                                        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) {
                                                          this.setState({ GlobalMeasurementMenu: false })
                                                          this.exportMeasurements("shapeFile", "global", true)
                                                        }
                                                      }}
                                                        style={{ padding: "5px 10px", color: (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) ? "" : "grey", cursor: (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.measurements.length > 0) ? "" : "not-allowed" }}>Download</div>
                                                    </div> : <></>
                                                }
                                              </div>
                                            </div>
                                          </div> : <></>}

                                          <div style={{ borderBottom: "1px solid rgb(218,220,224)", color: "#3c3c3c", fontSize: "11px", padding: "10px 0px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                            <input type='checkbox' style={{ cursor: 'pointer', marginBottom: "2px", height: "15px", width: "15px" }}
                                              checked={this.state.GCPShow}
                                              onClick={() => {
                                                this.setState((state) => ({
                                                  ...state,
                                                  GCPShow: !this.state.GCPShow
                                                }), () => {
                                                  this.showGCP()
                                                })
                                              }}
                                            />
                                            <div style={{ marginLeft: "10px", minWidth: "55px", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400", }}>{`GCPs`}</div>
                                          </div>

                                          {/* contour layer */}
                                          {this.state.contour?.id && <div style={{ borderBottom: "1px solid rgb(218,220,224)", color: "#3c3c3c", fontSize: "11px", padding: "10px 0px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                            <input type='checkbox' style={{ cursor: 'pointer', marginBottom: "2px", height: "15px", width: "15px" }}
                                              checked={this.state.contour?.showLayer || false}
                                              onClick={() => {
                                                this.handleLayerToggle(this.state.contour, AppConstants.ASSETS.CONTOUR)
                                              }}
                                            />
                                            <div style={{ marginLeft: "10px", minWidth: "55px", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400", }}>{`Contour`}</div>
                                            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                                              <div onClick={() => {
                                                this.setState({
                                                  contourMenu: !this.state.contourMenu,
                                                })
                                              }}
                                                style={{ position: "relative", height: "15px", width: "15px", marginLeft: "20px", marginBottom: "2px", cursor: "pointer" }}>
                                                <img src={Menu} style={{ width: "100%", heigth: "100%" }} />
                                                {
                                                  this.state.contourMenu ?
                                                    <div style={{ position: "absolute", top: "21px", right: "5px", background: "white", borderRadius: "2px", zIndex: 99, boxShadow: "0px 0px 1px 1px rgba(0,0,0,0.15)" }}>
                                                      <div id="hoverBtn" onClick={() => {
                                                        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) {
                                                          this.setState({ contourMenu: false })
                                                          // this.exportMeasurements("shapeFile", "global", true)
                                                          this.handleLayerDownload(this.state.contour.image_url, this.state.contour.image_type)
                                                        }
                                                      }}
                                                        style={{ padding: "5px 10px", color: (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) ? "" : "grey", cursor: (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) ? "" : "not-allowed" }}>Download</div>
                                                    </div> : <></>
                                                }
                                              </div>
                                            </div>
                                          </div>}


                                          {!this.potree.current ?
                                            <div style={{ borderBottom: "1px solid rgb(218,220,224)", color: "#3c3c3c", fontSize: "11px", padding: "10px 0px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                              <input type='checkbox' style={{ cursor: 'pointer', marginBottom: "2px", height: "15px", width: "15px" }}
                                                checked={this.state.toolTipShow}
                                                onClick={() => {
                                                  this.toggleToolTips()
                                                }}
                                              />
                                              <div style={{ marginLeft: "10px", minWidth: "55px", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400", }}>{`Show Labels`}</div>
                                            </div> : <></>}



                                        </div>
                                        {/* <div style={{ display: "flex", width: "100%", justifyContent: "right" }}>
                                        <ButtonWithIcon onClick={this.handleSelectAllLayers} text={this.state.allAssetLayersSelected ? "DeSelect All" : "Select All"} />
                                      </div> */}
                                        {this.state.assetsLayers.filter(asset => this.isImportedLayer(asset)).length > 0 && <div style={{ display: "flex", flexDirection: "column", height: "37.5%" }} >
                                          {/* <div style={{ color: "#3c3c3c", fontSize: "11px", padding: "10px 0px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                          <input type='checkbox' style={{ cursor: 'pointer', height: "15px", width: "15px" }} checked={this.state.allAssetLayersSelected} onChange={this.handleSelectAllLayers} /><div style={{ marginLeft: "10px", minWidth: "55px", backgroundColor: 'white', fontSize: "12px", width: "100%", fontWeight: "500", wordWrap: "break-word", color: "#2989cf" }}>Select All Layers</div>
                                        </div> */}
                                          <div style={{ width: "", padding: "10px 10px 10px 0px", margin: "0px 30px", borderBottom: "1px solid rgb(218, 220, 224)", display: "flex", justifyContent: "space-between " }}>
                                            <div style={{ color: "#2989cf", fontSize: "13px", display: "flex", alignItems: "center" }}>
                                              <div>Imported</div>
                                              {/* <div style={{fontSize:"11px",marginLeft:"9px",background:"#2989cf26",color:"#2989cf",fontWeight:"600",padding:"0px 5px",borderRadius:"5px"}}>{this.state.assetsLayers?.length||0}</div> */}
                                              <div style={{ fontSize: "11px", marginLeft: "5px" }}>{`(${this.state.assetsLayers.filter(asset => this.isImportedLayer(asset))?.length || 0})`}</div></div>
                                            {this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DELETE ? <ButtonWithIcon text={"Delete"} height="20px" padding="0px 10px " width="75px"
                                              isDisabled={this.state.assetsLayers.filter(lyr => lyr.showLayer && this.isImportedLayer(lyr)).length === 0}
                                              onClick={async () => {
                                                let deleteCount = this.state.assetsLayers.filter(lyr => lyr.showLayer && this.isImportedLayer(lyr)).length
                                                this.setState({
                                                  deleteMultipleLayers: !this.state.deleteMultipleLayers,
                                                  deleteLayerItems: "WARNING",
                                                  deleteLayerIcon: "WARNING",
                                                  deleteLayerMsg: `Are you sure, you want to delete ${deleteCount || 0} selected layer${deleteCount > 1 ? "s" : ""} ?`,
                                                  deleteLayerPopup: true,
                                                  deleteMultipleLayers: true,
                                                  deleteMultipleLayerType: "Imported"
                                                })
                                              }} /> : <></>}
                                          </div>
                                          <div className="scroll-container" style={{ overflowY: "auto", height: "100%", padding: "0px 30px" }}>

                                            {/* shp */}
                                            <Layers
                                              updatelayer={this.updatelayerColor}
                                              layers={this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.SHP)}
                                              handleLayerToggle={this.handleLayerToggle}
                                              toggleLayerOptions={this.toggleLayerOptions}
                                              disableLayers={this.state.disableLayers}
                                              handleLayerDownload={this.handleLayerDownload}
                                              handleDeleteLayer={this.openDeleteLayerConfirmation}
                                              permissions={this.state.permissions[DRONENAKSHA_FEATURES.MAPS]}

                                            />

                                            {/* kml */}

                                            <Layers
                                              updatelayer={this.updatelayerColor}
                                              layers={this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.KML)}
                                              handleLayerToggle={this.handleLayerToggle}
                                              toggleLayerOptions={this.toggleLayerOptions}
                                              disableLayers={this.state.disableLayers}
                                              handleLayerDownload={this.handleLayerDownload}
                                              handleDeleteLayer={this.openDeleteLayerConfirmation}
                                              permissions={this.state.permissions[DRONENAKSHA_FEATURES.MAPS]}

                                            />
                                            {/* json/geosjon */}
                                            <Layers
                                              updatelayer={this.updatelayerColor}
                                              layers={this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.GEOJSON)}
                                              handleLayerToggle={this.handleLayerToggle}
                                              toggleLayerOptions={this.toggleLayerOptions}
                                              disableLayers={this.state.disableLayers}
                                              handleLayerDownload={this.handleLayerDownload}
                                              handleDeleteLayer={this.openDeleteLayerConfirmation}
                                              permissions={this.state.permissions[DRONENAKSHA_FEATURES.MAPS]}

                                            />
                                            {/* cad */}
                                            <Layers
                                              updatelayer={this.updatelayerColor}
                                              layers={this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.CAD && asset.image_url.includes("/importedLayers"))}
                                              handleLayerToggle={this.handleLayerToggle}
                                              toggleLayerOptions={this.toggleLayerOptions}
                                              disableLayers={this.state.disableLayers}
                                              handleLayerDownload={this.handleLayerDownload}
                                              handleDeleteLayer={this.openDeleteLayerConfirmation}
                                              permissions={this.state.permissions[DRONENAKSHA_FEATURES.MAPS]}

                                            />
                                          </div>
                                        </div>}
                                        {/* detection layers */}
                                        {this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.DETECTION).length > 0 && <div style={{ display: "flex", flexDirection: "column", height: "37.5%" }} >
                                          {/* <div style={{ color: "#3c3c3c", fontSize: "11px", padding: "10px 0px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                          <input type='checkbox' style={{ cursor: 'pointer', height: "15px", width: "15px" }} checked={this.state.allAssetLayersSelected} onChange={this.handleSelectAllLayers} /><div style={{ marginLeft: "10px", minWidth: "55px", backgroundColor: 'white', fontSize: "12px", width: "100%", fontWeight: "500", wordWrap: "break-word", color: "#2989cf" }}>Select All Layers</div>
                                        </div> */}
                                          <div style={{ width: "", padding: "10px 10px 10px 0px", margin: "0px 30px", borderBottom: "1px solid rgb(218, 220, 224)", borderTop: "1px solid rgb(218, 220, 224)", display: "flex", justifyContent: "space-between " }}>
                                            <div style={{ color: "#2989cf", fontSize: "13px", display: "flex", alignItems: "center" }}>
                                              <div>Detections</div>
                                              {/* <div style={{fontSize:"11px",marginLeft:"9px",background:"#2989cf26",color:"#2989cf",fontWeight:"600",padding:"0px 5px",borderRadius:"5px"}}>{this.state.assetsLayers?.length||0}</div> */}
                                              <div style={{ fontSize: "11px", marginLeft: "5px" }}>{`(${this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.DETECTION)?.length || 0})`}</div></div>
                                            {this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DELETE ? <ButtonWithIcon text={"Delete"} height="20px" padding="0px 10px " width="75px"
                                              isDisabled={this.state.assetsLayers.filter(lyr => lyr.showLayer && lyr.image_type === AppConstants.ASSETS.DETECTION).length <= 0}
                                              onClick={async () => {
                                                let deleteCount = this.state.assetsLayers.filter(lyr => lyr.showLayer && lyr.image_type == AppConstants.ASSETS.DETECTION).length
                                                this.setState({
                                                  deleteMultipleLayers: !this.state.deleteMultipleLayers,
                                                  deleteLayerItems: "WARNING",
                                                  deleteLayerIcon: "WARNING",
                                                  deleteLayerMsg: `Are you sure, you want to delete ${deleteCount || 0} selected layer${deleteCount > 1 ? "s" : ""} ?`,
                                                  deleteLayerPopup: true,
                                                  deleteMultipleLayers: true,
                                                  deleteMultipleLayerType: "Detection"
                                                })
                                              }} /> : <></>}
                                          </div>
                                          <div className="scroll-container" style={{ overflowY: "auto", height: "100%", padding: "0px 30px" }}>

                                            {/* detection */}

                                            <Layers
                                              updatelayer={this.updatelayerColor}
                                              layers={this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.DETECTION)}
                                              handleLayerToggle={this.handleLayerToggle}
                                              toggleLayerOptions={this.toggleLayerOptions}
                                              disableLayers={this.state.disableLayers}
                                              handleLayerDownload={this.handleLayerDownload}
                                              handleDeleteLayer={this.openDeleteLayerConfirmation}
                                              permissions={this.state.permissions[DRONENAKSHA_FEATURES.MAPS]} />
                                          </div>
                                        </div>}
                                      </div> :
                                      this.state.activeSidepanel === this.state.activeSideBarFloor ?
                                        <FloorComponent
                                          updatelayer={this.updatelayerColor}
                                          map={this.state.map}
                                          minimizedView={this.state.minimizedFloorPlanningViewer}
                                          cadUpload={() => {
                                            // this.setState({ openFoorSelector: true })
                                            this.importFiles(".dxf, .dwg, .DWG, .DXF")
                                            this.setState({ selectedFilesExt: ".dxf" });
                                          }}
                                          onUnMount={
                                            this.closeFloorPlanning
                                            // () => { }
                                          }
                                          openFloorPlanningImageViewer={
                                            (FloorImagesViewer) => {
                                              this.setState({
                                                minimizedFloorPlanningViewer: !(FloorImagesViewer), // open image in maximize window always
                                              }, () => {
                                                this.setState({
                                                  FloorImagesViewer
                                                })
                                                // this.initThreeJs()
                                              })
                                            }
                                          }
                                          subscriptionCheck={this.state.subcheck}
                                          openSubcheckPopup={() => { this.setState((state) => ({ ...state, subscriptionPopup: true, })) }}
                                          totalImgCount={this.state.counts}
                                          oldImages={this.state.images}
                                          user={this.state.user}
                                          plan={this.state.plan}
                                          selectedFloor={this.state.selectedFloor}
                                          newUploadedCad={this.state.uploadedCadData?.savedAsset}
                                          cadLayersData={{
                                            layers: this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.CAD && asset.image_url.includes('/floorData')),
                                            handleLayerToggle: this.handleLayerToggle,
                                            toggleLayerOptions: this.toggleLayerOptions,
                                            disableLayers: this.state.disableLayers,
                                            handleLayerDownload: this.handleLayerDownload,
                                            handleDeleteLayer: this.openDeleteLayerConfirmation,
                                            handleDeleteMultipleLayers: (deleteCount) => {
                                              this.setState({
                                                deleteLayerItems: "WARNING",
                                                deleteLayerIcon: "WARNING",
                                                deleteLayerMsg: `Are you sure, you want to delete ${deleteCount || 0} selected layer${deleteCount > 1 ? "s" : ""} ?`,
                                                deleteLayerPopup: true,
                                                deleteMultipleLayers: true,
                                                isFloorCad: true
                                              })
                                            }, permissions: this.state.permissions[DRONENAKSHA_FEATURES.MAPS]
                                          }}
                                          permissions={this.state.permissions}
                                          tab={this.state.selectedTab}
                                        />
                                        :
                                        this.state.activeSidepanel === activeSidebarMeasurement ?
                                          <>
                                            {
                                              this.state.selectedMeasurement ?
                                                <>
                                                  <div className='content-text' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: 'white', padding: '0px 10px 5px', borderBottom: '1px solid #e5e5e5' }}>
                                                    <div style={{ backgroundColor: 'white', padding: '0px 10px 5px', fontSize: "14px", fontWeight: "500", color: "#2989cf" }}> {this.state.selectedMeasurement ? this.state.selectedMeasurement.type : this.state.clickedPolyFromShape ? "Shape file measurement" : ''}</div>
                                                    <div style={{ display: "flex" }}>
                                                      {(Number(this.state.selectedMeasurement?.measurements?.[0]?.['2D Area']?.split(" ")?.[0])) <= 30000 ?
                                                        this.state.selectedMeasurement?.type === POLYGON && this.state.RGBShow && <div><ButtonWithIcon
                                                          text={"Extract tiff"}
                                                          onClick={this.exportTiff}
                                                        /></div>
                                                        :
                                                        <Tippy
                                                          className="tippy-menu tippy-warning"
                                                          content={<span>Extracting larger tiff (more than 30,000 {this.state.selectedUnit.value}<sup>2</sup> area) may crash your system</span>}>
                                                          {this.state.selectedMeasurement?.type === POLYGON && this.state.RGBShow && <div><ButtonWithIcon
                                                            isDisabled={true}
                                                            text={"Extract tiff"}
                                                            onClick={this.exportTiff}
                                                          /></div>}
                                                        </Tippy>
                                                      }

                                                      <div style={{ backgroundColor: 'white', opacity: this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT ? "1" : "0.5" }}><img style={{ width: '20px', height: '20px', cursor: "pointer", padding: "1px", opacity: !(this.state.loadingVolume) ? 1 : 0.7 }} src={DeleteIcon}
                                                        onClick={() => {
                                                          if (!(this.state.loadingVolume) && this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT) this.deleteMeasurement();
                                                        }} />
                                                      </div>
                                                      <div style={{ backgroundColor: 'white', marginLeft: "10px" }}>
                                                        <img src={closeBtn} style={{ width: '20px', height: '20px', cursor: "pointer", padding: "1px" }}
                                                          onClick={
                                                            () => {
                                                              this.closeFloorPlanning()
                                                              this.setState((state) => ({
                                                                ...state,
                                                                sidebarPanel: false,
                                                                displayColorPicker: false,
                                                                showElevationProfile: false,
                                                                activeSidepanel: false,
                                                              }))
                                                            }
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className='content-text' style={{ backgroundColor: 'white', padding: '20px 30px', display: "flex", flexDirection: "column", overflowY: "scroll" }}>
                                                    <div style={{ backgroundColor: 'white', display: "flex" }}></div>

                                                    <div style={{ display: "flex" }}>
                                                      <div style={{ backgroundColor: 'white', fontSize: "10px", fontWeight: "400", color: "#666666" }}> Name </div>
                                                    </div>

                                                    <div className="content-text" style={{ marginTop: "3px", backgroundColor: 'white', color: "#3c3c3c", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", opacity: this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT ? "1" : "0.5" }}>
                                                      <input disabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT} type="text" className="textbox" maxlength="25" style={{ fontSize: "10px", padding: "5px 8px", width: "calc(100% - 40px)", border: "1px solid #6666668f", borderRadius: "2px", color: "#3c3c3c", borderColor: this.state.textboxValid ? "#6666668f" : 'red' }} value={this.state.selectedMeasurement ? this.state.selectedMeasurement.name : ''} onChange={(e) => {
                                                        this.measurementNameHandler(e)
                                                      }} />

                                                      <div style={{ backgroundColor: 'white', padding: '5px', }}>
                                                        <img style={{ width: '18px', height: '18px', cursor: "pointer", marginLeft: "10px" }}
                                                          src={this.state.saveNameState == false ? saveIcon : tickIcon}
                                                          onClick={() => {

                                                            this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT && this.updateMeasurementDetails(false)
                                                          }} />
                                                      </div>
                                                    </div>

                                                    {/* <div style={{ backgroundColor: "white", fontSize: "9px", color: "red", height: "10px" }}>{this.state.errorMsg}</div>
                                                <div style={{ display: "flex", marginTop: '5px' }}>
                                                  <div style={{ backgroundColor: 'white', fontSize: "10px", fontWeight: "400", color: "#666666" }}> Remark </div>
                                                </div>

                                                <div className="content-text" style={{ marginTop: "3px", backgroundColor: 'white', color: "#3c3c3c", display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between", opacity: this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT ? "1" : "0.5" }}>
                                                  <input disabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT} type="text" maxlength="60" className="textbox" style={{ fontSize: "10px", padding: "5px 8px", width: "90%", border: "1px solid #6666668f", borderRadius: "2px", color: "#3c3c3c" }} value={this.state.selectedMeasurement && this.state.selectedMeasurement.description ? this.state.selectedMeasurement.description : ''} onChange={(e) => {
                                                    this.setState({
                                                      selectedMeasurement: {
                                                        ...this.state.selectedMeasurement,
                                                        description: e.target.value,
                                                      }
                                                    })
                                                  }} />
                                                  <div style={{ backgroundColor: 'white', padding: '5px', }}>
                                                    <img style={{ width: '18px', height: '18px', cursor: "pointer", marginLeft: "10px", }}
                                                      src={this.state.saveDesState == false ? saveIcon : tickIcon}
                                                      onClick={() => {
                                                        this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT && this.updateMeasurementDetails(true)
                                                      }} />
                                                  </div>

                                                </div> */}

                                                    {/* <div style={{ display: "flex", justifyContent: "start", alignItems: "center", marginTop: "10px" }}>
                                                  <span style={{ color: "rgb(41, 137, 207)", fontSize: "13px", fontWeight: "400", marginRight: "10px" }}>Add To Compare</span>
                                                  <input type="checkbox" style={{ cursor: "pointer" }} checked={this.state.selectedMeasurement.compared} onChange={() => {
                                                    this.addToComparison(this.state.selectedMeasurement.id, this.state.selectedMeasurement?.compared ? null : this.state.plan.id, this.state.selectedMeasurement.task_id)
                                                    // this.getMeasurements();
                                                    this.setState({
                                                      measurements: this.state.measurements.map(m => {
                                                        if (m.id === this.state.selectedMeasurement.id) {
                                                          return { ...m, compared: !m.compared }
                                                        } else return m;
                                                      })
                                                      , selectedMeasurement: { ...this.state.selectedMeasurement, compared: !this.state.selectedMeasurement.compared, }
                                                    })
                                                  }} />
                                                </div> */}
                                                    {/* <div style={{ backgroundColor: 'white', padding: '5px', }}>
                                                  <img style={{ width: '18px', height: '18px', cursor: "pointer", marginLeft: "10px" }}
                                                    src={this.state.saveNameState == false ? saveIcon : tickIcon}
                                                    onClick={() => {
                                                      this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT && this.updateMeasurementDetails(false)
                                                    }} />
                                                </div> */}

                                                    <div style={{ backgroundColor: "white", fontSize: "9px", color: "red", height: "10px" }}>{this.state.errorMsg}</div>
                                                    <div style={{ display: "flex", marginTop: '5px' }}>
                                                      <div style={{ backgroundColor: 'white', fontSize: "10px", fontWeight: "400", color: "#666666" }}> Description </div>
                                                    </div>

                                                    <div className="content-text" style={{ marginTop: "3px", backgroundColor: 'white', color: "#3c3c3c", display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between", opacity: this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT ? "1" : "0.5" }}>
                                                      <div
                                                        id="addNoteDiv"
                                                        style={{
                                                          border: "1px solid rgba(102, 102, 102, 0.56)",
                                                          borderRadius: "2px",
                                                          padding: "5px 8px",
                                                          display: "flex",
                                                          alignItems: 'center',
                                                          width: "calc(100% - 40px)"
                                                        }}>
                                                        <MentionsInput

                                                          suggestionsPortalHost={this.suggestionsPortalRef?.current || null}
                                                          className="mention-input"
                                                          singleLine
                                                          maxLength={100}
                                                          value={this.state.mentionValue}
                                                          style={{
                                                            width: "100%",
                                                            // height: "25px",
                                                            color: "#3c3c3c",
                                                            fontSize: "10px",
                                                            outline: "none",
                                                            suggestions: {
                                                              list: {
                                                                backgroundColor: 'white',
                                                                border: '1px solid rgba(0,0,0,0.15)',
                                                                fontSize: 14,
                                                                height: '300px',
                                                                maxHeight: '300px',
                                                                overflow: 'auto'
                                                              },
                                                              item: {
                                                                padding: '5px 15px',
                                                                borderBottom: '1px solid rgba(0,0,0,0.15)',
                                                                '&focused': {
                                                                  backgroundColor: '#cee4e5',
                                                                },
                                                              },
                                                            },
                                                          }}
                                                          placeholder={"Mention people using '@'"}
                                                          onChange={this.onChangeTeamMember}
                                                          onPaste={this.handlePaste}
                                                          inputRef={this.inputRef}
                                                        >
                                                          <Mention
                                                            trigger="@"
                                                            data={this.state.teamMembers}
                                                            appendSpaceOnAdd={true}
                                                            style={{
                                                              backgroundColor: '#cee4e5',
                                                              border: "none",
                                                              outline: "none"
                                                            }}
                                                          />
                                                        </MentionsInput>
                                                      </div>
                                                      <img style={{ width: '18px', height: '18px', cursor: "pointer", marginRight: "5px", }}
                                                        src={this.state.saveDesState == false ? saveIcon : tickIcon}
                                                        onClick={() => {
                                                          this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT && this.sendNotification()
                                                        }} />
                                                      {/* <input disabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT} type="text" maxlength="60" className="textbox" style={{ fontSize: "10px", padding: "5px 8px", width: "90%", border: "1px solid #6666668f", borderRadius: "2px", color: "#3c3c3c" }} value={this.state.selectedMeasurement && this.state.selectedMeasurement.description ? this.state.selectedMeasurement.description : ''} onChange={(e) => {
                                                  this.setState({
                                                    selectedMeasurement: {
                                                      ...this.state.selectedMeasurement,
                                                      description: e.target.value,
                                                    }
                                                  })
                                                }} /> */}
                                                      {/* <div style={{ backgroundColor: 'white', padding: '5px', }}>
                                                  
                                                </div> */}

                                                    </div>

                                                  </div>
                                                  {/* <div style={{ display: "flex", justifyContent: "start", alignItems: "center", marginTop: "10px", padding: '0px 30px', }}>
                                                  <span style={{ color: "rgb(41, 137, 207)", fontSize: "13px", fontWeight: "400", marginRight: "10px" }}>Add To Compare</span>
                                                  <input type="checkbox" style={{ cursor: "pointer" }} checked={this.state.selectedMeasurement.compared} onChange={() => {
                                                    this.addToComparison(this.state.selectedMeasurement.id, this.state.selectedMeasurement?.compared ? null : this.state.plan.id, this.state.selectedMeasurement.task_id)
                                                    // this.getMeasurements();
                                                    this.setState({
                                                      measurements: this.state.measurements.map(m => {
                                                        if (m.id === this.state.selectedMeasurement.id) {
                                                          return { ...m, compared: !m.compared }
                                                        } else return m;
                                                      })
                                                      , selectedMeasurement: { ...this.state.selectedMeasurement, compared: !this.state.selectedMeasurement.compared, }
                                                    })
                                                  }} />
                                                </div> */}
                                                  {this.state.OrthomosaicAvailable ?
                                                    <div style={{ opacity: this.state.DisableAddGlobalMeasurement ? "0.5" : "1", display: "flex", justifyContent: "start", alignItems: "center", marginTop: "10px", padding: '0px 30px', }}>
                                                      <span style={{ color: "rgb(41, 137, 207)", fontSize: "13px", fontWeight: "400", marginRight: "10px" }}>Global Measurement</span>
                                                      <input type="checkbox" style={{ cursor: this.state.DisableAddGlobalMeasurement ? "not-allowed" : "pointer" }} checked={this.state.selectedMeasurement.plan_id ? true : false}
                                                        onChange={() => {
                                                          // alert(`${this.state.selectedMeasurement}`)
                                                          if (!this.state.DisableAddGlobalMeasurement)
                                                            this.setState({ DisableAddGlobalMeasurement: true }, () => {
                                                              this.saveToGlobal(this.state.selectedMeasurement)
                                                            })
                                                        }} />

                                                    </div>
                                                    : <></>
                                                  }

                                                  {/* Show labels */}
                                                  <div style={{ opacity: "1", display: "flex", justifyContent: "start", alignItems: "center", marginTop: "10px", padding: '0px 30px', }}>
                                                    <span style={{ color: "rgb(41, 137, 207)", fontSize: "13px", fontWeight: "400", marginRight: "10px" }}>Show Labels</span>
                                                    <input type="checkbox" style={{ cursor: "pointer" }} checked={this.state.selectedMeasurement.showLabels ? true : false}
                                                      onChange={(e) => {
                                                        this.handleToggleLabels(e.target.checked)
                                                      }} />
                                                  </div>


                                                  <div>
                                                    {this.state.selectedMeasurement && this.state.selectedMeasurement.type != 'Marker' ?

                                                      <div style={{ backgroundColor: 'white', display: "flex", alignItems: "center", padding: '0px 30px', }}>
                                                        <div style={{ backgroundColor: 'white', fontSize: "10px", fontWeight: "400", color: "#666666", marginTop: "15px", width: "25%" }}> Color</div>

                                                        <Tippy
                                                          visible={this.state.displayColorPicker}
                                                          onClickOutside={() => this.setState({ displayColorPicker: false })}
                                                          animation={false}
                                                          interactive
                                                          onShown={(instance) => {
                                                            document.querySelector('[data-tippy-root]').addEventListener('click', event => {
                                                              instance.hide();
                                                              this.setState({ displayColorPicker: false })
                                                            })
                                                          }}
                                                          onShow={instance => {
                                                            const el = document.querySelector(".scroll-container")
                                                            if (el)
                                                              el.addEventListener('scroll', event => {
                                                                instance.hide()
                                                                this.setState({ displayColorPicker: false })
                                                              })
                                                          }}
                                                          className='tippy-menu'
                                                          arrow={false}
                                                          offset={[105, -335]}
                                                          content={
                                                            <SketchPicker color={this.state.selectedMeasurement.color}
                                                              onChangeComplete={this.changeMeasurementColor} />}
                                                        >
                                                          <div style={{ backgroundColor: this.state.selectedMeasurement.color, height: "18px", width: "18px", marginTop: "15px", border: "1px solid #6666668f", borderRadius: '2px', cursor: "pointer" }} onClick={() => {
                                                            this.toggleColorPicker()
                                                          }}>
                                                          </div>
                                                        </Tippy>

                                                        {/* {this.state.displayColorPicker ? <div style={{ position: "absolute", zIndex: "2", marginTop: "350px", marginLeft: "10%" }}>
                                                          <SketchPicker color={this.state.selectedMeasurement.color}
                                                            onChangeComplete={this.changeMeasurementColor} onClick={this.handleClose} /> </div> : <></>} */}

                                                      </div>
                                                      : <></>
                                                    }
                                                    {this.state.selectedMeasurement && this.state.selectedMeasurement.type != 'Marker' ?
                                                      this.state.selectedMeasurement.measurements.map((measurement) => {
                                                        return <div style={{ backgroundColor: 'white', display: "flex", padding: '0px 30px', }}>
                                                          <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}> {Object.keys(measurement)[0]}</div>
                                                          <div style={{ display: "flex", heigth: Object.keys(measurement)[0].includes('Area') ? "100%" : undefined }}>
                                                            <div style={{ backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                              {
                                                                (Object.keys(measurement)[0].includes('Elevation')) ?
                                                                  `${measurement.Elevation}`
                                                                  :
                                                                  (Object.keys(measurement)[0].includes('3D') && !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable)) ? "Elevation not available" :
                                                                    measurement[Object.keys(measurement)[0]] !== "loading" ? (this.state.selectedUnit.value == 'ft' ?
                                                                      `${(parseFloat(measurement[Object.keys(measurement)[0]]) * (this.state.selectedMeasurement.type === 'Polyline' ? 3.2808 : 10.7639)).toFixed(2)} ${Object.keys(measurement)[0].includes('Area') ? "sq. ft" : "ft"}`
                                                                      :
                                                                      `${parseFloat(measurement[Object.keys(measurement)[0]])} ${Object.keys(measurement)[0].includes('Area') ? "sq. m" : "m"}`) : "loading"
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>
                                                      })
                                                      : <div style={{ marginBottom: "10px" }}>
                                                        <div style={{ backgroundColor: 'white', display: "flex", padding: '0px 30px', }}>
                                                          <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>{this.state.displayLatLongUnit === 'meter' ? 'Northing' : "Latitude"}</div>
                                                          <div style={{ backgroundColor: 'white', fontSize: "12px", width: "35%", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                            {this.state.selectedMeasurement ?
                                                              this.state.displayLatLongUnit === 'meter' ?
                                                                this.state.selectedMeasurement.coordinates.lat && this.state.selectedMeasurement.coordinates.lng ?
                                                                  (utm.convertLatLngToUtm(this.state.selectedMeasurement.coordinates.lat, this.state.selectedMeasurement.coordinates.lng, 4).Northing)
                                                                  : this.state.selectedMeasurement.coordinates.x.toFixed(8)
                                                                : (this.state.selectedMeasurement.coordinates.lat).toFixed(8)
                                                              : ''}
                                                          </div>
                                                          {this.state.selectedMeasurement.coordinates.lat && this.state.selectedMeasurement.coordinates.lng ?
                                                            <div style={{ paddingTop: "12px", marginLeft: "22px" }}>
                                                              <select
                                                                className="dropdown-item-style"
                                                                style={{ width: "70px", borderRadius: "5px", fontSize: "9px", color: "#666666" }}
                                                                name='gpsDrop'
                                                                value={this.state.displayLatLongUnit}
                                                                onChange={(e) => {
                                                                  this.setState({
                                                                    displayLatLongUnit: e.target.value
                                                                  })
                                                                }}
                                                              >
                                                                <option value={"degree"}>Degree</option>
                                                                <option value={"meter"}>Meter</option>
                                                              </select>
                                                            </div> : <></>}
                                                        </div>
                                                        <div style={{ backgroundColor: 'white', display: "flex", padding: '0px 30px', }}>
                                                          <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>{this.state.displayLatLongUnit === 'meter' ? 'Easting' : "Longitude"}</div>
                                                          <div style={{ backgroundColor: 'white', fontSize: "12px", width: "40%", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                            {this.state.selectedMeasurement ?
                                                              this.state.displayLatLongUnit === 'meter' ?
                                                                this.state.selectedMeasurement.coordinates.lat && this.state.selectedMeasurement.coordinates.lng ?
                                                                  utm.convertLatLngToUtm(this.state.selectedMeasurement.coordinates.lat, this.state.selectedMeasurement.coordinates.lng, 4).Easting
                                                                  : this.state.selectedMeasurement.coordinates.y.toFixed(8)
                                                                : (this.state.selectedMeasurement.coordinates.lng).toFixed(8)
                                                              : ''} </div>
                                                        </div>
                                                        {this.state.DSMAvailable != NotSelected && this.state.DSMAvailable ?
                                                          <div style={{ backgroundColor: 'white', display: "flex", padding: '0px 30px', }}>
                                                            <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>{'Elevation'}</div>
                                                            <div style={{ backgroundColor: 'white', fontSize: "12px", width: "40%", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                              {this.state.selectedMeasurement ? this.state.selectedMeasurement.altitude != 'NA' && this.state.selectedMeasurement.altitude != 'NaN' && this.state.selectedMeasurement.altitude >= 0 ? this.state.selectedUnit.value == 'm' ? this.state.selectedMeasurement.altitude + ' m' : ((this.state.selectedMeasurement.altitude * 3.28084).toFixed(2)) + ' ft' : 'NA' : ''} </div>
                                                          </div> : <></>}
                                                      </div>
                                                    }


                                                    <div style={{ marginTop: "5px" }}>
                                                      <div className='content-text' style={{ height: "40px", display: "flex", alignItems: "center", backgroundColor: 'white', justifyContent: "space-between", padding: '10px 30px', borderBottom: '1px solid #e5e5e5' }}>
                                                        <div style={{ backgroundColor: 'white', fontSize: "14px", fontWeight: "500", color: "#2989cf" }}> Other Properties</div>
                                                        <ButtonWithIcon
                                                          text="Field"
                                                          icon={AddIcon}
                                                          isDisabled={!(this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT)}
                                                          onClick={() => {
                                                            this.setState({
                                                              propertyObj: this.state.selectedMeasurement?.properties ? this.state.selectedMeasurement?.properties : {},
                                                            }, () => { this.setState({ addProperty: true, }) })
                                                          }}
                                                        />

                                                      </div>
                                                      <div style={{ overflow: "auto", maxHeight: "220px", }}>
                                                        {
                                                          this.state.selectedMeasurement?.properties ?
                                                            Object.keys(Object.fromEntries(Object.entries(this.state.selectedMeasurement.properties))).map((item) => {
                                                              return <div style={{ backgroundColor: 'white', alignItems: "center", display: "flex", gap: "30px", padding: "0 30px" }}>
                                                                <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px", wordBreak: "break-all" }}> {item}</div>
                                                                <div style={{ display: "flex", width: "75%" }}>
                                                                  <div style={{ wordBreak: "break-all", backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                                    {this.state.selectedMeasurement?.properties[item]}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            }) : <div style={{ backgroundColor: 'white', textAlign: "center", color: "#3C3C3C", fontWeight: "400", fontSize: "10px", padding: "20px 30px" }}>
                                                              No fields are available.
                                                            </div>
                                                        }

                                                      </div>
                                                    </div>

                                                  </div>

                                                  {/* volume for polygon */}
                                                  {(this.state.selectedMeasurement && this.state.selectedMeasurement.type === "Polygon") ?
                                                    <>
                                                      <div className='content-text' style={{ height: "40px", display: "flex", alignItems: "center", backgroundColor: 'white', justifyContent: "space-between", padding: '10px 30px', borderBottom: '1px solid #e5e5e5' }}>
                                                        <div style={{ backgroundColor: 'white', fontSize: "14px", fontWeight: "500", color: "#2989cf" }}> Volumetric Measurement</div>
                                                      </div>
                                                      {this.state.isRegionInOrtho || !this.state.OrthomosaicAvailable ? this.state.DSMAvailable === NotSelected || !(this.state.DSMAvailable) ?
                                                        // DSM not available block 
                                                        <div style={{ backgroundColor: 'white', textAlign: "center", color: "#3C3C3C", fontWeight: "400", fontSize: "10px", padding: "20px 30px" }}>
                                                          No elevation available.
                                                        </div>
                                                        :
                                                        <>
                                                          {this.state.selectedMeasurement.coordinates.length < 4 ?
                                                            <div style={{ backgroundColor: 'white', color: "#3C3C3C", fontWeight: "400", fontSize: "10px", padding: "20px 30px 5px 30px" }}>
                                                              A polygon with minimum 4 coordinates is required to calculate volume.
                                                            </div>
                                                            :
                                                            <>
                                                              <div style={{ backgroundColor: 'white', padding: "20px 30px" }}>
                                                                <div style={{ backgroundColor: 'white', display: "flex" }}>
                                                                  <div style={{ backgroundColor: 'white', fontSize: "10px", width: "30%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>Cut volume</div>
                                                                  <div style={{ display: "flex", heigth: "100%" }}>
                                                                    <div style={{ backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", margiinLeft: "5px", marginTop: "15px" }}> {this.state.loadingVolume ? "calculating..." : <>{(this.state.selectedMeasurement?.cut_volume !== null || this.state.selectedMeasurement?.cut_volume !== undefined) ? (!this.state.selectedMeasurement.volume ? "No elevation available." : <>{this.state.selectedUnit.value == 'm' ? `${(Number(this.state.selectedMeasurement.cut_volume)).toFixed(6)} m` : `${(Number(this.state.selectedMeasurement.cut_volume) * 1.308).toFixed(6)} yd`}<sup>3</sup></>) : "-"}</>}</div>
                                                                  </div>
                                                                </div>
                                                                <div style={{ backgroundColor: 'white', display: "flex" }}>
                                                                  <div style={{ backgroundColor: 'white', fontSize: "10px", width: "30%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>Fill volume</div>
                                                                  <div style={{ display: "flex", heigth: "100%" }}>
                                                                    <div style={{ backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", margiinLeft: "5px", marginTop: "15px" }}>{this.state.loadingVolume ? "calculating..." : <>{(this.state.selectedMeasurement?.fill_volume !== null || this.state.selectedMeasurement?.fill_volume !== undefined) ? (!this.state.selectedMeasurement.volume ? "No elevation available." : <>{this.state.selectedUnit.value == 'm' ? `${(Number(this.state.selectedMeasurement.fill_volume)).toFixed(6)} m` : `${(Number(this.state.selectedMeasurement.fill_volume) * 1.308).toFixed(6)} yd`}<sup>3</sup></>) : "-"}</>} </div>
                                                                  </div>
                                                                </div>
                                                                <div style={{ backgroundColor: 'white', display: "flex" }}>
                                                                  <div style={{ backgroundColor: 'white', fontSize: "10px", width: "30%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>Volume</div>
                                                                  <div style={{ display: "flex", heigth: "100%" }}>
                                                                    <div style={{ backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", margiinLeft: "5px", marginTop: "15px" }}>{this.state.loadingVolume ? "calculating..." : <>{(this.state.selectedMeasurement?.volume !== null || this.state.selectedMeasurement?.volume !== undefined) ? (!this.state.selectedMeasurement.volume ? "No elevation available." : <>{this.state.selectedUnit.value == 'm' ? `${(Number(this.state.selectedMeasurement.volume)).toFixed(6)} m` : `${(Number(this.state.selectedMeasurement.volume) * 1.308).toFixed(6)} yd`}<sup>3</sup></>) : "-"}</>}</div>
                                                                  </div>
                                                                </div>
                                                                <div style={{ backgroundColor: 'white', display: "flex", alignItems: 'baseline' }}>
                                                                  <div style={{ backgroundColor: 'white', fontSize: "10px", width: "30%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>Method</div>
                                                                  <div style={{ display: "flex", heigth: "100%" }}>
                                                                    <select
                                                                      className="dropdown-item-style"
                                                                      value={this.state.calculationMethod}
                                                                      style={{ width: "70px", borderRadius: "5px", fontSize: "9px", color: "#666666", marginTop: "15px" }}
                                                                      name='calculation method'
                                                                      onChange={(e) => {
                                                                        this.setState({
                                                                          calculationMethod: e.target.value
                                                                        })
                                                                      }}
                                                                    >
                                                                      <option value={"fit_plane"}>Fit Plane</option>
                                                                      <option value={"lowest"}>Lowest</option>
                                                                      <option value={"highest"}>Highest</option>
                                                                      <option value={"average"}>Average</option>
                                                                    </select>
                                                                  </div>
                                                                  {!(this.state.selectedMeasurement.calc_method === this.state.calculationMethod) ?
                                                                    <div style={{ margin: "10px 0px 0px 6%" }}>
                                                                      <ButtonWithIcon
                                                                        text="Calculate"
                                                                        // width="75px"
                                                                        height="24px"
                                                                        onClick={this.getVolume}
                                                                      />
                                                                    </div>
                                                                    : <></>}
                                                                </div>

                                                              </div>
                                                            </>
                                                          }
                                                        </> :
                                                        <div style={{ backgroundColor: 'white', color: "#3C3C3C", fontWeight: "400", fontSize: "10px", padding: "20px 30px 5px 30px" }}>
                                                          Polygon Is Out Of Bounds
                                                        </div>
                                                      }
                                                      :
                                                      <></>
                                                      {/* -------------------YieldAnalysis for polygon--------------------- */}
                                                      <YieldAnalysis
                                                        permissions={this.state.permissions}
                                                        orthoAvailable={this.state.OrthomosaicAvailable && this.state.OrthomosaicAvailable != NotSelected ? true : false}
                                                        saveStats={(stats) => {
                                                          this.setState({
                                                            selectedMeasurement: {
                                                              ...this.state.selectedMeasurement,
                                                              stats: stats
                                                            }
                                                          })
                                                          this.state.measurements.forEach((m) => {
                                                            if (m.id === this.state.selectedMeasurement.id) {
                                                              m.stats = stats
                                                            }
                                                          })
                                                        }}
                                                        taskId={this.state.orthoImageData?.task_id}
                                                        measurement={this.state.selectedMeasurement}
                                                        user={this.state.user} />
                                                    </> : <></>}

                                                  {/* line statistics for polyline */}
                                                  {
                                                    (this.state.selectedMeasurement && this.state.selectedMeasurement.type === "Polyline") && (this.state.DSMAvailable) ?
                                                      <>
                                                        <LineStatistics
                                                          permissions={this.state.permissions}
                                                          isRegionInOrtho={this.state.isRegionInOrtho}
                                                          DSMAvailable={this.state.DSMAvailable != NotSelected && this.state.DSMAvailable}
                                                          showElevationProfile={this.state.showElevationProfile}
                                                          onclickShowGraph={() => {
                                                            this.setState((state) => ({
                                                              ...state,
                                                              showElevationProfile: !this.state.showElevationProfile
                                                            }
                                                            ), () => {
                                                              if (this.state.showElevationProfile)
                                                                this.getElevationProfileData()
                                                            })
                                                          }}
                                                          polyline={this.state.selectedMeasurement}
                                                          orthoImageData={this.state.orthoImageData}
                                                          user={this.state.user}
                                                          selectedUnit={this.state.selectedUnit.value}
                                                        />
                                                      </>
                                                      :
                                                      <></>}
                                                </> :
                                                this.state.clickedPolyFromShape ?
                                                  <>
                                                    <div className='content-text' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: 'white', padding: '0px 30px 5px 30px', borderBottom: '1px solid #e5e5e5' }}>

                                                      <div style={{ backgroundColor: 'white', fontSize: "14px", fontWeight: "500", color: "#2989cf" }}> {"Shape file measurement"}</div>

                                                      {/* Close Button */}
                                                      <div style={{ display: "flex" }}>
                                                        <div style={{ backgroundColor: 'white', marginLeft: "10px" }}>
                                                          <img src={closeBtn} style={{ width: '20px', height: '20px', cursor: "pointer", padding: "1px" }}
                                                            onClick={
                                                              () => {
                                                                this.setState((state) => ({
                                                                  ...state,
                                                                  sidebarPanel: false,
                                                                  displayColorPicker: false,
                                                                  showElevationProfile: false
                                                                }))
                                                              }
                                                            }
                                                          />
                                                        </div>
                                                      </div>

                                                    </div>

                                                    <div style={{
                                                      display: "flex",
                                                      justifyContent: "space-between",
                                                      padding: "10px 10px 10px 30px",
                                                      alignItems: "center",
                                                      borderBottom: "1px solid rgb(229, 229, 229)",
                                                    }}>
                                                      <div style={{ color: "#666666", fontSize: "12px", fontWeight: "400", }}>
                                                        Properties
                                                      </div>
                                                      <div>
                                                        <ButtonWithIcon text="Add to measurement" isDisabled={!(this.state.clickedPolyFromShape) || !(this.state.permissions?.[DRONENAKSHA_FEATURES.MAPS].EDIT)}
                                                          onClick={async () => {
                                                            // alert(`selected Poly :  `, this.state.clickedPolyFromShape)
                                                            await this.saveShapeFilePoly(this.state.clickedPolyFromShape, this.state.selectedShapeCountour)
                                                            // await this.setState({ clickedPolyFromShape: null })
                                                          }}
                                                        />
                                                      </div>

                                                    </div>

                                                    {
                                                      <div style={{ margin: '0 0 10px 34px', overflow: "auto", maxHeight: "50%" }}>

                                                        <div style={{ backgroundColor: 'white', display: "flex" }}>
                                                          {
                                                            !(this.state.clickedPolyFromShape instanceof L.Marker) ?
                                                              <>
                                                                <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>
                                                                  {(this.state.clickedPolyFromShape instanceof L.Polygon) ? "Area" : (this.state.clickedPolyFromShape instanceof L.Polyline) ? "Length" : "LatLng"}
                                                                </div>
                                                                <div style={{ display: "flex", heigth: "100%" }}>
                                                                  <div style={{ backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                                    {
                                                                      (this.state.clickedPolyFromShape instanceof L.Polygon) ?
                                                                        `${getArea((this.state.clickedPolyFromShape.getLatLngs())[0].map((latlng) => { return { lat: latlng.lat, lng: latlng.lng } }), 'm', true, false)}`
                                                                        : `${getDistance((this.state.clickedPolyFromShape.getLatLngs()).map((latlng) => { return { lat: latlng.lat, lng: latlng.lng } }), 'm', true, false)}`
                                                                    }
                                                                  </div>
                                                                </div>
                                                              </>
                                                              :
                                                              <div>
                                                                <div style={{ display: "flex" }}>
                                                                  <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>
                                                                    Latitude
                                                                  </div>
                                                                  <div style={{ marginLeft: "30px", heigth: "100%" }}>
                                                                    <div style={{ backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                                      {`${(this.state.clickedPolyFromShape._latlng.lat).toString().substring(0, 10)}`}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div style={{ display: "flex" }}>
                                                                  <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>
                                                                    Longitude
                                                                  </div>
                                                                  <div style={{ marginLeft: "30px", heigth: "100%" }}>
                                                                    <div style={{ backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                                      {`${(this.state.clickedPolyFromShape._latlng.lng).toString().substring(0, 10)}`}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                          }

                                                        </div>
                                                        {this.state.clickedPolyFromShape instanceof L.Polygon ?
                                                          <div style={{ backgroundColor: 'white', display: "flex" }}>
                                                            <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>
                                                              2D Perimeter
                                                            </div>
                                                            <div style={{ display: "flex", heigth: "100%" }}>
                                                              <div style={{ backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                                {
                                                                  `${getDistance((this.state.clickedPolyFromShape.getLatLngs())[0].map((latlng) => { return { lat: latlng.lat, lng: latlng.lng } }), 'm', true, false)}`
                                                                }
                                                              </div>
                                                            </div>
                                                          </div> : <></>}

                                                        {this.state.clickedPolyFromShape?.properties ?
                                                          Object.keys(this.state.clickedPolyFromShape.properties).map((item) => {
                                                            if (!(item == "2D Area" || item == "2D Perimet" || item == "3D Area" | item == "3D Perimet ")) {
                                                              return <div style={{ backgroundColor: 'white', alignItems: "center", display: "flex", }}>
                                                                <div style={{ backgroundColor: 'white', fontSize: "10px", width: "25%", fontWeight: "400", color: "#666666", marginTop: "15px" }}> {item}</div>
                                                                <div style={{ display: "flex", }}>
                                                                  <div style={{ wordBreak: "break-all", backgroundColor: 'white', fontSize: "12px", fontWeight: "400", color: "#3c3c3c", marginLeft: "5px", marginTop: "15px" }}>
                                                                    {this.state.clickedPolyFromShape?.properties[item] ? this.state.clickedPolyFromShape?.properties[item] : "-"}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            }
                                                          }) : <></>}
                                                      </div>
                                                    }
                                                  </> : <></>
                                            }
                                            <div className='content-text' style={{ display: "flex", alignItems: "center", backgroundColor: 'white', justifyContent: "space-between", padding: '0px 30px 10px 30px', borderBottom: '1px solid #e5e5e5' }}>
                                              <div style={{ backgroundColor: 'white', fontSize: "14px", fontWeight: "500", color: "#2989cf" }}> All Measurements</div>
                                              {!(this.state.selectedMeasurement) ? <img src={transClose} style={{ width: '18px', height: '18px', cursor: "pointer" }}
                                                onClick={
                                                  () => {
                                                    this.managePopup(false, true)
                                                  }
                                                }
                                              /> : <></>}
                                            </div>
                                            <div style={{ backgroundColor: 'white', padding: "20px 30px", overflowY: "scroll" }}>

                                              <div className="content-text" style={{ backgroundColor: 'white', }}>
                                                <div style={{ backgroundColor: 'white', fontSize: "12px", width: "100%", fontWeight: "400", color: "#666666" }}>Polygons</div>
                                                {this.state.drawnMeasurements.length > 0 ? <>{this.state.measurements.map((measurement, key) => {
                                                  if (measurement.type === "Polygon") {
                                                    return <div key={key} style={{ alignItems: "center", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400", color: "#3c3c3c", marginTop: "10px" }}>
                                                      <div style={{ cursor: 'pointer', display: "flex", alignItems: "center", color: this.state.selectedMeasurement ? (this.state.selectedMeasurement.id === measurement.id ? '#2989CF' : '#3c3c3c') : '#3C3C3C' }} >
                                                        <input type='checkbox' style={{ height: '15px', marginRight: "10px", width: '15px', cursor: 'pointer' }}
                                                          checked={measurement.show}
                                                          onChange={() => {
                                                            this.measurementHideShow(key, !measurement.show)
                                                          }}
                                                        />
                                                        <span onClick={() => {
                                                          this.measurementClicked(measurement.id)
                                                        }}>{measurement.name}</span>
                                                      </div>
                                                    </div>
                                                  }
                                                })}</>
                                                  : <></>}
                                              </div>

                                              <div className="content-text" style={{ backgroundColor: 'white', }}>
                                                <div style={{ backgroundColor: 'white', fontSize: "12px", width: "100%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>Lines</div>
                                                {this.state.drawnMeasurements.length > 0 ?
                                                  <>{this.state.measurements.map((measurement, key) => {
                                                    if (measurement.type === "Polyline") {
                                                      return <div key={key} style={{ alignItems: "center", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400", color: "#3c3c3c", marginTop: "10px" }}>
                                                        <div style={{ cursor: 'pointer', display: "flex", alignItems: "center", color: this.state.selectedMeasurement ? (this.state.selectedMeasurement.id === measurement.id ? '#2989CF' : '#3c3c3c') : '#3C3C3C' }}
                                                        > <input type='checkbox' style={{ height: '15px', marginRight: "10px", width: '15px', cursor: 'pointer' }}
                                                          checked={measurement.show}
                                                          onClick={() => {
                                                            this.measurementHideShow(key, !measurement.show)
                                                          }}
                                                          /> <span onClick={() => {
                                                            this.measurementClicked(measurement.id)
                                                          }}>{measurement.name}</span> </div>
                                                      </div>
                                                    }
                                                  })}
                                                  </>
                                                  :
                                                  <></>}
                                              </div>

                                              <div className="content-text" style={{ backgroundColor: 'white', }}>
                                                <div style={{ backgroundColor: 'white', fontSize: "12px", width: "100%", fontWeight: "400", color: "#666666", marginTop: "15px" }}>Markers</div>
                                                {this.state.drawnMeasurements.length > 0 ? <>{this.state.measurements.map((measurement, key) => {
                                                  if (measurement.type === "Marker") {
                                                    return <div key={key} style={{ alignItems: "center", backgroundColor: 'white', fontSize: "10px", width: "40%", fontWeight: "400", color: "#3c3c3c", marginTop: "10px" }}>
                                                      <div style={{ cursor: 'pointer', display: "flex", alignItems: "center", color: this.state.selectedMeasurement ? (this.state.selectedMeasurement.id === measurement.id ? '#2989CF' : '#3c3c3c') : '#3C3C3C' }}  > <input type='checkbox' style={{ height: '15px', marginRight: "10px", width: '15px', cursor: 'pointer' }}
                                                        checked={measurement.show}
                                                        onClick={() => {
                                                          this.measurementHideShow(key, !measurement.show)
                                                        }}
                                                      /> <span onClick={() => {
                                                        this.measurementClicked(measurement.id)
                                                      }}>{measurement.name}</span> </div>
                                                    </div>
                                                  }
                                                })}</>
                                                  : <></>}
                                              </div>
                                            </div>
                                          </> :
                                          <>
                                            {this.state.activeSidepanel === activeSidebarDownloadAssets ?
                                              <div style={{ height: 'calc(100% - 50px)', width: '100%', padding: '0px 25px', overflow: "scroll", marginTop: "20px", }}>
                                                {/* Download Asset Component */}

                                                {/* Orthomosaic Download  */}
                                                <div style={{ margin: "20px 0px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                                                  <DownloadAssetCard onClick={() => {
                                                    this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.downloadActiveLayer('ortho',)
                                                  }}
                                                    text="Orthomosaic" logo={orthoInactive} isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD || !(this.state.OrthomosaicAvailable && (this.state.OrthomosaicAvailable != NotSelected))} />
                                                  {/* Orthomosaic - NVDI Download  */}

                                                  <DownloadAssetCard onClick={() => {
                                                    this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.downloadActiveLayer('ndvi')
                                                  }}
                                                    logo={NDVIInactiveIcon} isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD || !(this.state.OrthomosaicAvailable && (this.state.OrthomosaicAvailable != NotSelected))}
                                                    text="NDVI" />

                                                </div>

                                                {/* DSM and DTM Download */}
                                                <div style={{ margin: "20px 0px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>


                                                  {/* DSM Download  */}

                                                  <DownloadAssetCard text="DSM" logo={DEMInactive} onClick={() => {
                                                    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) {
                                                      if (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) {
                                                        this.downloadActiveLayer('dem')
                                                      } else {
                                                        this.openDataNotAvailablePopup("DSM")
                                                      }
                                                    }
                                                  }}
                                                    isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD || !(this.state.DSMAvailable && (this.state.DSMAvailable != NotSelected))}
                                                  />


                                                  {/* DTM Download  */}

                                                  <DownloadAssetCard text="DTM" logo={DTMIconInactive}
                                                    onClick={() => {
                                                      if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) {
                                                        if (this.state.DTMAvailable) {
                                                          this.downloadActiveLayer('dtm')
                                                        } else {
                                                          this.openDataNotAvailablePopup("DTM")
                                                        }
                                                      }
                                                    }}
                                                    isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD || !(this.state.DTMAvailable && (this.state.DTMAvailable != NotSelected))}
                                                  />

                                                </div>

                                                {/* Main Report Download  */}
                                                <div style={{ margin: "20px 0px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                                                  <DownloadAssetCard linkData={{
                                                    pathname: "/dronenaksha/report",
                                                    blankPage: this.state.urlExits ? this.state.urlExits : undefined,
                                                    state: {
                                                      type,
                                                      user,
                                                      plan: this.props.location.state.plan,
                                                      project: this.props.location.state.project,
                                                      orthoImageData: this.state.orthoImageData,
                                                      ndviData: {
                                                        processTileIndex: this.state.processTileIndex,
                                                        processTileType: this.state.processTileType,
                                                        processTileMin: this.state.processTileMin,
                                                        processTileMax: this.state.processTileMax
                                                      },
                                                      permissions: this.state.permissions,
                                                      DSMAvailable: this.state.DSMAvailable ? this.state.DSMAvailable : undefined,
                                                      DTMAvailable: this.state.DTMAvailable ? this.state.DTMAvailable : undefined,
                                                      OrthomosaicAvailable: this.state.OrthomosaicAvailable ? this.state.OrthomosaicAvailable : undefined,
                                                    }
                                                  }}
                                                    logo={RGBInactiveIcon}
                                                    isDisabled={!(this.state.permissions[DRONENAKSHA_FEATURES.REPORTS].READ && this.state.orthoImageData?.id) || !this.state.urlExits}
                                                    text="Main Report"
                                                  />


                                                  {/* PlantHealth Report Download  */}

                                                  <DownloadAssetCard text={<><span>PlantHealth</span><br /><span>Report</span></>} logo={measurementReportIcon} linkData={{
                                                    pathname: "/dronenaksha/plantHealth_report",
                                                    state: {
                                                      type,
                                                      user,
                                                      plan: this.props.location.state.plan,
                                                      project: this.props.location.state.project,
                                                      yieldAnalysis: this.state.measurements.filter(m => m.stats),
                                                      orthoImageData: this.state.orthoImageData,
                                                      ndviData: {
                                                        processTileIndex: this.state.processTileIndex,
                                                        processTileType: this.state.processTileType,
                                                        processTileMin: this.state.processTileMin,
                                                        processTileMax: this.state.processTileMax
                                                      },
                                                      permissions: this.state.permissions,
                                                    },
                                                  }}
                                                    isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.REPORTS].READ || !(this.state.OrthomosaicAvailable && (this.state.OrthomosaicAvailable != NotSelected))} />

                                                </div>

                                                {/* Measurement Report Download */}
                                                <div style={{ margin: "20px 0px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>

                                                  <DownloadAssetCard
                                                    text={<>Measurement <br /> Report</>}
                                                    logo={measurementReportIcon} linkData={{
                                                      pathname: "/dronenaksha/measurement_report",
                                                      state: {
                                                        type,
                                                        user,
                                                        plan: this.props.location.state.plan,
                                                        project: this.props.location.state.project,
                                                        orthoImageData: this.state.orthoImageData,
                                                        DSMAvailable: this.state.DSMAvailable != NotSelected && this.state.DSMAvailable,
                                                        permissions: this.state.permissions,
                                                      },
                                                    }}
                                                    isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.REPORTS].READ}
                                                  />


                                                  {/* comparison Report Download */}

                                                  {<DownloadAssetCard
                                                    text={<>Comparison <br /> Report</>}
                                                    logo={compareInactiveIcon2}
                                                    linkData={{
                                                      pathname: "/dronenaksha/compare_measurement_report",
                                                      state: {
                                                        type,
                                                        user,
                                                        plan: this.props.location.state.plan,
                                                        project: this.props.location.state.project,
                                                        orthoImageData: this.state.orthoImageData,
                                                        DSMAvailable: this.state.DSMAvailable != NotSelected && this.state.DSMAvailable,
                                                        permissions: this.state.permissions,
                                                        calculationMethod: this.state.calculationMethod,
                                                        OrthomosaicAvailable: this.state.OrthomosaicAvailable,
                                                      },
                                                    }}
                                                    isDisabled={(!(this.state.permissions[DRONENAKSHA_FEATURES.REPORTS].READ && this.state.orthoImageData?.id)) || !(this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable)}
                                                  />}
                                                </div>

                                                <div style={{ margin: "20px 0px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>

                                                  {/* 3D Download */}

                                                  <DownloadAssetCard text={"3D Files Zip"} logo={threeDIcon} multipleDownloadOptions={this.state.threeDHighResAvailable} options={[
                                                    {
                                                      name: "High", onClick: () => {
                                                        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) {
                                                          this.getZipFIle(true)
                                                        }
                                                      }
                                                    },
                                                    {
                                                      name: "Low", onClick: () => {
                                                        if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].
                                                          DOWNLOAD) {
                                                          this.getZipFIle()
                                                        }
                                                      }
                                                    }

                                                  ]} onClick={() => {
                                                    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) {
                                                      this.getZipFIle()
                                                    }
                                                  }}
                                                    isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD || !(this.state.ThreeDAvailable !== NotSelected && this.state.ThreeDAvailable &&
                                                      this.state.indPointCloudAvailable !== NotSelected && this.state.indPointCloudAvailable && this.state.indThreeDAvailable !== NotSelected && this.state.indThreeDAvailable)}
                                                  />
                                                  <DownloadAssetCard text={"LAZ File"} logo={threeDIcon} onClick={() => {
                                                    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD && this.state.lasFilePath) {
                                                      window.open(`${this.state.lasFilePath}`, "_blank")
                                                    }
                                                  }}
                                                    isDisabled={!(this.state.lasFilePath && this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD)}
                                                  />
                                                </div>
                                                <div style={{ margin: "20px 0px", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>

                                                  {/* Contour Download */}

                                                  <DownloadAssetCard text={"Contour SHP File "} logo={shapeFileIcon} onClick={() => {
                                                    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) {
                                                      const url = this.state.contour.image_url + "?" + this.state.permissions.st;
                                                      this.downloadContourShapeFile(url)
                                                    }
                                                  }}
                                                    isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD || !(this.state.contour?.id)}
                                                  />
                                                  <DownloadAssetCard text={"Contour DXF File"} logo={dxfFileIcon} onClick={() => {
                                                    if (this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD) {
                                                      let url = this.state.contour.image_url + "?" + this.state.permissions.st;
                                                      url = url.replace('contour_shape', 'contour_dxf')
                                                      this.downloadContourDXFFile(url)
                                                    }
                                                  }}
                                                    isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].DOWNLOAD || !(this.state.contour?.id)}
                                                  />
                                                </div>
                                              </div>
                                              :

                                              <>
                                                {this.state.activeSidepanel === activeSidebarMapDetails ?
                                                  <>
                                                    <div>
                                                      <div>
                                                        <div style={{ display: "flex", flexDirection: "column", marginLeft: "30px" }}>
                                                          <span className="itemKey">Area</span>
                                                          <span className="itemValue">{this.state.orthoImageData.orthomosaicDetails ? (this.state.orthoImageData.orthomosaicDetails.area ?
                                                            this.state.selectedUnit.value == 'm' ? this.state.orthoImageData.orthomosaicDetails.area.split(" sq.meter")[0] + ' sq.m' :
                                                              `${(this.state.orthoImageData.orthomosaicDetails.area.split(" sq.meter")[0] * 10.7639).toFixed(4)} Sq.ft` : "NA") : "NA"}</span>
                                                        </div>
                                                        <hr style={{ margin: "0px", borderTop: "1px solid rgba(0,0,0,.1)", width: "100%" }} />
                                                        <div style={{ display: "flex", flexDirection: "column", marginLeft: "30px" }}>
                                                          <span className="itemKey">GSD</span>
                                                          <span className="itemValue">{this.state.orthoImageData.orthomosaicDetails ? (this.state.orthoImageData.orthomosaicDetails.gsd ? this.state.orthoImageData.orthomosaicDetails.gsd : "NA") : "NA"}</span>
                                                        </div>
                                                        <hr style={{ margin: "0px", borderTop: "1px solid rgba(0,0,0,.1)", width: "100%" }} />
                                                        <hr style={{ margin: "0px", borderTop: "1px solid rgba(0,0,0,.1)", width: "100%" }} />
                                                        <div style={{ display: "flex", flexDirection: "column", marginLeft: "30px" }}>
                                                          <span className="itemKey">Processing Time</span>
                                                          <span className="itemValue">{this.state.orthoImageData.orthomosaicDetails ? (this.state.orthoImageData.orthomosaicDetails.processing_time ? this.state.orthoImageData.orthomosaicDetails.processing_time : "NA") : "NA"}</span>
                                                        </div>
                                                        <hr style={{ margin: "0px", borderTop: "1px solid rgba(0,0,0,.1)", width: "100%" }} />
                                                        <div style={{ display: "flex", flexDirection: "column", marginLeft: "30px" }}>
                                                          <span className="itemKey">Processing Date</span>
                                                          <span className="itemValue">{this.state.orthoImageData.orthomosaicDetails ? (this.state.orthoImageData.orthomosaicDetails.processing_date ? this.state.orthoImageData.orthomosaicDetails.processing_date : "NA") : "NA"}</span>
                                                        </div>
                                                      </div>

                                                    </div>
                                                  </> :
                                                  <>
                                                  </>}
                                              </>}
                                          </>
                                    }
                                  </>}
                              </>
                            }
                          </>
                      }
                    </>
                  }

                </div>
              </div>
              :
              <></>
            </div>
          </div>

          <div className="right-content"
            style={{ overflowY: "hidden" }}>

            <Popup
              style={{ width: "min-content" }}

              trigger={<button id="view-image-popup-button" style={{
                display: "none",
              }}
              ></button>}
              modal
            ><img
                id="close-popup"
                src={closeButton} style={{
                  width: "auto",
                  height: "25px",
                  position: "absolute",
                  top: "-12px",
                  right: "-12px",
                  cursor: "pointer"

                }} onClick={() => {
                  var style = document.createElement('style');
                  style.type = 'text/css';
                  style.innerHTML = '.popup-content { width: 800px !important; border-radius:15px;}';
                  document.getElementsByTagName('head')[0].appendChild(style);
                  document.getElementById("view-image-popup-button").click();
                  this.setState((state) => ({
                    ...state,
                    regions: [],
                    scale: 0,
                    imageLoad: false,
                  }));

                }} />
              <div style={{ display: 'flex' }} >
                <div className='flex-center' style={{ alignItems: 'end', background: "#666666", width: "790px", height: '567px', borderRadius: '15px', }}>
                  {this.state.imageLoad ?
                    <img className='image-popup' src={Loader} style={{ position: "absolute", zIndex: 5, height: "100%", width: "8vw", marginLeft: "10%" }} /> : ''
                  }
                  <TransformWrapper>
                    {({ zoomIn, zoomOut, centerView, resetTransform, ...rest }) => (
                      <TransformComponent>
                        <img id="action-image" style={{ zIndex: 0, opacity: this.state.imageLoad ? 0 : 1 }} className='image-popup' loading='lazy'
                          src={this.state.images && this.state.images.length ? this.state.tiffSrc : ''}
                          onLoad={((load) => {
                            this.setState((state) => ({
                              ...state,
                              imageLoad: false,
                            }),
                              centerView(),
                              resetTransform())
                          })} />
                      </TransformComponent>
                    )}
                  </TransformWrapper>
                  {this.state.images && this.state.images.length ? <div className='imageinfo'>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div className="imagePopupTitle">{images[this.state.Idx].file_name.length > 50 ? images[this.state.Idx].file_name.substring(0, 50) : images[this.state.Idx].file_name}</div>
                      <div className="imagePopupSubTitleTile">
                        <div className="imagePopupSubTitle">{images[this.state.Idx].resolution} MP</div>
                      </div>

                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div className="imagePopupSubTitle">
                        {images[this.state.Idx].latitude == null || images[this.state.Idx].latitude == "" ? "" : `${images[this.state.Idx].latitude.length > 11 ? `${images[this.state.Idx].latitude.substring(0, 11)}` : `${images[this.state.Idx].latitude}`}`} {images[this.state.Idx].longitude == null || images[this.state.Idx].longitude == "" ? "" : `${images[this.state.Idx].longitude.length > 11 ? `, ${images[this.state.Idx].longitude.substring(0, 11)}` : `, ${images[this.state.Idx].longitude}`} ${images[this.state.Idx].altitude ? `, ${images[this.state.Idx].altitude}` : ""} `}
                      </div>
                      <div className="imagePopupSubTitleTile">
                        <div className="imagePopupSubTitle">{images[this.state.Idx].file_size} MB</div>
                      </div>
                    </div>
                  </div> : ''}

                  {this.state.images && this.state.images.length > 1 ? < div className='nextprevfunction'>
                    {
                      this.state.Idx == 0 ?
                        <div className='prevDiv'>
                          <img className='prev' src={circleLeft} style={{ opacity: '0.5', cursor: "default" }} />
                        </div> :
                        <div className='prevDiv' onClick={this.prevImg}>
                          <img className='prev' src={circleLeft} style={{ cursor: 'pointer' }} />
                        </div>

                    }
                    {
                      this.state.Idx == this.state.images.length - 1 ?
                        <div className='nextDiv'> <img className='next' src={circleRight} style={{ opacity: '0.5', cursor: "default" }}
                        /> </div> :
                        <div className='nextDiv' onClick={this.nextImg} >
                          <img className='next' src={circleRight} style={{ cursor: 'pointer' }} />
                        </div>
                    }

                  </div> : ''
                  }
                </div>
              </div>
            </Popup>

            {/* <div className="top-bar-farm" style={{ display: 'flex', color: 'white', backgroundColor: 'rgba(60, 60,60,0.6)', color: 'white' }}>

              <div className="breadCrumbs">
                <BreadCrumbs data={[
                  {
                    displayName: "projects",
                    pathname: "/dronenaksha/projects",
                    state: {
                      type,
                      user,
                    },
                    style: {
                      color: "white",
                      fontSize: "12px",
                    }
                  },
                  {
                    displayName: this.props.location.state.plan.project_name,
                    pathname: "/dronenaksha/project",
                    state: {
                      type,
                      user,
                      plan: this.props.location.state.plan,
                      project: this.props.location.state.project,
                    },
                    style: {
                      color: "white",
                      fontSize: "12px",
                    }
                  },
                  {
                    displayName: this.props.location.state.plan.plan_name,
                  }
                ]} />
                <ActiveRole />
              </div>
            </div> */}
            <TopBar title={<>
              <div className="breadCrumbs">
                <BreadCrumbs data={[
                  {
                    displayName: "projects",
                    pathname: "/dronenaksha/projects",
                    state: {
                      type,
                      user,
                    },
                    style: {
                      color: "white",
                      fontSize: "12px",
                    }
                  },
                  {
                    displayName: this.props.location.state.plan.project_name,
                    pathname: "/dronenaksha/project",
                    state: {
                      type,
                      user,
                      plan: this.props.location.state.plan,
                      project: this.props.location.state.project,
                    },
                    style: {
                      color: "white",
                      fontSize: "12px",
                    }
                  },
                  {
                    displayName: this.props.location.state.plan.plan_name,
                  }
                ]} />
                <ActiveRole />
              </div>
            </>} />

            {/* ----------------- Select Unit | Change base layer | Center ---------------------- */}
            {this.state.mapDataLoaded && !(this.state.ThreeDShow || this.state.pointCloudShow || this.state.bothShowPT) ?
              <div className='slide' style={{ display: 'flex', height: '26px', width: '285px', justifyContent: 'space-evenly', position: 'absolute', bottom: this.state.showElevationProfile && this.state.selectedMeasurement ? "40.5vh" : "15px", right: this.state.sidebarPanel ? '23.6vw' : '8px', zIndex: '1' }}>
                <div style={{ borderRadius: '6px', backgroundColor: 'white' }}>
                  <SelectComponent
                    selected={[this.state.selectedUnit]}
                    itemsList={this.state.unitSystems}
                    onchangeHandler={(value) => {
                      this.setState({
                        selectedUnit: value[0]
                      }, () => {
                        this.updateDataAsPerUnit()
                      })
                    }}
                    fontSize={10}
                    fontWeight={500}
                    width={"154px"}
                    height={"26px"}
                    iconSize={"10px"}
                    border={true}
                    borderRadius={'6px'}
                    dropdownGap={1}
                    dropdownHeight={"185px"}
                    dropdownPosition={'top'}
                    itemFontSize={'10px'}
                    itemFontWeight={500}
                  />
                </div>
                {/* changeBaseMapView  */}
                <div style={{ border: 'solid 1px rgb(102, 102, 102, 0.3)', height: '25px', backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: '5px', cursor: 'pointer', zIndex: '1' }}
                  onClick={() => {
                    this.switchBaseLayer()
                  }}>
                  <img style={{ width: '80px', height: '25px', borderRadius: '4px' }} src={this.state.activeBaseLayer === "satelite" ? roadMapView : sateliteView} />
                </div>
                {/* changeBaseMapView end */}
                <div style={{ cursor: this.getTiffAvailable() ? "pointer" : "not-allowed", border: 'solid 1px rgb(102, 102, 102, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: '5px', cursor: 'pointer', alignItems: 'center' }} onClick={() => {
                  if (this.getTiffAvailable()) {
                    this.setMapCenter().then(() => {
                      if (this.state.compare) {
                        this.removeLayer("leftLayer")
                        this.removeLayer("rightLayer")
                        this.removeLayer("compareControl").then(() => {
                          this.compareSlider()
                        })
                      }
                      // this.compareSlider()
                    });
                  }
                }}>
                  <img style={{ cursor: this.state.OrthomosaicAvailable ? "pointer" : "not-allowed", opacity: this.state.OrthomosaicAvailable ? 1 : 0.5, width: '15px', height: '15px', margin: '4.5px' }} src={trackingIcon} onClick={() => this.setMapCenter()} />
                </div>
              </div> : <></>}

            {/* ------------------------------------------------ */}


            {this.state.compare == true || this.state.compare3DMode == true ? <div style={{ zIndex: '11', marginTop: '45px', position: 'fixed' }}>

              {this.state.orthoImageData == undefined || this.state.compare3DMode == true ? '' : <div
                style={{ borderRadius: '10px', backgroundColor: 'rgba(60, 60,60,0.6)', color: 'white', textAlign: 'center', width: '25%', marginLeft: '15%', marginRight: '70%', position: 'fixed', padding: '1px 5px' }}>
                <div style={{ width: "100%", padding: '0px 30px' }}>
                  <div style={{ fontSize: "13px", overflow: 'hidden', height: '24px' }}>{this.state.orthoImageData.task_name} </div>
                  <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', height: '22px' }}>
                    <div style={{ fontSize: '11px', marginLeft: '5px' }}>{dateFormat(this.state.orthoImageData.date_created, "dd/mm/yyyy, h:MM TT")} </div>
                    <div style={{}}>
                      <select
                        style={{ width: "65px", height: "32px", border: "none", outline: "none", color: "white", fontSize: "12px", backgroundColor: 'transparent', }}
                        value={this.state.selectedLayer1}
                        onChange={(event) => this.setState({
                          selectedLayer1: event.target.value
                        }, () => {
                          this.compareSlider();
                        })}
                      >
                        {this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable ? <>
                          <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"orthomosaic"}>ORTHO</option>
                          <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"plantHealth"}>{this.state.processTileIndex}</option>
                        </> : <></>}
                        {this.state.DSMAvailable != NotSelected && this.state.DSMAvailable ?
                          <>
                            <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"dem"}>DSM</option>
                          </> :
                          <></>
                        }
                        {this.state.DTMAvailable != NotSelected && this.state.DTMAvailable ? <>
                          <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"dtm"}>DTM</option>
                        </> : <></>}
                        <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"base"}>BASE</option>
                      </select>
                    </div>
                  </div>
                </div>
                {
                  this.state.orthomosaicImages.length > 0 ? < div style={{ display: 'flex', width: '100%', backgroundColor: 'transparent' }}>
                    <div style={{ marginTop: '-35px' }}>
                      {
                        this.state.activeOrtho == 0 ?
                          <img src={Prev} style={{ height: '15px', opacity: '0.5', cursor: "default" }}
                          /> :
                          <img src={Prev} style={{ height: '15px', cursor: 'pointer' }}
                            onClick={() => {
                              this.managePopup()
                              this.prevOrtho()
                            }}
                          />
                      }
                    </div>
                    <div style={{ marginLeft: 'auto', marginTop: '-35px' }}>
                      {
                        this.state.activeOrtho == this.state.orthomosaicImages.length - 1 ?
                          <img src={Next} style={{ height: '15px', opacity: '0.5', cursor: "default" }}
                          /> :
                          <img src={Next} style={{ height: '15px', cursor: 'pointer' }}
                            onClick={() => {
                              this.managePopup()
                              this.nextOrtho()
                            }}
                          />
                      }
                    </div>
                  </div> : ''
                }
              </div>}
              {this.state.orthoImageData1 == undefined || this.state.compare3DMode == true ? '' :
                <div style={{ borderRadius: '10px', color: 'white', backgroundColor: 'rgba(60, 60,60,0.6)', textAlign: 'center', width: '25%', marginLeft: '62%', marginRight: '15%', position: 'fixed', padding: '1px 5px' }}>
                  <div style={{ width: "100%", padding: '0px 30px' }}>
                    <div style={{ fontSize: "13px", overflow: 'hidden', height: '24px' }}>{this.state.orthoImageData1.task_name}</div>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', height: '22px' }}>
                      <div style={{ fontSize: '11px', marginLeft: '5px' }}>{dateFormat(this.state.orthoImageData1.date_created, "dd/mm/yyyy, h:MM TT")} </div>
                      <div style={{}}>
                        <select
                          style={{ width: "65px", height: "32px", border: "none", outline: "none", color: "white", fontSize: "12px", backgroundColor: 'transparent', }}
                          value={this.state.selectedLayer2}
                          onChange={(event) => this.setState({
                            selectedLayer2: event.target.value
                          }, () => {
                            this.compareSlider()
                          })}
                        >
                          {this.state.OrthomosaicAvailable1 != NotSelected && this.state.OrthomosaicAvailable1 ? <>
                            <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"orthomosaic"}>ORTHO</option>
                            <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"plantHealth"}>{this.state.processTileIndex}</option>
                          </> : <></>}
                          {this.state.DSMAvailable1 != NotSelected && this.state.DSMAvailable1 ?
                            <>
                              <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"dem"}>DSM</option>
                            </> : <></>}
                          {this.state.DTMAvailable1 != NotSelected && this.state.DTMAvailable1 ? <>
                            <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"dtm"}>DTM</option>
                          </> : <></>}
                          <option style={{ backgroundColor: 'rgba(60, 60,60,0.6)' }} value={"base"}>BASE</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {
                    this.state.orthomosaicImages.length > 0 ? <div style={{ display: 'flex', width: '100%', backgroundColor: 'transparent' }}>
                      <div style={{ marginTop: '-35px' }}>  {
                        this.state.activeOrtho1 == 0 ?
                          <img src={Prev} style={{ height: '15px', opacity: '0.5', cursor: "default" }} /> :
                          <img src={Prev} style={{ height: '15px', cursor: 'pointer' }}
                            onClick={() => {
                              this.managePopup()
                              this.prevOrtho1()
                            }}
                          />
                      }
                      </div>
                      <div style={{ marginLeft: 'auto', marginTop: '-35px' }}>
                        {
                          this.state.activeOrtho1 == this.state.orthomosaicImages.length - 1 ?
                            <img src={Next} style={{ height: '15px', opacity: '0.5', cursor: "default" }}
                            /> :
                            <img src={Next} style={{ height: '15px', cursor: 'pointer' }}
                              onClick={() => {
                                this.managePopup()
                                this.nextOrtho1()
                              }}
                            />
                        }
                      </div>
                    </div> : ''
                  }
                </div>}

              {this.state.loadingComponent ? <></>
                : <div style={{ cursor: 'pointer', color: 'white', right: '5px', borderRadius: '5px', backgroundColor: 'rgba(60, 60,60,0.6)', position: 'fixed', padding: '5px', marginTop: "2px" }}
                  onClick={
                    () => {
                      this.setState((state) => ({
                        ...state,
                        compare: false,
                        compare3DMode: false,
                        openToolBar: false,
                      }), () => {
                        if (this.potree.current) {
                          this.potree.current.toggleView()
                        } else {
                          this.managePopup()
                          this.removeLayer("leftLayer")
                          this.removeLayer("rightLayer")
                          this.removeLayer("compareControl")
                          if (this.state.RGBShow) {
                            this.overlayTilesLayerOf("orthomosaic")
                          }
                          if (this.state.NDVIShow) {
                            this.overlayTilesLayerOf("plantHealth")
                          }
                          if (this.state.DEMShow) {
                            this.overlayTilesLayerOf("dem")
                          }
                          if (this.state.DTMShow) {
                            this.overlayTilesLayerOf("dtm")
                          }
                        }
                      })
                    }
                  }>
                  <img src={closeButton} style={{ width: '25px', height: '23px' }} />
                </div>}
            </div> :
              <div style={{ zIndex: '11', textAlign: 'center', marginTop: '3px', position: 'fixed', display: "flex", width: "96.5vw", justifyContent: "center", pointerEvents: "none" }}>
                {this.state.orthoImageData == undefined ? '' :
                  <div
                    style={{ borderRadius: '10px', textAlign: 'center', width: '20%', padding: '5px', pointerEvents: "all", }}>
                    <div style={{ color: 'white', width: '100%', padding: "0 10%", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ overflow: 'hidden', fontSize: "14px", textAlign: 'center', width: '100%', height: '24px' }}>{this.state.orthoImageData.task_name} <span style={{ fontSize: '10px', marginLeft: '5px' }}>{dateFormat(this.state.orthoImageData.date_created, "dd/mm/yyyy, h:MM TT")} </span></div>
                    </div>
                    {
                      this.state.orthomosaicImages.length > 1 ? < div style={{ display: 'flex', width: '100%', backgroundColor: 'transparent' }}>
                        <div style={{ marginTop: '-25px' }}>  {
                          this.state.activeOrtho == 0 ?
                            <img src={Prev} style={{ height: '15px', opacity: '0.5', cursor: "default" }}
                            /> :
                            <img src={Prev} style={{ height: '15px', cursor: 'pointer' }}
                              onClick={() => {
                                this.managePopup()
                                this.prevOrtho()
                              }}
                            />
                        }</div>
                        <div style={{ marginLeft: 'auto', marginTop: '-25px' }}> {
                          this.state.activeOrtho == this.state.orthomosaicImages.length - 1 ?
                            <img src={Next} style={{ height: '15px', opacity: '0.5', cursor: "default" }}
                            /> :
                            <img src={Next} style={{ height: '15px', cursor: 'pointer' }}
                              onClick={() => {
                                this.managePopup()
                                this.nextOrtho()
                              }}

                            />
                        }
                        </div>
                      </div> : ''
                    }
                  </div>}
              </div>}
            {/* location selector for cad file */}

            {this.state.openCadlocationPopup &&
              <AnimatedModal
                width="700px"
                height={"550px"}
                overflow="hidden"
                isOpen={true}
                onRequestClose={() => {
                  this.setState({ openCadlocationPopup: false })
                }}>
                <LocationSelector
                  closePopUp={() => {
                    const newAssetsLayers = this.state.assetsLayers.map(lyr => {//this is used to turn off layer if user does not select location
                      if (lyr.showLayer && !lyr.shapeLayer) {
                        return { ...lyr, showLayer: false }
                      } else {
                        return lyr
                      }
                    })
                    this.setState({ openCadlocationPopup: false, saveShapeFilePopup: false, uploadFileEvent: undefined, shpFileEvent: undefined, cadLocationSelected: false, shapeFilePopup: false, assetsLayers: newAssetsLayers })
                  }}
                  getSelectedLocation={this.getSelectedLocation} />

              </AnimatedModal>}

            {/* floor selector */}
            <AnimatedModal
              width="500px"
              height="230px"
              overflow="hidden"
              isOpen={this.state.openFloorSelectorPopUp}
              onRequestClose={() => {
                this.setState({ openFloorSelectorPopUp: false })
              }}>
              <FloorSelector floors={this.state.floors} closePopUp={(isCancel) => { this.setState({ openFloorSelectorPopUp: false, shapeFilePopup: isCancel ? false : true }) }} selectedFloor={this.state.selectedFloor} getSelectedFloor={(floor) => { this.setState({ floorForCadImport: floor, beginImportingCad: true }) }} />
            </AnimatedModal>
            {/* new floor add */}
            <AnimatedModal
              width="500px"
              height="230px"
              overflow="hidden"
              isOpen={this.state.openFloorAdderPopUp}
              onRequestClose={() => {
                this.setState({ openFloorAdderPopUp: false })
              }}>
              <FloorAdder floors={this.state.floors} closePopUp={() => { this.setState({ openFloorAdderPopUp: false }) }} addFloor={this.addFloor} />
            </AnimatedModal>

            {/* Global Activity popup for all uses */}
            <ActivityPopup
              item={this.state.universalActivityPopup_name}
              open={this.state.showUniversalActivityPopup}
              icon={this.state.universalActivityPopup_icon}
              action={this.state.universalActivityPopup_action}
              msg={this.state.universalActivityPopup_msg}
              close={this.closeUniversalActivityPopup}
              onClickOk={this.onOkUniversalActivityPopup}
            />
            {/* showDeletePopup */}
            <ActivityPopup
              item={this.state.showDeletePopup?.item}
              open={this.state.showDeletePopup?.open}
              icon={this.state.showDeletePopup?.icon}
              msg={this.state.showDeletePopup?.msg}
              close={() => this.setState({ showDeletePopup: undefined })}
            // onClickOk={() => alert("on ok click")}
            />

            <ActivityPopup
              item={this.state.activityPopupObj?.item}
              open={this.state.activityPopupObj?.open}
              icon={this.state.activityPopupObj?.icon}
              // action={this.state.universalActivityPopup_action}
              msg={this.state.activityPopupObj?.msg}
              close={() => { this.setState({ activityPopupObj: undefined }) }}
              onClickOk={() => { this.setState({ activityPopupObj: undefined }) }}
            />

            {/* -------------- Activity Popup ----------------------- */}
            <ActivityPopup
              item={this.state.itemName}
              open={this.state.showProcessPopup}
              icon={this.state.processPopupIcon}
              action={this.state.processAction}
              msg={this.state.processMessage}
              close={() => this.closeActivityPopup()}
              onClickOk={() => this.deleteSharedData()}
            />

            {/* --------------------------------------------------------------- */}

            {/*  Activity popup for invalid measurements */}
            <ActivityPopup
              item={this.state.shapeFileItem}
              open={this.state.shapeFilePopup || this.state.saveShapeFilePopup}
              icon={this.state.shapeFileIcon}
              msg={this.state.shapeFileMsg}
              close={() => this.setState({ shapeFilePopup: false, saveShapeFilePopup: false })}
              onClickOk={() => this.setState({ shapeFilePopup: false, saveShapeFilePopup: false })}
            />
            {/* Activity popup for cad location selection */}
            <ActivityPopup
              item={this.state.cadFileItem}
              open={this.state.cadFilePopup || this.state.savecadFilePopup}
              icon={this.state.cadFileIcon}
              msg={this.state.cadFileMsg}
              close={() => this.setState({ cadFilePopup: false, savecadFilePopup: false, openCadlocationPopup: true })}
              onClickOk={() => this.setState({ cadFilePopup: false, savecadFilePopup: false, openCadlocationPopup: true })}
            />
            {/* Activity popup for layers deletetion*/}
            <ActivityPopup
              item={this.state.deleteLayerItem}
              open={this.state.deleteLayerPopup}
              icon={this.state.deleteLayerIcon}
              msg={this.state.deleteLayerMsg}
              close={() => this.setState({ deleteLayerPopup: false, deleteMultipleLayers: false, layerToDelete: undefined })}
              onClickOk={() => this.setState({ deleteLayerPopup: false, deleteMultipleLayers: false },
                () => {
                  if (this.state.layerToDelete) this.handleDeleteLayer(this.state.layerToDelete)
                  else this.handleDeleteMultipleLayers()
                })}
            />
            {/* Activity popup for floor deletion */}
            <ActivityPopup
              item={this.state.deleteFloorItem}
              open={this.state.deleteFloorPopup}
              icon={this.state.deleteFloorIcon}
              msg={this.state.deleteFloorMsg}
              close={() => this.setState({ deleteFloorPopup: false })}
              onClickOk={() => this.setState({ deleteFloorPopup: false, },
                () => {
                  this.deleteFloor(this.state.selectedFloor.id)
                })}
            />
            {/* Activity popup for invalid file format */}
            <ActivityPopup
              item={this.state.invalidFileItems}
              open={this.state.invalidFilePopup}
              icon={this.state.invalidFileIcon}
              msg={this.state.invalidFileMsg}
              close={() => this.setState({ invalidFilePopup: false })}
              onClickOk={() => this.setState({ invalidFilePopup: false })}
            />
            {/*  ---------------------------------------  */}


            <CopyToClipboard id='copy' text={this.state.copyText} onCopy={() => {
            }}><span></span></CopyToClipboard>

            {/* -----------Elevation Profile --------------- */}
            <ElevationProfile selectedUnit={this.state.selectedUnit.value} closeElevationGraph={this.closeElevationGraph} isElevationData={this.state.isElevationData} elevationData={this.state.graphData} showElevationProfile={this.state.showElevationProfile && this.state.selectedMeasurement && this.state.selectedMeasurement.type == 'Polyline'} />
            {/* -------------------------------------------- */}

            {/* delete shared access modal */}
            <AnimatedModal
              isOpen={this.state.shareDetailedData}
              height="450px"
              width="700px">
              <div style={{ display: "flex", height: "100%" }}>
                <div style={{ width: "35%", backgroundColor: "#EAEAEA", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center" }}>
                  <img src={shareInviteMailIcon} style={{ margin: "8%" }} />
                </div>
                <img style={{ position: "absolute", top: '7px', right: "7px", width: '20px', height: '20px', cursor: "pointer" }} src={closeBtn} onClick={() => {
                  this.setState((state) => ({
                    ...state,
                    shareDetailedData: false
                  }))
                }} />
                <div style={{ margin: '20px 50px 5px 35px' }}>
                  <div
                    style={{
                      textAlign: "left",
                      fontSize: "20px",
                      fontWeight: "500",
                      color: "#3C3C3C",
                    }}
                  >
                    {`Are you sure you want to remove access ?`}
                  </div>
                  <div
                    style={{
                      textAlign: "left",
                      margin: "10px 0px 2px 0px",
                      fontSize: "15px",
                      fontWeight: "500",
                      color: "#3C3C3C",
                    }}
                  >Access to the following assets will be removed</div>
                  <div style={{ height: '265px', width: '100%', overflow: 'auto' }}>
                    {this.state.accessRemoved == 0 ? <div style={{
                      textAlign: "center",
                      margin: "50px 0px 0px 0px",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#3C3C3C",
                    }}>Access record not found</div> :
                      this.state.accessRemoved.map((access, key) => {
                        return <>
                          <div style={{
                            textAlign: "left",
                            margin: "10px 0px 2px 0px",
                            fontSize: "13px",
                            fontWeight: "500",
                            color: "#3C3C3C",
                          }}>Plan Name: <span style={{ fontWeight: '500' }}>{access.plan_name}</span></div>
                          <div style={{
                            textAlign: "left",
                            margin: "3px 0px 0px 0px",
                            fontSize: "13px",
                            fontWeight: "500",
                            color: "#3C3C3C",
                          }}>Imageset Name: <span style={{ fontWeight: '500' }}>{access.collection_name}</span></div>
                        </>
                      })}
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="addcustomer-button-empty-dashboard" style={{ padding: '8px 20px 8px 20px', cursor: 'pointer' }} onClick={() => {
                      this.setState((state) => ({
                        ...state,
                        shareDetailedData: false,
                        deleteShareEmail: '',
                        deleteshareSId: '',
                        accessRemoved: [],
                      }))
                    }}>
                      Cancel
                    </div>
                    <div className="addcustomer-button-empty-dashboard" style={{ padding: '8px 35px 8px 35px', cursor: 'pointer' }} onClick={() => {
                      this.deleteSharedData();
                    }}>
                      Ok
                    </div>
                  </div>


                </div>
              </div>

            </AnimatedModal>

            {/* share map moda; */}
            <AnimatedModal
              isOpen={this.state.shareInviteModal}
              height="450px"
              width="700px"
            >
              <div style={{ display: "flex", height: "100%" }}>
                <div style={{ width: "35%", backgroundColor: "#EAEAEA", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center" }}>
                  <img src={shareInviteMailIcon} style={{ margin: "8%" }} />
                </div>
                <img style={{ position: "absolute", top: '7px', right: "7px", width: '20px', height: '20px', cursor: "pointer" }} src={closeBtn} onClick={() => {
                  this.setState((state) => ({
                    ...state,
                    shareInviteModal: false,
                    inviteModal: false,
                    inviteMail: [],
                    successEmails: [],
                    existEmails: [],
                    errorEmails: [],
                    emailValue: '',
                    accessType: false,
                    validationDisplay: "none",
                    validationColor: "red",
                    validationMessage: ""
                  }))
                }} />
                <div style={{ width: "65%", height: "100%" }}>
                  <div
                    style={{
                      textAlign: "left",
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "#3C3C3C",
                      margin: '20px 50px 5px 35px'
                    }}
                  >
                    Share Assets
                  </div>
                  {/* <form> */}
                  <div
                    style={{ textAlign: "center", margin: "0px 50px 0px 35px" }}
                  >

                    <div
                      style={{
                        textAlign: "left",
                        margin: "0px 0px 2px 2px",
                        fontSize: "12px",
                        color: "#3C3C3C",
                      }}
                    >
                      Invite users to view assets
                    </div>
                    <label
                      style={{
                        display: "flex",
                        fontFamily: "Poppins",
                        fontStyle: "normal",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "22px",
                        alignItems: "center",
                        textTransform: "capitalize",
                        color: "@fontColorSecondary !important",
                        marginBottom: "4px",
                      }}
                    >

                      <input
                        // type='email' multiple
                        // pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        style={{ width: '300px', fontSize: '11px', lineHeight: '13px' }}
                        onChange={(event) => this.handleInputChange(event)}
                        value={this.state.emailValue}
                        name="username"
                        className="add-user-form-text"
                        placeholder="Enter list of emails separated by comma."
                      />
                    </label>
                    <div style={{ textAlign: "left", color: this.state.validationColor, fontSize: "12px", margin: "2px", height: "18px" }}>{this.state.validationMessage}</div>
                  </div>
                  <div style={{ textAlign: "center", margin: "0px 50px 10px 35px", display: 'flex', fontSize: '12px' }}>
                    <div style={{ marginRight: '10px', width: "22%", display: "flex", justifyContent: "space-between", alignItems: 'center', marginLeft: "2px" }}><input type='checkbox' name="access_type" value={'READ'} checked={this.state.accessType == true} onClick={() => {
                      this.setState((state) => ({
                        ...state,
                        accessType: !this.state.accessType
                      }))
                    }} /> Read Only</div>
                    {/* <div style={{ marginLeft: '10px' }}><input type='radio' name="access_type" value='DOWNLOAD' checked={this.state.accessType == 'DOWNLOAD'} onClick={() => {
                        this.setState((state) => ({
                          ...state,
                          accessType: 'DOWNLOAD'
                        }))
                      }} />  Download</div> */}
                  </div>
                  <div className="teamsInvite" style={{ display: "flex", justifyContent: "space-between", padding: "0 50px 0px 35px", width: "65%", }}>
                    <div style={{ textAlign: "center" }}>
                      <button
                        className="defaultButtonSuccess"
                        onClick={() => {
                          this.sendInvite()
                        }}
                      >Share</button>
                    </div>
                  </div>
                  {/* </form> */}
                  <hr style={{ margin: '15px 50px 15px 35px' }}></hr>

                  <div
                    style={{
                      textAlign: "left",
                      margin: "0 0 10px 0",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#3C3C3C",
                      margin: '20px 50px 10px 35px'
                    }}
                  >
                    Already Shared
                  </div>
                  <div style={{ padding: this.state.alreadysharedwith.length === 0 ? undefined : '0px 45px 0px 35px', display: this.state.alreadysharedwith.length === 0 ? "flex" : undefined, justifyContent: this.state.alreadysharedwith.length === 0 ? 'center' : undefined, alignItems: this.state.alreadysharedwith.length === 0 ? "center" : undefined, height: '145px', overflow: 'auto', width: '99%' }}>

                    {this.state.alreadysharedwith.length === 0 ? <p style={{ fontSize: '14px' }}>Nothing is shared here.</p> :
                      this.state.alreadysharedwith.map((shared, key) =>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                          <div style={{ width: '90%', overflow: 'hidden', textAlign: 'left' }}>
                            <div style={{ lineHeight: '18px', fontSize: '14px', }}>{
                              shared.shared_to
                              // .length > 30 ?
                              //   `${shared.shared_to.substring(0, 30)}...` :
                              //   `${shared.shared_to}`
                            }</div>
                            <div style={{ display: 'flex', }}>
                              <div style={{ fontSize: '10px', display: "flex", alignItems: "center", color: '#666666' }}>{shared.access_level.title === 'READ' ? 'View Access' : 'Download Access'}</div>
                              {shared.status === 'Invited' ? <div style={{ marginLeft: '10px', fontSize: '12px', color: '#2989cf' }}>(Pending)</div> : <></>}
                            </div>
                          </div>
                          <div style={{ width: '10%', textAlign: 'right', }}>
                            <img style={{ width: '16px', height: '16px', cursor: "pointer" }} src={closeBtn} onClick={() => {
                              this.setState((state) => ({
                                ...state,
                                accessType: false,
                                deleteShareEmail: shared.shared_to,
                                deleteshareSId: shared.sid
                              }), () => {
                                if (shared.status === 'Invited') {
                                  this.setState((state) => ({
                                    ...state,
                                    shareInviteModal: false,
                                    itemName: "Share Access",
                                    processPopupIcon: "WARNING",
                                    processAction: "DELETE",
                                    processMessage: 'Are you sure you want to remove this Share Access ?',
                                    showProcessPopup: true,
                                  }))
                                } else {
                                  this.getSharedData()
                                }
                              })
                            }} />
                          </div>
                        </div>
                      )}
                  </div>

                </div>

              </div>
            </AnimatedModal>

            <div className="main-content" style={{ padding: "0", height: "100vh", position: "relative" }}>
              <Modal
                style={{ marginTop: "150px" }}
                show={this.state.downloadNDVIPopup}
              >
                <Modal.Body>
                  {errorWhileDownloading ? <>
                    <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: "-20px" }}>
                      <img src={fail} style={{
                        width: "auto",
                        height: "75px",
                        margin: "18px auto"
                      }} />
                      <p>Something went wrong during downloading image.</p>
                    </div> <div>
                      <button
                        className="add-user-form-submit-button popup-btn-right btn-ok"
                        onClick={() => {
                          this.setState({
                            downloadNDVIPopup: false,
                          }, () => {
                            this.setState({ errorWhileDownloading: false })
                          })
                        }}
                      >
                        Ok
                      </button>
                    </div> </> : <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginBottom: "30px" }}>
                    <img src={waiting} style={{
                      width: "auto",
                      height: "75px",
                      margin: "18px auto"
                    }} />
                    <p>Please wait, we are downloading image...</p>
                  </div>}
                </Modal.Body>
              </Modal>
              <div style={{ display: "flex" }}>
                <div style={{ width: "100%", height: "100vh" }}>
                  {this.state.mapDataLoaded ?
                    <>
                      {
                        // for threed texture view view which is running on another app
                        this.state.ThreeDShow || this.state.pointCloudShow || this.state.bothShowPT ?
                          <div style={{ backgroundColor: '#000000', height: '100%', width: '100%', position: "absolute", zIndex: 1 }}>
                            <PotreeViewer
                              ref={this.potree}
                              showMeasurements={this.state.allMeasurementsShow}
                              drawVolumeBox={this.state.drawVolumeBox}
                              user={this.state.user}
                              taskId={this.state.orthoImageData.task_id}
                              ThreeDShow={this.state.ThreeDShow}
                              pointCloudShow={this.state.pointCloudShow}
                              bothShowPT={this.state.bothShowPT}
                              drawIn2dAndSave={this.drawIn2dAndSave}
                              getArea={get3dPolygonArea}
                              getLength={getDistanceIn3d}
                              unit={this.state.selectedUnit.value}
                              measurementClickedOnThreed={this.measurementClickedOnThreed}
                              isOwner={this.state.isOwner}
                              updateMeasurement={this.updateMeasurementFrom3d}
                              utmDetails={this.state.utmDetails}
                              measurements={this.state.measurements}
                              compare3DMode={this.state.compare3DMode}
                              threeDModelData={this.state.orthomosaicImages}
                              loadingComponent={(data) => { this.setState({ loadingComponent: data }) }}
                              sidebarPanel={this.state.sidebarPanel}
                            />
                          </div>
                          :
                          <></>
                      }
                      {this.state.FloorImagesViewer ? <div
                        style={{
                          backgroundColor: '#000000',
                          height: this.state.minimizedFloorPlanningViewer ? "30%" : '100%',
                          width: this.state.minimizedFloorPlanningViewer ? "25%" : '76.1%',
                          position: "absolute",
                          overflow: "hidden",
                          borderRadius: this.state.minimizedFloorPlanningViewer ? "2%" : '0%',
                          zIndex: this.state.minimizedFloorPlanningViewer ? 1 : 0,
                          left: this.state.minimizedFloorPlanningViewer ? "10px" : "0px",
                          bottom: this.state.minimizedFloorPlanningViewer ? "5px" : "0px",
                          transition: "0.5s all"
                        }}>
                        <FloorImagesViewer
                          minimizedView={this.state.minimizedFloorPlanningViewer}
                          changeView={(value) => {
                            this.setState({
                              minimizedFloorPlanningViewer: value
                            })
                          }}
                          closeViwer={() => {
                            this.setState({
                              FloorImagesViewer: false
                            })
                          }}
                          st={this.state.permissions?.st}
                          images360={this.state.FloorImagesViewer.images360}
                          imagesPlain={this.state.FloorImagesViewer.images}
                          index={this.state.FloorImagesViewer.index}
                          panning={this.state.panning}
                          handleImageAnnotationToolChange={this.handleImageAnnotationToolChange}
                          mentionObj={{ teamMembers: this.state.teamMembers, sendAnnotationNotification: this.sendAnnotationNotification }}
                          rest={{ taggedIssue: this.state.taggedIssue, notificationViewed: false }}
                          isDisabled={!this.state.permissions[DRONENAKSHA_FEATURES.MAPS].EDIT}
                          scene={this.scene}
                          camera={this.camera}
                          callMarkIssue={this.state.callMarkIssue}
                          callback={this.callback}
                        />
                      </div> : <></>}

                      <Map
                        innerMapChildren={
                          !this.state.minimizedFloorPlanningViewer ?
                            <Maximize
                              style={
                                { zIndex: 10000 }
                              }
                              onClick={() => this.setState({
                                minimizedFloorPlanningViewer: true
                              })}
                            />
                            : <></>
                        }
                        style={
                          {
                            left: !(this.state.minimizedFloorPlanningViewer) ? "10px" : "0px",
                            bottom: !(this.state.minimizedFloorPlanningViewer) ? "5px" : "0px",
                            height: !(this.state.minimizedFloorPlanningViewer) ? "30%" : '100%',
                            width: !(this.state.minimizedFloorPlanningViewer) ? "25%" : '100%',
                            borderRadius: !(this.state.minimizedFloorPlanningViewer) ? "2%" : '0%',
                            zIndex: !(this.state.minimizedFloorPlanningViewer) ? 1 : 0,
                            position: "absolute",
                            transition: "0.5s all"

                          }
                        }
                        setBaseLayerToState={this.setBaseLayerToState}
                        compare={this.state.compare}
                        initCenter={[0, 0]}
                        bounds={this.state.bounds}
                        map={this.state.map}
                        map2={this.state.map2}
                        maxZoom={this.state.tileMaxZoom}
                        initZoom={16}
                        handleMapClick={this.handleMapClick}
                        handleMoveStart={this.handleMoveStart}
                        setMap1={(map) => {
                          let drawBounds = this.state.map ? false : true
                          this.setState({ map: map }, () => {
                            this.mapInitialized()
                            if (this.state.OrthomosaicAvailable && this.state.OrthomosaicAvailable != NotSelected) {
                              if (drawBounds && this.state.RGBShow || this.state.DEMShow) {
                                this.drawBoundsborder()
                              }
                              if (this.state.RGBShow) {
                                this.overlayTilesLayerOf("orthomosaic")
                              }
                              if (this.state.NDVIShow) {
                                this.overlayTilesLayerOf("plantHealth")
                              }
                              if (this.state.DEMShow) {
                                this.overlayTilesLayerOf("dem")
                              }
                              if (this.state.DTMShow) {
                                this.overlayTilesLayerOf("dtm")
                              }
                            }
                          })
                        }}
                      >

                        {this.state.compare || this.state.compare3DMode ? <></> :
                          <DrawingToolbar
                            state={
                              {
                                isOwner: this.state.isOwner,
                                sharedBy: this.state.sharedBy,
                                isAllowToDownload: this.state.isAllowToDownload,
                                FloorImagesViewer: this.state.FloorImagesViewer,
                                minimizedFloorPlanningViewer: this.state.minimizedFloorPlanningViewer,
                                showPointer: this.state.showPointer,
                                compare: this.state.compare,
                                sidebarPanel: this.state.sidebarPanel,
                                activeSidepanel: this.state.activeSidepanel,
                                activeSideBarFloor: this.state.activeSideBarFloor,
                                panning: this.state.panning,
                                permissions: this.state.permissions,
                                orthoImageData: this.state.orthoImageData,
                                ThreeDShow: this.state.ThreeDShow,
                                bothShowPT: this.state.bothShowPT,
                                showOnclickPointDetails: this.state.showOnclickPointDetails,
                                drawVolumeBox: this.state.drawVolumeBox,
                                drawPolygon: this.state.drawPolygon,
                                drawMarker: this.state.drawMarker,
                                drawPolyline: this.state.drawPolyline,
                                drawMeasurements: this.state.drawnMeasurements,
                                inspectShow: this.state.inspectShow,
                                showMeasurement: this.state.showMeasurements,
                                images: this.state.images
                              }
                            }
                            functions={
                              {
                                handleImageAnnotationToolChange: this.handleImageAnnotationToolChange,
                                managePopup: this.managePopup,
                                toggleSidepanelData: this.toggleSidepanelData,
                                toggleMeasurement: this.toggleMeasurement,
                                getTiffAvailable: this.getTiffAvailable,
                              }
                            }
                            callDrawingTool={this.callDrawingTool}
                            potree={this.potree}
                            updateRMAssignDroneState={this.updateRMAssignDroneState}
                          />
                        }
                      </Map>

                    </>
                    : <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <img src={Loader} style={{ height: "30vh", width: "100%", marginLeft: "3%" }} />
                    </div>}
                </div>
                {/* changeBaseMapView end */}
                {/* bottom Toolbar */}
                {this.state.mapDataLoaded ?
                  <div className='slide' style={{ zIndex: '1', borderRadius: '10px', "bottom": this.state.showElevationProfile && this.state.selectedMeasurement ? "40.5vh" : "15px", position: 'fixed', display: "flex", justifyContent: "center", width: this.state.sidebarPanel ? '73vw' : '96vw', pointerEvents: "none" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", pointerEvents: "all" }}>

                      {/* dem layer popup */}

                      {this.state.DEMShowPopup ? <div
                        className={this.state.orthoImageData ? "hoverPointer AeroFarm" : "disableDiv"}
                        style={{ fontSize: "9px", width: "85px", borderRadius: '5px', backgroundColor: "white", fontWeight: "500", marginBottom: "10px", marginLeft: this.state.ThreeDAvailable === NotSelected ? "61px" : "0px" }}>
                        {this.state.DSMAvailable != NotSelected && this.state.DSMAvailable ?
                          <div className={this.state.DEMType == "DSM" && (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) ? "DEM" : ""} style={{ fontSize: '14px', margin: "10px auto 5px 10px" }}
                            onClick={
                              () => {
                                if (this.state.orthoImageData && (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable)) {
                                  this.setState({ DEMShowPopup: false })
                                  this.toggleLayer("dsm")
                                } else {
                                  this.openDataNotAvailablePopup("DSM")
                                }
                              }
                            } >DSM</div> : <div className={this.state.DEMType == "DSM" && (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) ? "DEM" : ""}
                              style={{ fontSize: '14px', margin: "10px auto 5px 10px", opacity: '0.5', cursor: "default" }} >DSM</div>}
                        {/* DEM layer is the dsm layer,for user interface we renamed dem layer to dsm layer*/}
                        <hr style={{ margin: "0px" }} />
                        {this.state.DTMAvailable != NotSelected && this.state.DTMAvailable ? <div className={this.state.DEMType == "DTM" && this.state.DTMAvailable ? "DEM" : ""}
                          style={{ fontSize: '14px', margin: "5px auto 10px 10px" }} onClick={
                            () => {
                              if (this.state.orthoImageData && this.state.DTMAvailable) {
                                this.setState({ DEMShowPopup: false })
                                this.toggleLayer("dtm")
                              } else {
                                this.openDataNotAvailablePopup("DTM")
                              }
                            }
                          } >DTM</div>
                          : <div className={this.state.DEMType == "DTM" && this.state.DTMAvailable ? "DEM" : ""}
                            style={{ fontSize: '14px', margin: "5px auto 10px 10px", opacity: '0.5', cursor: "default" }} >DTM</div>}
                      </div> : <></>}

                      {/* dem layer popup end*/}

                      {/* 3d layer popup */}
                      {this.state.ThreeDShowPopup ? <div
                        className={this.state.ThreeDAvailable && this.state.ThreeDAvailable != NotSelected ? "hoverPointer AeroFarm" : "disableDiv"}
                        style={{ fontSize: "9px", width: "125px", borderRadius: '5px', backgroundColor: "white", fontWeight: "500", marginBottom: "10px", marginLeft: !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) ? "62px" : "121px" }}>
                        {this.state.indPointCloudAvailable && this.state.indPointCloudAvailable != NotSelected ? <div className={this.state.pointCloudShow ? "DEM" : ""} style={{ fontSize: '14px', margin: "10px auto 5px 15px" }} onClick={
                          () => {
                            this.setState({ ThreeDShowPopup: false })
                            this.toggleLayer("pointCloud")
                          }
                        } >Points Cloud</div> : <div className={this.state.pointCloudShow ? "DEM" : ""} style={{ fontSize: '14px', margin: "10px auto 5px 15px", opacity: '0.5', cursor: 'auto' }} >Points Cloud</div>}
                        <hr style={{ margin: "0px" }} />
                        {this.state.indThreeDAvailable && this.state.indThreeDAvailable != NotSelected ? <div className={this.state.ThreeDShow ? "DEM" : ""} style={{ fontSize: '14px', margin: "5px auto 10px 15px" }} onClick={
                          () => {
                            this.setState({ ThreeDShowPopup: false })
                            this.toggleLayer("ThreeD")
                          }
                        } >Texture View</div> : <div className={this.state.ThreeDShow ? "DEM" : ""} style={{ fontSize: '14px', margin: "5px auto 10px 15px", opacity: '0.5', cursor: 'auto' }}  >Texture View</div>}
                        <hr style={{ margin: "0px" }} />
                        {this.state.indThreeDAvailable && this.state.indThreeDAvailable != NotSelected && this.state.indPointCloudAvailable && this.state.indPointCloudAvailable != NotSelected ?
                          <div className={this.state.bothShowPT ? "DEM" : ""} style={{ fontSize: '14px', margin: "5px auto 10px 15px" }} onClick={
                            () => {
                              this.setState({ bothShowPT: false })
                              this.toggleLayer("bothPT")
                            }
                          } >Both</div> : <div className={this.state.bothShowPT ? "DEM" : ""} style={{ fontSize: '14px', margin: "5px auto 10px 15px", opacity: '0.5', cursor: 'auto' }}  >Both</div>}
                      </div> : <></>}
                      {/* 3d layer popup end*/}
                      {/* Floor layer popup start */}
                      {/* {this.state.showFloorPopUp ? <div
                        className={"hoverPointer AeroFarm"}
                        style={{ fontSize: "9px", width: "max-content", borderRadius: '5px', backgroundColor: "white", fontWeight: "500", marginBottom: "10px", marginLeft: !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable)?"0px":"235px", overflow: "hidden" }}>
                        <div
                          style={{ fontSize: '14px', padding: "5px 10px 10px 10px", background: "#F0F0F0", color: "" }} onClick={
                            () => {
                              this.setState({ openFloorAdderPopUp: true, showFloorPopUp: false })
                              if (this.state.activeSidepanel === this.state.activeSideBarFloor && this.state.sidebarPanel) {
                                this.managePopup(false, true)
                              }
                            }
                          } >Add</div>
                        <hr style={{ margin: "0px" }} />
                        <div style={{ overflowY: "auto", maxHeight: "120px" }}>
                          {this.state?.floors.map(floor => <> <div className={this.state.activeSideBarFloor === `${floor.name} ${floor.number}` ? "DEM" : ""}
                            style={{ fontSize: '14px', margin: "5px 10px 5px 10px" }} onClick={
                              () => {
                                this.setState({ activeSideBarFloor: `${floor.name} ${floor.number}`, showFloorPopUp: false, selectedFloor: floor }, () => {

                                  this.toggleMeasurement("showPointer")
                                  // if (this.state.activeSidepanel === this.state.activeSideBarFloor && this.state.sidebarPanel) {
                                  //   this.managePopup(false, true)
                                  //   this.setState({ activeSideBarFloor: "" })
                                  // } else {
                                  if (!(this.state.compare)) { this.toggleSidepanelData(this.state.activeSideBarFloor) }
                                  // }
                                })
                              }
                            } >{(floor?.name && floor?.number) ? `${floor?.name} ${floor?.number}` : "-"}</div> <hr style={{ margin: "0px" }} /></>
                          )
                          }
                        </div>

                      </div> : <></>} */}
                      {/* Floor layer popup end */}

                      {/* layer switching bar */}
                      {this.state.compare || this.state.drawVolumeBox || this.state.compare3DMode ? <></> :
                        <div
                          // this.state.orthoImageData ? "hoverPointer AeroFarm" : "disableDiv"
                          className={"hoverPointer AeroFarm"}
                          style={{ fontSize: "9px", borderRadius: '10px', textAlign: 'center', color: "#3C3C3C", fontWeight: "500" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                              borderRadius: "10px",
                              width: !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) && !(this.state.DTMAvailable != NotSelected && this.state.DTMAvailable) && this.state.ThreeDAvailable === NotSelected ? "120px" :
                                !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable || this.state.ThreeDAvailable === NotSelected ? "150px" : "200px")
                            }}
                          >

                            {/* ORTHO */}
                            {this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable ?
                              <div
                                style={{
                                  width: "60px",
                                  borderRadius: "5px 0px 0px 5px",
                                  textAlign: "center",
                                  margin: 'auto',
                                  borderWidth: "1px 0.5px 1px 1px",
                                  borderStyle: "solid",
                                  borderColor: 'rgb(102, 102, 102, 0.3)',
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center"
                                }}
                                data-tip data-for='ortho'
                                onClick={() => {
                                  this.setState({
                                    showFloorPopUp: false,
                                    showFloors: false,
                                    previousRGBShow: false,
                                    previousNDVIShow: false,
                                    previousDEMShow: false,
                                    previousDTMShow: false,
                                    previousThreeDShow: false,
                                    previousPointCloudShow: false,
                                    previousBothShowPT: false,
                                  }, () => {

                                    if (this.state.orthoImageData) {
                                      this.toggleLayer("orthomosaic")
                                    }
                                  })
                                }}
                                className={this.state.RGBShow && !this.state.showFloors ? "toggle-layer-active-buttons" : "toggle-layer-inactive-buttons"}
                              >
                                <img width='17px' height="17px" style={{ opacity: this.state.orthoImageData ? 1 : 0.5, }} src={this.state.RGBShow && !this.state.showFloors ? RGBIcon : RGBInactiveIcon} />
                                <ReactTooltip border='true' borderColor="rgb(102, 102, 102, 0.3)" className="tooltipclass" offset={{ top: 0 }} id="ortho" place="top" type="light" effect="solid"><span style={{ fontSize: '14px', padding: '0px', margin: '0px', zIndex: '3', position: 'relative' }}>ORTHO</span></ReactTooltip>
                                {/* <div style={{ marginLeft: "5px" }}></div> */}
                              </div>
                              : <></>}



                            {/* PlantHealth */}
                            {this.state.OrthomosaicAvailable != NotSelected && this.state.OrthomosaicAvailable ?
                              <div
                                style={{
                                  width: "60px",
                                  textAlign: "center",
                                  margin: 'auto',
                                  borderWidth: !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable || this.state.DTMAvailable != NotSelected && this.state.DTMAvailable || this.state.ThreeDAvailable !== NotSelected && this.state.ThreeDAvailable) ? "1px 1px 1px 1px" : "1px 0px 1px 0px",
                                  borderStyle: "solid",
                                  borderColor: 'rgb(102, 102, 102, 0.3)',
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable || this.state.DTMAvailable != NotSelected && this.state.DTMAvailable || this.state.ThreeDAvailable !== NotSelected && this.state.ThreeDAvailable) ? "0px 0px 0px 0px" : "0px 0px 0px 0px"
                                }}
                                onClick={() => {
                                  this.setState({
                                    showFloorPopUp: false,
                                    showFloors: false,
                                    NDVIShow: true,
                                    previousRGBShow: false,
                                    previousNDVIShow: false,
                                    previousDEMShow: false,
                                    previousDTMShow: false,
                                    previousThreeDShow: false,
                                    previousPointCloudShow: false,
                                    previousBothShowPT: false,
                                  }, () => {
                                    if (this.state.orthoImageData) {
                                      this.toggleLayer("plantHealth")
                                    }
                                  })
                                }}
                                className={this.state.NDVIShow && !this.state.showFloors ? "toggle-layer-active-buttons" : "toggle-layer-inactive-buttons"}
                                data-tip data-for='ndvi'
                              >
                                <img width='17px' height="17px" style={{ opacity: this.state.orthoImageData ? 1 : 0.5, }} src={this.state.NDVIShow && !this.state.showFloors ? NDVIIcon : NDVIInactiveIcon} />
                                <ReactTooltip border='true' borderColor="rgb(102, 102, 102, 0.3)" className="tooltipclass" offset={{ top: 0 }} id="ndvi" place="top" type="light" effect="solid"><span style={{ fontSize: '14px', padding: '0px', margin: '0px', zIndex: '3', position: 'relative' }}>Plant Health</span></ReactTooltip>
                                {/* <div style={{ marginLeft: "5px" }}>{this.state.processTileIndex}</div> */}
                              </div> : <></>}



                            {/* DSM/DTM */}
                            {(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) || (this.state.DTMAvailable != NotSelected && this.state.DTMAvailable) ?
                              <div
                                style={{
                                  width: "60px",
                                  borderRadius: this.state.ThreeDAvailable === NotSelected ? this.state.OrthomosaicAvailable === NotSelected ? "5px 5px 5px 5px" : "0px 0px 0px 0px" : this.state.OrthomosaicAvailable === NotSelected ? "5px 0px 0px 5px" : "0px 0px 0px 0px",
                                  textAlign: "center",
                                  margin: 'auto',
                                  borderWidth: this.state.ThreeDAvailable === NotSelected ? "1px" : "1px 0.5px 1px 0.5px",
                                  borderStyle: "solid",
                                  borderColor: 'rgb(102, 102, 102, 0.3)',
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center"
                                }}
                                onClick={() => {
                                  this.setState({
                                    previousRGBShow: false,
                                    previousNDVIShow: false,
                                    previousDEMShow: false,
                                    previousDTMShow: false,
                                    previousThreeDShow: false,
                                    previousPointCloudShow: false,
                                    previousBothShowPT: false,
                                  })
                                  if (this.state.orthoImageData && this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) {
                                    this.setState({ DEMShowPopup: !(this.state.DEMShowPopup), showFloorPopUp: false, showFloors: false })
                                    this.toggleLayer(this.state.DEMType.toLowerCase())
                                  } else if (this.state.orthoImageData && this.state.DTMAvailable != NotSelected && this.state.DTMAvailable) {
                                    this.setState({ DEMShowPopup: !(this.state.DEMShowPopup), showFloorPopUp: false, showFloors: false })
                                    this.toggleLayer("dtm")
                                  }
                                  else {
                                    this.setState({ DEMShowPopup: !(this.state.DEMShowPopup), showFloorPopUp: false, showFloors: false })
                                    this.openDataNotAvailablePopup("DSM")
                                  }
                                }}
                                className={(this.state.DEMShow || this.state.DTMShow) && !this.state.showFloors ? "toggle-layer-active-buttons" : "toggle-layer-inactive-buttons"}
                                data-tip data-for='dsm'
                              >
                                <img width='17px' height="17px" style={{ opacity: this.state.orthoImageData ? 1 : 0.5, }} src={(this.state.DEMShow || this.state.DTMShow) && !this.state.showFloors ? DEMIcon : DEMIconInactive} />
                                {this.state.DEMShow || this.state.DTMShow ? <></> : <ReactTooltip border='true' borderColor="rgb(102, 102, 102, 0.3)" className="tooltipclass" offset={{ top: 0 }} id="dsm" place="top" type="light" effect="solid"><span style={{ fontSize: '14px', padding: '0px', margin: '0px', zIndex: '3', position: 'relative' }}>{this.state.DEMType}</span></ReactTooltip>}
                                {/* <div style={{ marginLeft: "5px" }}>{this.state.DEMType}</div> */}
                              </div> : <></>}



                            {/* 3D */}
                            {this.state.ThreeDAvailable !== NotSelected && this.state.ThreeDAvailable ?
                              <div
                                onClick={() => {
                                  this.setState({
                                    showFloorPopUp: false, showFloors: false,
                                    previousRGBShow: false,
                                    previousNDVIShow: false,
                                    previousDEMShow: false,
                                    previousDTMShow: false,
                                    previousThreeDShow: false,
                                    previousPointCloudShow: false,
                                    previousBothShowPT: false,
                                  }, () => {

                                    if (this.state.ThreeDAvailable) {
                                      this.managePopup(false, true)
                                      this.setState({ ThreeDShowPopup: !(this.state.ThreeDShowPopup), showFloorPopUp: false, showFloors: false })
                                      if (!(this.state.ThreeDShow || this.state.bothShowPT || this.state.pointCloudShow)) this.toggleLayer("pointCloud");
                                      this.setState({ showElevationProfile: false })
                                    } else {
                                      this.openDataNotAvailablePopup("3D data")
                                    }
                                  })
                                }}
                                style={{
                                  width: "60px",
                                  borderRadius: this.isAnyMapAvailable() ? "0px 0px 0px 0px" : "5px 0px 0px 5px",
                                  borderWidth: !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) ? "1px" : "1px 1px 1px 0px",
                                  borderStyle: "solid",
                                  borderColor: 'rgb(102, 102, 102, 0.3)',
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center"
                                }}
                                className={(this.state.ThreeDShow || this.state.pointCloudShow || this.state.bothShowPT) && !this.state.showFloors ? "toggle-layer-active-buttons" : "toggle-layer-inactive-buttons"}
                                data-tip='tooltip' data-for='3d'
                              >
                                <img width='17px' height="17px" src={(this.state.ThreeDShow || this.state.pointCloudShow || this.state.bothShowPT) && !this.state.showFloors ? ThreeDIcon : ThreeDInactiveIcon} />
                                {this.state.ThreeDShow || this.state.pointCloudShow || this.state.bothShowPT ? <></> : <ReactTooltip border='true' borderColor="rgb(102, 102, 102, 0.3)" className="tooltipclass" offset={{ top: 0 }} id="3d" place="top" type="light" effect="solid"><span style={{ fontSize: '14px', padding: '0px', margin: '0px', zIndex: '3', position: 'relative', }}>3D</span></ReactTooltip>}
                              </div>
                              : <></>}
                            {/* Floor layer */}

                            <div
                              onClick={() => {
                                this.setState({
                                  showFloorPopUp: !this.state.showFloorPopUp,
                                  DEMShowPopup: false,
                                  ThreeDShowPopup: false,
                                })
                              }}
                              style={{
                                width: "60px",
                                borderRadius: ((this.state.ThreeDAvailable !== NotSelected && this.state.ThreeDAvailable) || (this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) || (this.state.DTMAvailable != NotSelected && this.state.DTMAvailable) || (this.state.OrthomosaicAvailable != NotSelected && this.state.DTMAvailable)) ? "0px 5px 5px 0px" : "5px 5px 5px 5px", textAlign: "center", margin: 'auto',
                                borderWidth: !(this.state.DSMAvailable != NotSelected && this.state.DSMAvailable) ? "1px" : "1px 1px 1px 0px",
                                borderStyle: "solid",
                                borderColor: 'rgb(102, 102, 102, 0.3)',
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative"
                              }}
                              className={this.state.showFloors ? "toggle-layer-active-buttons" : "toggle-layer-inactive-buttons"}
                              data-tip='true' data-for='floors'
                            >
                              {/* floor popup */}
                              {this.state.showFloorPopUp ? <div
                                className={"hoverPointer AeroFarm"}
                                style={{ minWidth: "135px", maxWidth: "160px", fontSize: "9px", width: "max-content", borderRadius: '5px', backgroundColor: "white", fontWeight: "500", marginBottom: "10px", position: "absolute", bottom: "100%", overflow: "hidden" }}>
                                <div
                                  style={{
                                    fontSize: '14px', padding: "5px 10px", textAlign: "left", background: "#F0F0F0", color: "#3c3c3c",
                                    opacity: this.state.permissions?.[DRONENAKSHA_FEATURES.MAPS].EDIT ? "1" : "0.5",
                                    cursor: this.state.permissions?.[DRONENAKSHA_FEATURES.MAPS].EDIT ? "pointer" : "default"
                                  }} onClick={
                                    () => {
                                      if (this.state.permissions?.[DRONENAKSHA_FEATURES.MAPS].EDIT) {
                                        this.setState({ openFloorAdderPopUp: true, showFloorPopUp: false })
                                        if (this.state.activeSidepanel === this.state.activeSideBarFloor && this.state.sidebarPanel) {
                                          this.managePopup(false, true)
                                        }
                                      }
                                    }
                                  } >Add</div>
                                <hr style={{ margin: "0px" }} />
                                <div style={{ overflowY: "auto", maxHeight: "128px" }}>
                                  {this.state?.floors.map(floor => <>
                                    <div
                                      style={{
                                        width: "100%",
                                        wordWrap: "break-word",
                                        fontSize: '14px', padding: "5px 10px",
                                        textAlign: "left",
                                        color: this.state.activeSideBarFloor === `${floor.name} ${floor.number}` ? "#2989cf" : "#666666"
                                      }}
                                      onClick={() => {
                                        this.setState({
                                          previousRGBShow: this.state.RGBShow,
                                          previousNDVIShow: this.state.NDVIShow,
                                          previousDEMShow: this.state.DEMShow,
                                          previousDTMShow: this.state.DTMShow,
                                          previousThreeDShow: this.state.ThreeDShow,
                                          previousPointCloudShow: this.state.pointCloudShow,
                                          previousBothShowPT: this.state.bothShowPT,
                                          activeSideBarFloor: `${floor.name} ${floor.number}`,
                                          showFloorPopUp: false,
                                          selectedFloor: floor,
                                          showFloors: true,
                                          RGBShow: false,
                                          NDVIShow: false,
                                          DEMShow: false,
                                          DTMShow: false,
                                          //closing threed viewer when user open floor planning.
                                          ThreeDShow: false,
                                          pointCloudShow: false,
                                          bothShowPT: false,
                                        }, () => {
                                          this.toggleMeasurement("showPointer")
                                          if (!(this.state.compare)) { this.toggleSidepanelData(this.state.activeSideBarFloor) }
                                        })
                                      }
                                      } >{(floor?.name && floor?.number) ? `${floor?.name} ${floor?.number}` : "-"}
                                    </div>
                                    <hr style={{ margin: "0px" }} />
                                  </>
                                  )}
                                </div>

                              </div> : <></>}
                              <div style={{ width: '17px', height: "17px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <img style={{ width: "100%", height: "100%" }} src={this.state.showFloors ? FloorsActive : FloorsInactive} />
                              </div>

                              {this.state.showFloorPopUp ? <></> : <ReactTooltip border='true' borderColor="rgb(102, 102, 102, 0.3)" className="tooltipclass" offset={{ top: 0 }} id="floors" place="top" type="light" effect="solid"><span style={{ fontSize: '14px', padding: '0px', margin: '0px', zIndex: '3', position: 'relative', }}>Floors</span></ReactTooltip>}
                            </div>
                          </div>
                        </div>
                      }

                      {/* layer switching bar end */}
                    </div>
                  </div> : <></>
                }
                {this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.DETECTION).length > 0 && this.state.showTip && <div style={{ transition: "0.5s all", width: this.state.sidebarPanel ? "73vw" : "96vw", display: "flex", justifyContent: "center", alignItems: "center", position: "fixed", top: "46px" }}> <Tip
                  tipIcon={hideLayers}
                  text={`PicStork detection${this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.DETECTION).length <= 1 ? "" : "s"}
                ${this.state.assetsLayers.filter(asset => asset.image_type === AppConstants.ASSETS.DETECTION).length <= 1 ? "is" : "are"}
                 available in layers`}
                  btnText={"View"}
                  style={{ left: "", position: "" }}
                  closeTip={() => {
                    this.setState({ showTip: false })
                  }}
                  onView={() => {
                    this.setState({ showTip: false }, () => {
                      this.toggleMeasurement("showPointer")
                      if (this.state.activeSidepanel === activeSidebarLayers && this.state.sidebarPanel) {
                      } else {
                        if (!(this.state.compare)) { this.toggleSidepanelData(activeSidebarLayers) }
                      }
                    })

                  }}
                />
                </div>
                }
              </div>
            </div>
          </div >
        </div >
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projectName: state.project.projectName,
    clientName: state.project.clientName ? state.project.clientName : "asd",
    planName: state.project.planName,
    dateAndTime: state.project.dateAndTime,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addPlan: (payload) => dispatch(addPlan(payload)),
    addProjectDetails: (payload) => dispatch(addProjectDetails(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RMAssignDrone)